var _metadata, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFuturaCyrillicBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20190801 at Wed Dec 29 15:20:03 2021\n By www-data\nCopyright (c) 1995 ParaGraph Intl., (c) 1998 ParaType Inc., ParaType Ltd. All rights reserved.\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "FuturaCyrillicBold",
    horizAdvX: 500
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "FuturaCyrillicBold",
    fontWeight: 700,
    fontStretch: "normal",
    unitsPerEm: 1000,
    panose1: "2 11 9 2 2 2 4 2 2 3",
    ascent: 763,
    descent: -237,
    xHeight: 447,
    capHeight: 667,
    bbox: "-391 -260 1291 944",
    underlineThickness: 50,
    underlinePosition: -100,
    unicodeRange: "U+0020-FB02"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 233
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10017.var.accented",
    unicode: "\u0410`",
    horizAdvX: 710,
    d: "M518 0l-41 112h-242l-45 -112h-183l256 667h189l251 -667h-185zM283 244h148l-75 216zM408 929l101 -73l-154 -136l-74 55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10022.var.accented",
    unicode: "\u0415`",
    horizAdvX: 489,
    d: "M449 667v-147h-206v-111h195v-147h-195v-115h206v-147h-379v667h379zM297 929l101 -73l-154 -136l-74 55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10026.var.accented",
    unicode: "\u0418`",
    horizAdvX: 741,
    d: "M70 667h174v-420l250 420h177v-667h-174v420l-250 -420h-177v667zM423 929l101 -73l-154 -136l-74 55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10032.var.accented",
    unicode: "\u041E`",
    horizAdvX: 816,
    d: "M776 333q0 -148 -105 -249q-104 -99 -263 -99t-263 99q-105 101 -105 249q0 69 26.5 135t78.5 115q104 99 263 99t263 -99q52 -49 78.5 -115t26.5 -135zM408 514q-82 0 -135 -53q-53 -52 -53 -131q0 -73 53 -124q55 -53 135 -53q82 0 134 52q54 54 54 128q0 76 -54 128 q-56 53 -134 53zM462 929l101 -73l-154 -136l-74 55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10037.var.accented",
    unicode: "\u0423`",
    horizAdvX: 623,
    d: "M0 667h194l127 -297l111 297h185l-300 -667h-183l93 187zM364 929l101 -73l-154 -136l-74 55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10045.var.accented",
    unicode: "\u042B`",
    horizAdvX: 879,
    d: "M635 0v667h174v-667h-174zM70 0v667h174v-260h84q136 0 199 -62q53 -52 53 -141t-50 -140q-63 -64 -212 -64h-248zM244 134h67q55 0 75 20q18 18 18 50t-19 49q-21 20 -74 20h-67v-139zM492 929l101 -73l-154 -136l-74 55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10047.var.accented",
    unicode: "\u042D`",
    horizAdvX: 618,
    d: "M50 35v173q29 -29 67 -47q45 -22 106 -22q74 0 118 37t56 97h-254v134h248q-11 54 -51 87q-43 35 -117 35q-59 0 -106 -25q-40 -23 -67 -53v181q99 49 196 49q149 0 239 -94q93 -96 93 -251q0 -157 -100 -260q-88 -91 -238 -91q-61 0 -115 17q-32 10 -75 33zM312 929 l101 -73l-154 -136l-74 55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10048.var.accented",
    unicode: "\u042E`",
    horizAdvX: 1086,
    d: "M243 409h86q21 116 109 191q96 82 238 82q161 0 263 -98q50 -47 78.5 -112.5t28.5 -137.5q0 -71 -28.5 -137t-78.5 -114q-102 -98 -263 -98q-144 0 -240 86q-92 83 -107 204h-86v-275h-173v667h173v-258zM682 514q-78 0 -133 -55q-53 -53 -53 -126q0 -76 55 -128 q53 -52 130 -52q74 0 129 53q55 55 55 130q0 73 -55 126q-53 52 -128 52zM596 929l101 -73l-154 -136l-74 55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10049.var.accented",
    unicode: "\u042F`",
    horizAdvX: 618,
    d: "M14 0l186 251q-58 10 -99 52q-52 53 -52 140q0 99 55 157q63 67 187 67h257v-667h-174v227h-17l-143 -227h-200zM374 361v160h-49q-50 0 -75 -23q-23 -21 -23 -57t21 -57q24 -23 77 -23h49zM362 929l101 -73l-154 -136l-74 55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10023.var.accented",
    unicode: "\u0401`",
    horizAdvX: 489,
    d: "M449 667v-147h-206v-111h195v-147h-195v-115h206v-147h-379v667h379zM276 929l76 -57l-144 -136l-49 39zM30 829q0 29 20 48.5t48 19.5t48 -19.5t20 -48.5t-20 -48.5t-48 -19.5t-48 19.5t-20 48.5zM350 829q0 29 20 48.5t48 19.5t48 -19.5t20 -48.5t-20 -48.5t-48 -19.5 t-48 19.5t-20 48.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10065.var.accented",
    unicode: "\u0430`",
    horizAdvX: 616,
    d: "M401 404v43h160v-447h-160v49q-46 -64 -139 -64q-94 0 -161 71q-64 68 -64 164q0 110 69 179q63 63 161 63q82 0 134 -58zM303 326q-40 0 -70 -29q-32 -31 -32 -73q0 -44 31 -73q32 -30 72 -30q41 0 72 31q30 30 30 72q0 43 -31 73q-31 29 -72 29zM363 729l101 -73 l-154 -136l-74 55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10070.var.accented",
    unicode: "\u0435`",
    horizAdvX: 566,
    d: "M529 211v-17h-333q0 -47 28 -75q22 -22 66 -22q30 0 52 12q19 11 28 30h153q-15 -54 -54 -92q-64 -62 -182 -62q-117 0 -185 68q-66 66 -66 169q0 108 67 173t183 65q107 0 172 -61q71 -68 71 -188zM201 286h181q-7 29 -26 48q-24 24 -66 24q-41 0 -65 -24 q-20 -22 -24 -48zM339 729l101 -73l-154 -136l-74 55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10074.var.accented",
    unicode: "\u0438`",
    horizAdvX: 586,
    d: "M55 447h160v-230l177 230h139v-447h-160v236l-175 -236h-141v447zM347 729l101 -73l-154 -136l-74 55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10080.var.accented",
    unicode: "\u043E`",
    horizAdvX: 611,
    d: "M306 326q-41 0 -72 -29t-31 -73q0 -40 31 -71q30 -30 72 -30q41 0 71 30q31 29 31 71t-31 73q-31 29 -71 29zM574 224q0 -97 -69 -165q-75 -74 -200 -74q-124 0 -199 74q-69 68 -69 165t69 164q76 74 199 74q122 0 200 -74q69 -67 69 -164zM362 729l101 -73l-154 -136 l-74 55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10085.var.accented",
    unicode: "\u0443`",
    horizAdvX: 604,
    d: "M66 -229l150 290l-216 386h186l119 -229l116 229h183l-359 -676h-179zM357 729l101 -73l-154 -136l-74 55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10093.var.accented",
    unicode: "\u044B`",
    horizAdvX: 742,
    d: "M527 0v447h160v-447h-160zM215 298h109q78 0 120 -40q40 -39 40 -107q0 -69 -38 -107q-44 -44 -122 -44h-269v447h160v-149zM215 104h60q29 0 43 14q11 11 11 32q0 22 -12 32q-15 12 -44 12h-58v-90zM426 729l101 -73l-154 -136l-74 55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10095.var.accented",
    unicode: "\u044D`",
    horizAdvX: 476,
    d: "M46 15v134q49 -43 120 -43q49 0 77 17q29 17 38 51h-172v104h172q-13 34 -42 49q-28 15 -70 15q-39 0 -71 -14q-25 -10 -52 -35v132q66 36 150 36q112 0 177 -63q66 -64 66 -172q0 -115 -69 -180q-64 -61 -180 -61q-73 0 -144 30zM254 729l101 -73l-154 -136l-74 55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10096.var.accented",
    unicode: "\u044E`",
    horizAdvX: 814,
    d: "M509 326q-43 0 -72 -29q-31 -31 -31 -73q0 -41 31 -72q28 -29 72 -29q42 0 71 29q30 30 30 74q0 40 -28 71q-27 29 -73 29zM215 296h47q23 71 85 117q67 49 161 49q123 0 200 -74q69 -69 69 -162q0 -100 -69 -167q-74 -74 -205 -74q-123 0 -189 68q-44 46 -56 117h-43 v-170h-160v447h160v-151zM464 729l101 -73l-154 -136l-74 55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10097.var.accented",
    unicode: "\u044F`",
    horizAdvX: 522,
    d: "M28 0l124 156q-46 9 -78 39q-35 35 -35 96q0 67 40 109q44 47 152 47h236v-447h-160v142h-13l-98 -142h-168zM307 240v103h-48q-35 0 -50 -14q-14 -14 -14 -38q0 -25 15 -38q16 -13 47 -13h50zM316 729l101 -73l-154 -136l-74 55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10071.var.accented",
    unicode: "\u0451`",
    horizAdvX: 566,
    d: "M529 211v-17h-333q0 -47 28 -75q22 -22 66 -22q30 0 52 12q19 11 28 30h153q-15 -54 -54 -92q-64 -62 -182 -62q-117 0 -185 68q-66 66 -66 169q0 108 67 173t183 65q107 0 172 -61q71 -68 71 -188zM201 286h181q-7 29 -26 48q-24 24 -66 24q-41 0 -65 -24 q-20 -22 -24 -48zM294 729l75 -57l-142 -136l-48 39zM371 627q0 29 20.5 49.5t49.5 20.5t49.5 -20.5t20.5 -49.5t-20.5 -49.5t-49.5 -20.5t-49.5 20.5t-20.5 49.5zM39 627q0 29 20.5 49.5t49.5 20.5t49.5 -20.5t20.5 -49.5t-20.5 -49.5t-49.5 -20.5t-49.5 20.5t-20.5 49.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fi",
    unicode: "fi",
    horizAdvX: 584,
    d: "M339 316h-112v-316h-160v316h-56v131h56v55q0 116 61 175q64 63 176 63q51 0 100 -15.5t79 -44.5q56 -54 56 -150v-23h-160v15q0 40 -20 60t-56 20q-34 0 -55 -23q-21 -22 -21 -69v-63h112v-131zM379 447h160v-447h-160v447z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fl",
    unicode: "fl",
    horizAdvX: 594,
    d: "M339 316h-112v-316h-160v316h-56v131h56v59q0 111 61 171q65 63 174 63q116 0 181 -66q35 -36 45.5 -77t10.5 -97v-500h-160v504q0 54 -20 76t-55 22t-56 -23t-21 -69v-63h112v-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 233
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    horizAdvX: 333
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 233
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 341,
    d: "M253 227h-166v440h166v-440zM171 -19q-42 0 -73 31t-31 73t31 73t73 31t74 -32q29 -29 29 -72t-30 -73q-31 -31 -73 -31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 413,
    d: "M185 667l-25 -268h-95l-24 268h144zM372 667l-24 -268h-96l-24 268h144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 600,
    d: "M475 299h101l-17 -117h-102l-29 -182h-134l30 182h-85l-29 -182h-132l30 182h-102l18 117h101l14 83h-101l18 116h101l27 169h132l-28 -169h85l27 169h133l-27 -169h100l-18 -116h-100zM342 299l13 83h-85l-13 -83h85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    horizAdvX: 600,
    d: "M267 775h100v-110q73 -4 151 -51l-66 -128q-56 43 -112 43q-41 0 -60 -18q-15 -13 -15 -33q0 -19 14 -33q17 -15 46 -25l52 -18q78 -26 116 -63q50 -49 50 -122q0 -92 -56 -151q-45 -46 -120 -65v-113h-100v108q-57 1 -113 24q-53 22 -97 57l72 134q36 -35 69 -51 q48 -23 91 -23q42 0 65 23q18 18 18 42q0 23 -20 38q-14 10 -45 20l-59 20q-77 26 -110 62q-43 44 -43 116q0 86 50 141q47 52 122 66v110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 895,
    d: "M214 347q-88 0 -139 53q-42 45 -42 108q0 69 41 113q47 53 140 53q91 0 142 -53q42 -44 42 -110t-43 -111q-51 -53 -141 -53zM211 0l386 667h87l-387 -667h-86zM216 586q-34 0 -55 -23q-20 -22 -20 -52q0 -34 26 -57q20 -18 49 -18q30 0 53 21q22 22 22 54q0 33 -24 56 q-20 19 -51 19zM680 231q-34 0 -55 -23q-20 -22 -20 -52q0 -34 26 -57q20 -18 49 -18q30 0 53 21q22 22 22 54q0 34 -24 56q-20 19 -51 19zM678 -8q-88 0 -139 53q-42 45 -42 108q0 69 41 113q47 53 140 53q91 0 142 -53q42 -44 42 -110t-43 -111q-51 -53 -141 -53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 756,
    d: "M600 350l98 -95q-40 -51 -91 -97l149 -158h-216l-58 61q-104 -76 -224 -76q-107 0 -164 56q-54 52 -54 132q0 78 50 128q40 41 109 65q-22 26 -39 53q-23 38 -23 82q0 69 51 122q58 59 157 59q98 0 155 -55q53 -52 53 -125q0 -61 -46 -107q-34 -34 -78 -52l84 -88 q48 44 87 95zM387 166l-105 113q-63 -36 -63 -78q0 -28 20 -45q21 -19 57 -19q45 0 91 29zM301 509q0 -19 18 -45q13 -18 35 -40q21 11 40 30q21 24 21 49q0 30 -18 46q-17 15 -40 15t-38 -14q-18 -16 -18 -41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 225,
    d: "M185 667l-25 -268h-95l-24 268h144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 354,
    d: "M307 -128l-113 -60q-62 90 -98 224q-29 112 -29 234q0 140 37 262q30 98 90 197l113 -60q-51 -93 -74 -181q-28 -105 -28 -213q0 -102 24 -207q23 -101 78 -196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 354,
    d: "M160 -188l-113 60q55 95 78 196q24 105 24 207q0 108 -28 213q-23 88 -74 181l113 60q60 -99 90 -197q37 -121 37 -263q0 -121 -29 -233q-36 -134 -98 -224z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 647,
    d: "M175 661l103 -44l-10 112h110l-10 -112l104 44l34 -103l-110 -26l74 -85l-88 -64l-59 95l-58 -95l-88 64l74 84l-110 26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    d: "M33 280v120h152v153h130v-153h152v-120h-152v-153h-130v153h-152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 416,
    d: "M-9 -149l125 316h150l-172 -316h-103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 353,
    d: "M50 202v133h253v-133h-253z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 303,
    d: "M152 -19q-42 0 -73 31t-31 73t31 73t73 31t74 -32q29 -29 29 -72t-30 -73q-31 -31 -73 -31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 672,
    d: "M-30 -188l511 917h131l-512 -917h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 600,
    d: "M300 527q-30 0 -53 -21q-26 -22 -42 -73.5t-16 -100.5q0 -45 15.5 -97.5t42.5 -76.5q23 -21 53 -21t53 21q26 23 42 74.5t16 98.5t-16.5 100t-41.5 75q-23 21 -53 21zM583 333q0 -175 -99 -272q-77 -76 -184 -76t-184 76q-99 97 -99 272q0 176 99 273q77 76 184 76 t184 -76q99 -97 99 -273z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 600,
    d: "M234 0v520h-95v147h268v-667h-173z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 600,
    d: "M561 147v-147h-535l169 177q91 95 137 169q36 56 36 104q0 42 -20 64q-18 20 -49 20q-37 0 -58 -27q-22 -28 -24 -82h-179q1 112 74 185q72 72 189 72q119 0 188 -69q65 -65 65 -164q0 -106 -99 -198l-112 -104h218z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 600,
    d: "M28 228h177q2 -42 27 -67q24 -26 68 -26q41 0 68 29q20 23 20 55q0 37 -26 59q-23 19 -64 19q-17 0 -29 -4v117q44 -6 71 17q22 19 22 47q0 30 -18 48t-49 18t-48 -17q-23 -21 -23 -59h-161q5 93 65 153q62 65 176 65q106 0 166 -59q54 -54 54 -129q0 -46 -20 -82 q-19 -35 -51 -51q49 -18 79 -61q28 -41 28 -98q0 -87 -59 -146q-71 -71 -199 -71q-117 0 -191 69q-73 67 -83 174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 600,
    d: "M494 667v-408h81v-133h-81v-126h-160v126h-323v111l257 430h226zM177 259h157v272z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 600,
    d: "M495 667v-147h-231l-12 -74q31 5 54 5q112 0 176 -66q61 -61 61 -158q0 -101 -64 -167q-73 -75 -208 -75q-130 0 -225 60l26 162q38 -35 80 -54q49 -23 100 -23q56 0 87 33q26 28 26 68q0 44 -32 72q-37 33 -120 33q-67 0 -123 -28l58 359h347z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    horizAdvX: 600,
    d: "M267 667h197l-190 -227q47 21 93 21q87 0 151 -64q63 -63 63 -159q0 -105 -69 -174q-79 -79 -213 -79q-140 0 -219 81q-61 63 -61 156q0 118 99 249zM296 122q46 0 77 31t31 76q0 40 -31 70q-32 31 -77 31q-43 0 -75 -29q-33 -30 -33 -69q0 -45 29 -76q33 -34 79 -34z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 600,
    d: "M58 0l304 520h-278v147h547l-382 -667h-191z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 600,
    d: "M418 351q50 -15 86 -51q51 -50 51 -118q0 -72 -54 -126q-71 -71 -202 -71q-129 0 -199 70q-55 55 -55 127q0 32 14 65.5t35 54.5q33 33 84 49q-36 14 -60 38q-45 45 -45 106q0 74 55 126q66 61 178 61q110 0 172 -64q49 -49 49 -122q0 -63 -41 -104q-27 -27 -68 -41z M302 566q-34 0 -55 -23q-20 -22 -20 -51q0 -25 21 -48q21 -22 53 -22q29 0 49 20q23 23 23 51q0 32 -23 53q-22 20 -48 20zM300 281q-31 0 -56 -23q-24 -24 -24 -55q0 -33 23 -56q24 -24 57 -24t56 23q24 24 24 57t-24 55q-24 23 -56 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 600,
    d: "M333 0h-196l189 225q-39 -21 -89 -21q-91 0 -153 61q-67 66 -67 161q0 102 67 172q82 84 219 84q135 0 214 -79q66 -68 66 -165q0 -114 -101 -245zM305 545q-45 0 -77 -32q-33 -33 -33 -76q0 -42 32 -72t78 -30q44 0 75 28q35 31 35 76q0 42 -32 74q-34 32 -78 32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 303,
    d: "M152 254q-42 0 -73 31t-31 73t31 73t73 31t74 -32q29 -29 29 -72t-30 -73q-31 -31 -73 -31zM152 -15q-42 0 -73 31t-31 73t31 73t73 31t74 -32q29 -29 29 -72t-30 -73q-31 -31 -73 -31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 393,
    d: "M-9 -149l125 316h150l-172 -316h-103zM185 254q-42 0 -73 31t-31 73t31 73t73 31t74 -32q29 -29 29 -72t-30 -73q-31 -31 -73 -31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    d: "M33 389l434 220v-128l-297 -147l297 -148v-128l-434 222v109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    d: "M33 370v113h434v-113h-434zM33 197v113h434v-113h-434z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    d: "M467 279l-434 -221v129l297 147l-297 147v128l434 -221v-109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 547,
    d: "M347 231h-163v162q18 -5 34 -5q61 0 94 33q23 23 23 55q0 30 -17 47q-17 19 -48 19q-28 0 -43 -17q-18 -18 -18 -50h-176q4 86 60 142q65 65 174 65q108 0 177 -65q63 -59 63 -143q0 -72 -48 -126q-44 -49 -112 -64v-53zM270 -15q-42 0 -73 31t-31 73t31 73t72 31 q43 0 75 -32q29 -29 29 -72t-30 -73q-31 -31 -73 -31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 733,
    d: "M465 454l7 38l89 -1l-37 -189q-6 -28 -6 -40q0 -35 22 -35q15 0 30 13q22 19 37 61.5t15 82.5q0 43 -17 84t-44 67q-30 29 -77 46t-95 17q-112 0 -190 -78q-79 -79 -79 -194q0 -122 83 -197q68 -61 187 -61q88 0 180 30l20 -80q-97 -30 -203 -30q-152 0 -248 89 q-50 46 -78 112t-28 138q0 74 28.5 139.5t74.5 110.5q50 48 117.5 74.5t131.5 26.5q67 0 130.5 -24.5t108.5 -72.5q76 -81 76 -197q0 -111 -71 -185q-44 -45 -93 -45q-23 0 -46 13.5t-32 40.5q-45 -63 -124 -63q-54 0 -91 36q-50 48 -50 121q0 81 55 143q53 57 120 57 q63 0 97 -48zM380 409q-29 0 -53 -24q-32 -30 -32 -79q0 -32 20 -53q17 -17 43 -17q29 0 53 24q32 34 32 80q0 32 -21 53q-18 16 -42 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 710,
    d: "M518 0l-41 112h-242l-45 -112h-183l256 667h189l251 -667h-185zM283 244h148l-75 216z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 618,
    d: "M348 0h-278v667h258q99 0 146 -52q41 -45 41 -125q0 -44 -19 -82q-20 -37 -54 -52q56 -6 91 -40q45 -43 45 -122q0 -82 -49 -131q-61 -63 -181 -63zM243 534v-130h32q46 0 66 21q16 16 16 44q0 27 -16 45q-20 20 -66 20h-32zM243 275v-140h39q84 0 107 27q14 16 14 43 q0 31 -17 48q-22 22 -107 22h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 589,
    d: "M549 223v-205q-91 -33 -150 -33q-156 0 -258 100q-48 48 -74.5 112.5t-26.5 130.5q0 69 27.5 134t73.5 112q102 104 252 104q72 0 156 -34v-207q-59 73 -151 73q-71 0 -120 -44q-58 -54 -58 -137q0 -79 54 -130q49 -46 124 -46q87 0 151 70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 695,
    d: "M312 0h-242v667h227q170 0 265 -92q93 -89 93 -243q0 -144 -87 -231q-44 -44 -110 -72.5t-146 -28.5zM243 520v-373h35q97 0 146 48q51 49 51 137q0 97 -52 146q-45 42 -138 42h-42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 489,
    d: "M449 667v-147h-206v-111h195v-147h-195v-115h206v-147h-379v667h379z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 485,
    d: "M452 667v-147h-209v-111h190v-147h-190v-262h-173v667h382z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 774,
    d: "M390 243v135h344q0 -103 -24.5 -174.5t-82.5 -125.5q-90 -84 -235 -84q-159 0 -256 99q-96 96 -96 241q0 152 100 250q98 98 259 98q106 0 180 -45q78 -48 119 -137l-165 -68q-16 40 -48 67q-40 33 -93 33q-68 0 -114 -46q-58 -58 -58 -153q0 -88 53 -144q48 -51 122 -51 q59 0 96 31q33 27 41 74h-142z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 737,
    d: "M243 667v-249h250v249h174v-667h-174v270h-250v-270h-173v667h173z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 313,
    d: "M70 667h173v-667h-173v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 468,
    d: "M225 667h173v-459q0 -54 -10.5 -89t-46.5 -71q-63 -63 -163 -63q-59 0 -105 30q-38 25 -66 68l113 116q4 -36 24 -53q15 -12 33 -12q17 0 30 11q18 17 18 67v455z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 700,
    d: "M243 667v-275l212 275h214l-265 -316l289 -351h-224l-226 289v-289h-173v667h173z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 470,
    d: "M70 667h173v-520h208v-147h-381v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 915,
    d: "M212 0h-172l113 667h171l135 -356l143 356h173l100 -667h-173l-49 384l-161 -384h-69l-154 384z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 805,
    d: "M243 0h-173v667h173l319 -408v408h173v-667h-173l-319 408v-408z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 816,
    d: "M776 333q0 -148 -105 -249q-104 -99 -263 -99t-263 99q-105 101 -105 249q0 69 26.5 135t78.5 115q104 99 263 99t263 -99q52 -49 78.5 -115t26.5 -135zM408 514q-82 0 -135 -53q-53 -52 -53 -131q0 -73 53 -124q55 -53 135 -53q82 0 134 52q54 54 54 128q0 76 -54 128 q-56 53 -134 53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 599,
    d: "M352 221h-109v-221h-173v667h276q107 0 169 -60t62 -162q0 -108 -59 -166t-166 -58zM243 527v-166h58q50 0 73 21q22 19 22 61q0 40 -20 60q-23 24 -74 24h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 816,
    d: "M687 106l115 -118l-159 -24l-56 64q-79 -43 -175 -43q-176 0 -278 110q-94 100 -94 241q0 70 27.5 134.5t75.5 110.5q104 101 264 101q74 0 144 -25.5t121 -74.5q103 -99 103 -251q0 -71 -27 -134q-22 -53 -61 -91zM354 266l163 21l46 -50q31 44 31 98q0 31 -14.5 65 t-39.5 59q-26 26 -62.5 40.5t-70.5 14.5q-79 0 -132 -55q-54 -56 -54 -134q0 -73 50 -121q53 -51 135 -51q26 0 54 7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 627,
    d: "M70 667h270q106 0 163 -59q57 -58 57 -150q0 -88 -53 -139q-37 -35 -92 -46l209 -273h-215l-166 256v-256h-173v667zM243 533v-165h33q56 0 84 27q22 22 22 56q0 35 -23 56q-26 26 -83 26h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 571,
    d: "M40 60l74 140q72 -68 153 -68q46 0 67 23q17 17 17 42q0 24 -19 40q-16 14 -86 35l-45 14q-67 21 -96 54q-38 41 -38 118q0 100 61 161q63 63 171 63q103 0 206 -54l-69 -135q-57 45 -114 45q-36 0 -57 -20q-17 -17 -17 -36q0 -18 9 -30q14 -17 58 -30l53 -16 q84 -26 121 -66q43 -46 43 -119q0 -105 -63 -168q-68 -68 -197 -68q-71 0 -131 22q-51 18 -101 53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 471,
    d: "M464 520h-142v-520h-173v520h-142v147h457v-147z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 721,
    d: "M70 667h173v-395q0 -70 34 -103q34 -32 82 -32t80 29q18 16 27.5 40.5t10.5 39t1 41.5v380h173v-383q0 -44 -3 -72.5t-20.5 -69t-51.5 -74.5q-82 -83 -220 -83q-146 0 -221 80q-65 71 -65 219v383z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 699,
    d: "M0 667h189l160 -406l162 406h188l-284 -667h-135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 1014,
    d: "M0 667h181l116 -431l141 431h138l131 -431l126 431h181l-213 -667h-177l-121 386l-128 -386h-176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 711,
    d: "M0 0l261 356l-214 311h214l99 -173l103 173h213l-217 -311l252 -356h-210l-142 217l-150 -217h-209z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 640,
    d: "M229 0v320l-241 347h207l126 -182l121 182h210l-249 -347v-320h-174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 631,
    d: "M618 667l-314 -520h280v-147h-571l316 520h-262v147h551z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 337,
    d: "M297 636h-90v-730h90v-94h-217v917h217v-93z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 672,
    d: "M702 -188h-130l-512 917h131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 337,
    d: "M130 636h-90v93h217v-917h-217v94h90v730z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    d: "M250 563l-110 -233h-135l160 337h170l161 -337h-136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    d: "M0 -178v132h500v-132h-500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    d: "M250 520l-154 136l102 73l126 -154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 616,
    d: "M401 404v43h160v-447h-160v49q-46 -64 -139 -64q-94 0 -161 71q-64 68 -64 164q0 110 69 179q63 63 161 63q82 0 134 -58zM303 326q-40 0 -70 -29q-32 -31 -32 -73q0 -44 31 -73q32 -30 72 -30q41 0 72 31q30 30 30 72q0 43 -31 73q-31 29 -72 29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 616,
    d: "M55 729h160v-325q54 58 133 58q95 0 158 -60q73 -69 73 -177t-72 -178q-64 -62 -157 -62q-85 0 -135 64v-49h-160v729zM313 121q41 0 71 30q31 31 31 70q0 45 -31 76q-29 29 -71 29q-45 0 -73 -30q-30 -32 -30 -72q0 -45 34 -76q31 -27 69 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 429,
    d: "M393 144v-134q-51 -25 -111 -25q-106 0 -176 68q-69 67 -69 167q0 103 72 173q71 68 180 68q54 0 104 -25v-134q-41 29 -83 29q-47 0 -78 -31t-31 -77q0 -44 28 -75q32 -34 82 -34q47 0 82 30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    horizAdvX: 616,
    d: "M561 729v-729h-160v49q-50 -64 -135 -64q-93 0 -157 62q-72 70 -72 178t73 177q63 60 158 60q79 0 133 -58v325h160zM303 121q38 0 69 27q34 31 34 76q0 40 -30 72q-28 30 -73 30q-42 0 -71 -29q-31 -31 -31 -76q0 -39 31 -70q30 -30 71 -30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 566,
    d: "M529 211v-17h-333q0 -47 28 -75q22 -22 66 -22q30 0 52 12q19 11 28 30h153q-15 -54 -54 -92q-64 -62 -182 -62q-117 0 -185 68q-66 66 -66 169q0 108 67 173t183 65q107 0 172 -61q71 -68 71 -188zM201 286h181q-7 29 -26 48q-24 24 -66 24q-41 0 -65 -24 q-20 -22 -24 -48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 345,
    d: "M339 316h-112v-316h-160v316h-56v131h56v75q0 92 41 147q53 71 155 71q39 0 77 -15v-138q-25 15 -50 15q-30 0 -45 -17q-18 -20 -18 -75v-63h112v-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 613,
    d: "M398 447h160v-419q0 -60 -11.5 -103t-49.5 -82q-71 -72 -197 -72q-131 0 -209 79q-41 43 -49 93h178q15 -46 75 -46q45 0 71 25q32 30 32 83v45q-56 -59 -134 -59q-104 0 -165 63q-62 64 -62 163q0 106 66 175q65 68 162 68q81 0 133 -59v46zM303 327q-41 0 -71 -30 q-31 -32 -31 -72q0 -42 31 -73q29 -29 72 -29q42 0 72 30t30 72q0 41 -32 73q-29 29 -71 29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 585,
    d: "M55 0v729h160v-338q22 28 50 44q38 22 92 22q84 0 132 -48q27 -27 34.5 -55.5t7.5 -69.5v-284h-160v226q0 65 -20 87q-17 19 -51 19q-37 0 -58 -19q-27 -25 -27 -73v-240h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 269,
    d: "M55 447h160v-447h-160v447zM45 633q0 37 26.5 63.5t63.5 26.5t63.5 -26.5t26.5 -63.5t-26.5 -63.5t-63.5 -26.5t-63.5 26.5t-26.5 63.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 269,
    d: "M55 447h160v-676h-160v676zM45 633q0 37 26.5 63.5t63.5 26.5t63.5 -26.5t26.5 -63.5t-26.5 -63.5t-63.5 -26.5t-63.5 26.5t-26.5 63.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 601,
    d: "M55 729h160v-443l151 161h217l-211 -206l228 -241h-222l-163 183v-183h-160v729z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 269,
    d: "M55 729h160v-729h-160v729z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 873,
    d: "M55 0v447h160v-54q51 62 134 62q49 0 86 -20q40 -21 62 -64q23 41 61 62q39 22 93 22q82 0 124 -41t42 -123v-291h-160v221q0 74 -23 96q-17 15 -42 15q-28 0 -47 -18q-29 -28 -29 -85v-229h-160v221q0 74 -21 96q-17 18 -48 18q-28 0 -44 -16q-28 -27 -28 -98v-221h-160 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 585,
    d: "M55 0v447h160v-56q50 66 142 66q84 0 132 -48q26 -26 34 -54t8 -71v-284h-160v226q0 66 -20 87q-18 19 -51 19q-36 0 -59 -21q-26 -24 -26 -71v-240h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 611,
    d: "M306 326q-41 0 -72 -29t-31 -73q0 -40 31 -71q30 -30 72 -30q41 0 71 30q31 29 31 71t-31 73q-31 29 -71 29zM574 224q0 -97 -69 -165q-75 -74 -200 -74q-124 0 -199 74q-69 68 -69 165t69 164q76 74 199 74q122 0 200 -74q69 -67 69 -164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 616,
    d: "M215 43v-272h-160v676h160v-49q51 64 137 64q94 0 159 -65q68 -68 68 -173q0 -107 -72 -177q-63 -62 -153 -62q-83 0 -139 58zM313 326q-42 0 -72 -30q-31 -31 -31 -74q0 -40 31 -71q30 -30 72 -30q43 0 71 30q31 31 31 71q0 43 -31 74q-28 30 -71 30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    horizAdvX: 616,
    d: "M401 -229v272q-56 -58 -139 -58q-90 0 -153 62q-72 72 -72 177t68 173q65 65 159 65q87 0 137 -64v49h160v-676h-160zM303 326q-43 0 -71 -30q-31 -31 -31 -74q0 -40 31 -71q28 -30 71 -30q42 0 72 30q31 31 31 71q0 43 -31 74q-30 30 -72 30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 409,
    d: "M55 0v447h160v-73q22 42 63 62q33 18 83 18q2 0 5 -0.5t10.5 -1t16.5 -0.5v-151q-32 16 -69 16q-47 0 -73 -24q-36 -33 -36 -102v-191h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 444,
    d: "M27 37l57 111q30 -22 64 -33q31 -11 62 -11q28 0 41 12q8 8 8 21t-8 20q-8 8 -42 16l-42 10q-53 12 -78 39q-29 31 -29 77q0 65 42 109q52 54 160 54q74 0 143 -29l-54 -102q-48 22 -84 22q-22 0 -37 -9q-14 -8 -14 -22q0 -17 19 -25q8 -3 25 -6.5t28 -6.5l29 -8 q43 -12 66 -35q34 -32 34 -89q0 -68 -45 -111q-56 -56 -165 -56q-95 0 -180 52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 328,
    d: "M323 316h-91v-316h-160v316h-51v131h51v147h160v-147h91v-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 590,
    d: "M55 447h160v-250q0 -43 24 -65q19 -17 56 -17t57 19q23 23 23 63v250h160v-279q0 -76 -43 -120q-61 -63 -193 -63q-142 0 -202 64q-42 44 -42 119v279z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 573,
    d: "M0 447h179l107 -229l109 229h178l-233 -447h-109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 899,
    d: "M0 447h179l106 -236l113 236h98l113 -243l112 243h178l-234 -447h-108l-112 246l-107 -246h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 652,
    d: "M0 0l223 243l-181 204h208l77 -92l79 92h207l-185 -204l224 -243h-212l-114 133l-114 -133h-212z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 604,
    d: "M66 -229l150 290l-216 386h186l119 -229l116 229h183l-359 -676h-179z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 517,
    d: "M497 447l-209 -316h187v-131h-455l211 316h-180v131h446z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    d: "M304 555v-157q0 -52 -12 -76q-15 -30 -48 -50q33 -20 48 -50q12 -24 12 -76v-160q0 -32 14 -44.5t65 -12.5h20v-114h-19q-12 0 -36 -1.5t-36 -1.5q-39 0 -66.5 11t-41 24.5t-21 36.5t-8.5 37t-1 36v197q0 60 -55 68v110q55 7 55 68v184q0 22 1 36t8.5 37t21 36.5t41 24.5 t66.5 11q12 0 36 -1.5t36 -1.5h19v-114h-20q-51 0 -65 -12.5t-14 -44.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    d: "M185 -250v1000h130v-1000h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    d: "M218 398v157q0 32 -14 44.5t-65 12.5h-20v114h19q12 0 36 1.5t36 1.5q32 0 57 -6.5t39 -20t23.5 -26.5t13 -32t4.5 -31t1 -29v-184q0 -61 55 -68v-110q-55 -8 -55 -68v-197q0 -17 -1 -29t-4.5 -31t-13 -32t-23.5 -26.5t-39 -20t-57 -6.5q-12 0 -36 1.5t-36 1.5h-19v114 h20q51 0 65 12.5t14 44.5v160q0 52 12 76q15 30 48 50q-33 20 -48 50q-12 24 -12 76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    d: "M257 225l-35 12q-54 19 -73 19q-25 0 -43 -17q-16 -15 -29 -44l-71 47l8 17q32 67 53 87q35 35 88 35q33 0 92 -21l36 -13q39 -15 64 -15q28 0 46 15q16 14 27 36l74 -43l-5 -11q-21 -48 -53 -82q-40 -41 -95 -41q-24 0 -84 19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10023",
    unicode: "\u0401",
    horizAdvX: 489,
    d: "M449 667v-147h-206v-111h195v-147h-195v-115h206v-147h-379v667h379zM284 797q0 33 23.5 56.5t56.5 23.5t56.5 -23.5t23.5 -56.5t-23.5 -56.5t-56.5 -23.5t-56.5 23.5t-23.5 56.5zM76 797q0 33 23.5 56.5t56.5 23.5t56.5 -23.5t23.5 -56.5t-23.5 -56.5t-56.5 -23.5 t-56.5 23.5t-23.5 56.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10051",
    unicode: "\u0402",
    horizAdvX: 734,
    d: "M160 0v520h-150v147h537v-147h-213v-132q65 23 127 23q85 0 138 -30q93 -52 93 -178q0 -119 -81 -172q-57 -37 -156 -37q-21 0 -57 6v132q21 -6 44 -6q30 0 48 14q22 17 22 58q0 42 -33 59q-19 10 -55 10q-44 0 -90 -23v-244h-174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10052",
    unicode: "\u0403",
    horizAdvX: 493,
    d: "M460 667v-147h-217v-520h-173v667h390zM313 929l101 -73l-154 -136l-74 55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10053",
    unicode: "\u0404",
    horizAdvX: 618,
    d: "M568 208v-173q-43 -23 -75 -33q-54 -17 -116 -17q-147 0 -237 91q-100 102 -100 258q0 157 93 253q90 94 239 94q97 0 196 -49v-181q-27 30 -67 53q-47 25 -106 25q-74 0 -117 -35q-40 -33 -51 -87h248v-134h-253q12 -60 55 -97q45 -37 118 -37q61 0 106 22q38 18 67 47z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10054",
    unicode: "\u0405",
    horizAdvX: 571,
    d: "M40 60l74 140q72 -68 153 -68q46 0 67 23q17 17 17 42q0 24 -19 40q-16 14 -86 35l-45 14q-67 21 -96 54q-38 41 -38 118q0 100 61 161q63 63 171 63q103 0 206 -54l-69 -135q-57 45 -114 45q-36 0 -57 -20q-17 -17 -17 -36q0 -18 9 -30q14 -17 58 -30l53 -16 q84 -26 121 -66q43 -46 43 -119q0 -105 -63 -168q-68 -68 -197 -68q-71 0 -131 22q-51 18 -101 53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10055",
    unicode: "\u0406",
    horizAdvX: 313,
    d: "M70 667h173v-667h-173v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10056",
    unicode: "\u0407",
    horizAdvX: 356,
    d: "M91 667h173v-667h-173v667zM267 897q27 0 46 -16q29 -25 29 -65t-29 -65q-19 -16 -46 -16t-46 16q-29 25 -29 65t29 65q19 16 46 16zM89 897q27 0 46 -16q29 -25 29 -65t-29 -65q-19 -16 -46 -16t-46 16q-29 25 -29 65t29 65q19 16 46 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10057",
    unicode: "\u0408",
    horizAdvX: 468,
    d: "M225 667h173v-459q0 -54 -10.5 -89t-46.5 -71q-63 -63 -163 -63q-59 0 -105 30q-38 25 -66 68l113 116q4 -36 24 -53q15 -12 33 -12q17 0 30 11q18 17 18 67v455z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10058",
    unicode: "\u0409",
    horizAdvX: 1020,
    d: "M718 0h-248v521h-163v-243q0 -160 -70 -230q-59 -57 -156 -57q-40 0 -79 9v160q21 -7 40 -7q36 0 58 20q35 32 35 126v368h509v-260h84q136 0 199 -62q53 -53 53 -141q0 -89 -51 -140q-64 -64 -211 -64zM644 134h67q55 0 75 20q18 18 18 50t-19 49q-21 20 -74 20h-67 v-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10059",
    unicode: "\u040A",
    horizAdvX: 1030,
    d: "M654 418h84q136 0 199 -62q53 -52 53 -145q0 -95 -51 -147q-63 -64 -211 -64h-248v270h-237v-270h-173v667h173v-249h237v249h174v-249zM654 134h67q55 0 75 20q18 18 18 59q0 34 -19 51q-21 20 -74 20h-67v-150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10060",
    unicode: "\u040B",
    horizAdvX: 770,
    d: "M160 0v520h-150v147h537v-147h-213v-117q64 13 143 13q144 0 202 -56q23 -22 34.5 -53.5t13 -49.5t1.5 -48v-209h-174v168q0 55 -20 77q-25 27 -99 27q-44 0 -101 -9v-263h-174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10061",
    unicode: "\u040C",
    horizAdvX: 694,
    d: "M243 667v-275l212 275h214l-265 -316l289 -351h-224l-226 289v-289h-173v667h173zM393 929l101 -73l-154 -136l-74 55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10062",
    unicode: "\u040E",
    horizAdvX: 623,
    d: "M0 667h194l127 -297l111 297h185l-300 -667h-183l93 187zM413 895l116 -44q-24 -66 -82 -97q-47 -26 -128 -26q-78 0 -126 26q-58 31 -82 97l116 44q10 -31 32 -47t61 -16q38 0 61 16q22 16 32 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10145",
    unicode: "\u040F",
    horizAdvX: 718,
    d: "M70 0v667h174v-521h230v521h174v-667h-211v-166h-156v166h-211z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10017",
    unicode: "\u0410",
    horizAdvX: 710,
    d: "M518 0l-41 112h-242l-45 -112h-183l256 667h189l251 -667h-185zM283 244h148l-75 216z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10018",
    unicode: "\u0411",
    horizAdvX: 614,
    d: "M70 0v667h434v-147h-260v-115h68q148 0 211 -65q51 -54 51 -138q0 -87 -55 -142q-61 -60 -213 -60h-236zM244 135h60q55 0 77 23q17 19 17 47q0 32 -20 50q-21 18 -74 18h-60v-138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10019",
    unicode: "\u0412",
    horizAdvX: 618,
    d: "M348 0h-278v667h258q99 0 146 -52q41 -45 41 -125q0 -44 -19 -82q-20 -37 -54 -52q56 -6 91 -40q45 -43 45 -122q0 -82 -49 -131q-61 -63 -181 -63zM243 534v-130h32q46 0 66 21q16 16 16 44q0 27 -16 45q-20 20 -66 20h-32zM243 275v-140h39q84 0 107 27q14 16 14 43 q0 31 -17 48q-22 22 -107 22h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10020",
    unicode: "\u0413",
    horizAdvX: 493,
    d: "M460 667v-147h-217v-520h-173v667h390z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10021",
    unicode: "\u0414",
    horizAdvX: 743,
    d: "M139 667h504v-533h80v-284h-156v150h-406v-150h-156v284q44 7 76 40q35 36 46.5 87.5t11.5 131.5v274zM307 533v-157q0 -83 -16 -140q-17 -60 -58 -102h236v399h-162z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10022",
    unicode: "\u0415",
    horizAdvX: 489,
    d: "M449 667v-147h-206v-111h195v-147h-195v-115h206v-147h-379v667h379z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10024",
    unicode: "\u0416",
    horizAdvX: 970,
    d: "M399 0v293l-180 -293h-218l243 340l-223 327h200l178 -290v290h172v-290l178 290h200l-223 -327l243 -340h-218l-180 293v-293h-172z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10025",
    unicode: "\u0417",
    horizAdvX: 597,
    d: "M131 483l-67 127q39 27 92 47q68 25 141 25q117 0 179 -60q50 -47 50 -126q0 -55 -29 -96q-24 -35 -62 -53v-3q44 -14 74 -42q48 -46 48 -112q0 -102 -83 -159q-66 -46 -188 -46q-91 0 -161 29q-60 25 -110 70l88 126q30 -34 70 -56q43 -22 90 -22q46 0 73 17 q31 19 31 55q0 31 -30 50q-24 16 -82 16h-65v134h43q76 0 104 28q17 17 17 42q0 28 -26 47q-24 17 -64 17q-42 0 -78 -18q-26 -13 -55 -37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10026",
    unicode: "\u0418",
    horizAdvX: 741,
    d: "M70 667h174v-420l250 420h177v-667h-174v420l-250 -420h-177v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10027",
    unicode: "\u0419",
    horizAdvX: 741,
    d: "M70 667h174v-420l250 420h177v-667h-174v420l-250 -420h-177v667zM459 895l116 -44q-24 -66 -82 -97q-47 -26 -128 -26q-78 0 -126 26q-58 31 -82 97l116 44q10 -31 32 -47t61 -16q38 0 61 16q22 16 32 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10028",
    unicode: "\u041A",
    horizAdvX: 694,
    d: "M243 667v-275l212 275h214l-265 -316l289 -351h-224l-226 289v-289h-173v667h173z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10029",
    unicode: "\u041B",
    horizAdvX: 719,
    d: "M135 667h514v-667h-174v521h-168v-243q0 -160 -70 -230q-59 -57 -156 -57q-40 0 -79 9v160q21 -7 40 -7q36 0 58 20q35 32 35 126v368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10030",
    unicode: "\u041C",
    horizAdvX: 915,
    d: "M212 0h-172l113 667h171l135 -356l143 356h173l100 -667h-173l-49 384l-161 -384h-69l-154 384z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10031",
    unicode: "\u041D",
    horizAdvX: 737,
    d: "M243 667v-249h250v249h174v-667h-174v270h-250v-270h-173v667h173z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10032",
    unicode: "\u041E",
    horizAdvX: 816,
    d: "M776 333q0 -148 -105 -249q-104 -99 -263 -99t-263 99q-105 101 -105 249q0 69 26.5 135t78.5 115q104 99 263 99t263 -99q52 -49 78.5 -115t26.5 -135zM408 514q-82 0 -135 -53q-53 -52 -53 -131q0 -73 53 -124q55 -53 135 -53q82 0 134 52q54 54 54 128q0 76 -54 128 q-56 53 -134 53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10033",
    unicode: "\u041F",
    horizAdvX: 726,
    d: "M656 0h-174v519h-239v-519h-173v667h586v-667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10034",
    unicode: "\u0420",
    horizAdvX: 599,
    d: "M352 221h-109v-221h-173v667h276q107 0 169 -60t62 -162q0 -108 -59 -166t-166 -58zM243 527v-166h58q50 0 73 21q22 19 22 61q0 40 -20 60q-23 24 -74 24h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10035",
    unicode: "\u0421",
    horizAdvX: 589,
    d: "M549 223v-205q-91 -33 -150 -33q-156 0 -258 100q-48 48 -74.5 112.5t-26.5 130.5q0 69 27.5 134t73.5 112q102 104 252 104q73 0 156 -34v-207q-59 73 -151 73q-71 0 -120 -44q-58 -54 -58 -137q0 -79 54 -130q49 -46 124 -46q87 0 151 70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10036",
    unicode: "\u0422",
    horizAdvX: 471,
    d: "M464 520h-142v-520h-173v520h-142v147h457v-147z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10037",
    unicode: "\u0423",
    horizAdvX: 623,
    d: "M0 667h194l127 -297l111 297h185l-300 -667h-183l93 187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10038",
    unicode: "\u0424",
    horizAdvX: 870,
    d: "M348 0v93q-159 0 -237 76q-71 71 -71 188q0 125 72 194q79 76 236 76v97h174v-97q157 0 236 -76q72 -69 72 -194q0 -117 -71 -188q-78 -76 -237 -76v-93h-174zM509 493v-266h9q66 0 99 32q39 37 39 103q0 65 -39 100q-34 31 -100 31h-8zM361 493h-8q-66 0 -100 -31 q-39 -35 -39 -100q0 -66 39 -103q33 -32 99 -32h9v266z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10039",
    unicode: "\u0425",
    horizAdvX: 711,
    d: "M0 0l261 356l-214 311h214l99 -173l103 173h213l-217 -311l252 -356h-210l-142 217l-150 -217h-209z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10040",
    unicode: "\u0426",
    horizAdvX: 747,
    d: "M70 0v667h174v-521h230v521h174v-521h84v-296h-156v150h-506z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10041",
    unicode: "\u0427",
    horizAdvX: 660,
    d: "M416 0v262q-66 -10 -139 -10q-129 0 -182 50t-53 158v207h174v-181q0 -49 20 -69q21 -21 82 -21q53 0 98 7v264h174v-667h-174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10042",
    unicode: "\u0428",
    horizAdvX: 998,
    d: "M70 0v667h174v-521h168v521h174v-521h168v521h174v-667h-858z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10043",
    unicode: "\u0429",
    horizAdvX: 1037,
    d: "M866 0h-796v667h174v-521h168v521h174v-521h168v521h174v-521h94v-296h-156v150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10044",
    unicode: "\u042A",
    horizAdvX: 697,
    d: "M147 0v521h-137v146h311v-260h84q136 0 199 -62q53 -53 53 -141q0 -89 -51 -140q-64 -64 -211 -64h-248zM321 134h67q55 0 75 20q18 18 18 50t-19 49q-21 20 -74 20h-67v-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10045",
    unicode: "\u042B",
    horizAdvX: 879,
    d: "M635 0v667h174v-667h-174zM70 0v667h174v-260h84q136 0 199 -62q53 -52 53 -141t-50 -140q-63 -64 -212 -64h-248zM244 134h67q55 0 75 20q18 18 18 50t-19 49q-21 20 -74 20h-67v-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10046",
    unicode: "\u042C",
    horizAdvX: 620,
    d: "M70 0v667h174v-260h84q136 0 199 -62q53 -53 53 -141q0 -89 -51 -140q-64 -64 -211 -64h-248zM244 134h67q55 0 75 20q18 18 18 50t-19 49q-21 20 -74 20h-67v-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10047",
    unicode: "\u042D",
    horizAdvX: 618,
    d: "M50 35v173q29 -29 67 -47q45 -22 106 -22q74 0 118 37t56 97h-254v134h248q-11 54 -51 87q-43 35 -117 35q-59 0 -106 -25q-40 -23 -67 -53v181q99 49 196 49q149 0 239 -94q93 -96 93 -251q0 -157 -100 -260q-88 -91 -238 -91q-61 0 -115 17q-32 10 -75 33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10048",
    unicode: "\u042E",
    horizAdvX: 1086,
    d: "M243 409h86q21 116 109 191q96 82 238 82q161 0 263 -98q50 -47 78.5 -112.5t28.5 -137.5q0 -71 -28.5 -137t-78.5 -114q-102 -98 -263 -98q-144 0 -240 86q-92 83 -107 204h-86v-275h-173v667h173v-258zM682 514q-78 0 -133 -55q-53 -53 -53 -126q0 -76 55 -128 q53 -52 130 -52q74 0 129 53q55 55 55 130q0 73 -55 126q-53 52 -128 52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10049",
    unicode: "\u042F",
    horizAdvX: 618,
    d: "M14 0l186 251q-58 10 -99 52q-52 53 -52 140q0 99 55 157q63 67 187 67h257v-667h-174v227h-17l-143 -227h-200zM374 361v160h-49q-50 0 -75 -23q-23 -21 -23 -57t21 -57q24 -23 77 -23h49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10065",
    unicode: "\u0430",
    horizAdvX: 616,
    d: "M401 404v43h160v-447h-160v49q-46 -64 -139 -64q-94 0 -161 71q-64 68 -64 164q0 110 69 179q63 63 161 63q82 0 134 -58zM303 326q-40 0 -70 -29q-32 -31 -32 -73q0 -44 31 -73q32 -30 72 -30q41 0 72 31q30 30 30 72q0 43 -31 73q-31 29 -72 29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10066",
    unicode: "\u0431",
    horizAdvX: 612,
    d: "M177 399h7q52 61 151 61q109 0 177 -63q63 -59 63 -162q0 -108 -69 -177q-73 -73 -200 -73q-124 0 -193 71q-76 78 -76 235q0 201 96 301q33 33 74.5 52t107.5 32l29 6q53 10 68 25q13 15 13 33h139q-7 -52 -41 -97q-32 -42 -92 -64q-22 -8 -116 -34q-69 -19 -98 -49 q-35 -38 -40 -97zM306 328q-40 0 -69 -26q-34 -30 -34 -76t34 -77q29 -26 69 -26q41 0 69 26q34 32 34 81q0 42 -34 72q-30 26 -69 26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10067",
    unicode: "\u0432",
    horizAdvX: 529,
    d: "M55 447h274q80 0 114 -32q31 -29 31 -78q0 -39 -19 -67q-16 -23 -49 -37v-2q39 -8 64 -31q32 -29 32 -77q0 -54 -32 -86q-37 -37 -109 -37h-306v447zM215 269h60q29 0 41 10q12 11 12 32q0 19 -11 28q-12 11 -43 11h-59v-81zM215 97h71q25 0 39 13q13 13 13 32 q0 21 -12 33q-11 11 -40 11h-71v-89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10068",
    unicode: "\u0433",
    horizAdvX: 383,
    d: "M55 0v447h314v-131h-154v-316h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10069",
    unicode: "\u0434",
    horizAdvX: 596,
    d: "M105 447h411v-335h65v-242h-140v130h-297v-130h-140v242q37 3 61 27q40 39 40 128v180zM360 112v223h-107v-76q0 -50 -13 -85q-15 -40 -42 -62h162z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10070",
    unicode: "\u0435",
    horizAdvX: 566,
    d: "M529 211v-17h-333q0 -47 28 -75q22 -22 66 -22q30 0 52 12q19 11 28 30h153q-15 -54 -54 -92q-64 -62 -182 -62q-117 0 -185 68q-66 66 -66 169q0 108 67 173t183 65q107 0 172 -61q71 -68 71 -188zM201 286h181q-7 29 -26 48q-24 24 -66 24q-41 0 -65 -24 q-20 -22 -24 -48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10072",
    unicode: "\u0436",
    horizAdvX: 818,
    d: "M330 0v194l-133 -194h-196l182 233l-155 214h182l120 -187v187h158v-187l120 187h182l-155 -214l182 -233h-196l-133 194v-194h-158z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10073",
    unicode: "\u0437",
    horizAdvX: 464,
    d: "M87 309l-53 104q35 19 74 31q59 18 114 18q110 0 160 -50q32 -32 32 -79q0 -41 -22 -67q-18 -21 -45 -33v-2q37 -6 62 -31q27 -27 27 -69q0 -58 -41 -97q-50 -49 -172 -49q-62 0 -116 17q-46 14 -89 41l59 111q27 -21 56 -34q33 -14 70 -14q30 0 48 8q21 10 21 30 q0 17 -18 25q-15 7 -52 7h-55v104h45q31 0 50 7q21 7 21 26q0 18 -19 26q-16 8 -46 8t-61 -12q-28 -10 -50 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10074",
    unicode: "\u0438",
    horizAdvX: 586,
    d: "M55 447h160v-230l177 230h139v-447h-160v236l-175 -236h-141v447z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10075",
    unicode: "\u0439",
    horizAdvX: 586,
    d: "M55 447h160v-230l177 230h139v-447h-160v236l-175 -236h-141v447zM370 676l107 -38q-16 -60 -68 -92q-44 -28 -116 -28t-116 28q-52 32 -68 92l107 38q8 -27 23 -42q19 -20 54 -20t54 20q15 15 23 42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10076",
    unicode: "\u043A",
    horizAdvX: 569,
    d: "M55 0v447h160v-183l135 183h201l-185 -210l202 -237h-207l-146 198v-198h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10077",
    unicode: "\u043B",
    horizAdvX: 576,
    d: "M521 447v-447h-160v316h-114v-128q0 -102 -47 -151q-42 -43 -126 -43q-31 0 -64 6v116q42 -5 63 17q20 21 20 72v242h428z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10078",
    unicode: "\u043C",
    horizAdvX: 680,
    d: "M20 0l71 447h139l110 -242l110 242h139l71 -447h-150l-36 233l-105 -233h-58l-105 233l-36 -233h-150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10079",
    unicode: "\u043D",
    horizAdvX: 579,
    d: "M55 0v447h160v-151h149v151h160v-447h-160v170h-149v-170h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10080",
    unicode: "\u043E",
    horizAdvX: 611,
    d: "M306 326q-41 0 -72 -29t-31 -73q0 -40 31 -71q30 -30 72 -30q41 0 71 30q31 29 31 71t-31 73q-31 29 -71 29zM574 224q0 -97 -69 -165q-75 -74 -200 -74q-124 0 -199 74q-69 68 -69 165t69 164q76 74 199 74q122 0 200 -74q69 -67 69 -164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10081",
    unicode: "\u043F",
    horizAdvX: 573,
    d: "M55 0v447h463v-447h-160v321h-143v-321h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10082",
    unicode: "\u0440",
    horizAdvX: 616,
    d: "M215 43v-272h-160v676h160v-49q51 64 137 64q94 0 159 -65q68 -68 68 -173q0 -107 -72 -177q-63 -62 -153 -62q-83 0 -139 58zM313 326q-42 0 -72 -30q-31 -31 -31 -74q0 -40 31 -71q30 -30 72 -30q43 0 71 30q31 31 31 71q0 43 -31 74q-28 30 -71 30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10083",
    unicode: "\u0441",
    horizAdvX: 429,
    d: "M393 144v-134q-51 -25 -111 -25q-106 0 -176 68q-69 67 -69 167q0 103 72 173q71 68 180 68q54 0 104 -25v-134q-41 29 -83 29q-47 0 -78 -31t-31 -77q0 -44 28 -75q32 -34 82 -34q47 0 82 30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10084",
    unicode: "\u0442",
    horizAdvX: 412,
    d: "M126 0v316h-116v131h392v-131h-116v-316h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10085",
    unicode: "\u0443",
    horizAdvX: 604,
    d: "M66 -229l150 290l-216 386h186l119 -229l116 229h183l-359 -676h-179z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10086",
    unicode: "\u0444",
    horizAdvX: 744,
    d: "M452 -229h-160v222h-3q-122 0 -190 68q-62 61 -62 162q0 106 66 167q70 64 186 64h3v213h160v-213h3q116 0 186 -64q66 -61 66 -167q0 -101 -62 -162q-68 -68 -190 -68h-3v-222zM441 339v-231h2q47 0 75 26q35 31 35 90q0 55 -34 88q-28 27 -75 27h-3zM303 339h-3 q-47 0 -75 -27q-34 -33 -34 -88q0 -59 35 -90q28 -26 75 -26h2v231z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10087",
    unicode: "\u0445",
    horizAdvX: 652,
    d: "M0 0l223 243l-181 204h208l77 -92l79 92h207l-185 -204l224 -243h-212l-114 133l-114 -133h-212z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10088",
    unicode: "\u0446",
    horizAdvX: 596,
    d: "M55 0v447h160v-321h137v321h160v-321h74v-256h-140v130h-391z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10089",
    unicode: "\u0447",
    horizAdvX: 538,
    d: "M323 0v146q-44 -11 -98 -11q-100 0 -143 44q-40 40 -40 127v141h154v-130q0 -37 17 -51q14 -12 54 -12q33 0 56 7v186h160v-447h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10090",
    unicode: "\u0448",
    horizAdvX: 830,
    d: "M55 0v447h160v-321h120v321h160v-321h120v321h160v-447h-720z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10091",
    unicode: "\u0449",
    horizAdvX: 870,
    d: "M721 0h-666v447h160v-321h121v321h160v-321h121v321h160v-321h84v-256h-140v130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10092",
    unicode: "\u044A",
    horizAdvX: 583,
    d: "M285 298h112q80 0 121 -40q40 -39 40 -107t-38 -107q-44 -44 -123 -44h-272v316h-115v131h275v-149zM285 104h60q29 0 43 14q10 10 10 32t-11 32q-14 12 -44 12h-58v-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10093",
    unicode: "\u044B",
    horizAdvX: 742,
    d: "M527 0v447h160v-447h-160zM215 298h109q78 0 120 -40q40 -39 40 -107q0 -69 -38 -107q-44 -44 -122 -44h-269v447h160v-149zM215 104h60q29 0 43 14q11 11 11 32q0 22 -12 32q-15 12 -44 12h-58v-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10094",
    unicode: "\u044C",
    horizAdvX: 513,
    d: "M215 298h112q79 0 121 -40q40 -39 40 -107q0 -69 -38 -107q-44 -44 -123 -44h-272v447h160v-149zM215 104h60q29 0 42 14q11 11 11 32q0 22 -12 32q-15 12 -43 12h-58v-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10095",
    unicode: "\u044D",
    horizAdvX: 476,
    d: "M46 15v134q49 -43 120 -43q49 0 77 17q29 17 38 51h-172v104h172q-13 34 -42 49q-28 15 -70 15q-39 0 -71 -14q-25 -10 -52 -35v132q66 36 150 36q112 0 177 -63q66 -64 66 -172q0 -115 -69 -180q-64 -61 -180 -61q-73 0 -144 30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10096",
    unicode: "\u044E",
    horizAdvX: 814,
    d: "M509 326q-43 0 -72 -29q-31 -31 -31 -73q0 -41 31 -72q28 -29 72 -29q42 0 71 29q30 30 30 74q0 40 -28 71q-27 29 -73 29zM215 296h47q23 71 85 117q67 49 161 49q123 0 200 -74q69 -69 69 -162q0 -100 -69 -167q-74 -74 -205 -74q-123 0 -189 68q-44 46 -56 117h-43 v-170h-160v447h160v-151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10097",
    unicode: "\u044F",
    horizAdvX: 522,
    d: "M28 0l124 156q-46 9 -78 39q-35 35 -35 96q0 67 40 109q44 47 152 47h236v-447h-160v142h-13l-98 -142h-168zM307 240v103h-48q-35 0 -50 -14q-14 -14 -14 -38q0 -25 15 -38q16 -13 47 -13h50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10071",
    unicode: "\u0451",
    horizAdvX: 566,
    d: "M529 211v-17h-333q0 -47 28 -75q22 -22 66 -22q30 0 52 12q19 11 28 30h153q-15 -54 -54 -92q-64 -62 -182 -62q-117 0 -185 68q-66 66 -66 169q0 108 67 173t183 65q107 0 172 -61q71 -68 71 -188zM201 286h181q-7 29 -26 48q-24 24 -66 24q-41 0 -65 -24 q-20 -22 -24 -48zM93 614q0 35 24.5 59.5t59.5 24.5t59.5 -24.5t24.5 -59.5t-24.5 -59.5t-59.5 -24.5t-59.5 24.5t-24.5 59.5zM305 614q0 35 24.5 59.5t59.5 24.5t59.5 -24.5t24.5 -59.5t-24.5 -59.5t-59.5 -24.5t-59.5 24.5t-24.5 59.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10099",
    unicode: "\u0452",
    horizAdvX: 585,
    d: "M55 0v486h-82v108h82v135h160v-135h164v-108h-164v-135q22 28 50 44q38 22 92 22q84 0 132 -48q27 -27 34.5 -55.5t7.5 -69.5v-304q0 -87 -41 -128q-42 -42 -125 -42q-35 0 -88 11v124q52 -12 77 13q5 5 8.5 11.5t5 11t2.5 14t1 12v13.5v11v195q0 65 -20 87 q-17 19 -51 19q-37 0 -58 -19q-27 -25 -27 -73v-200h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10100",
    unicode: "\u0453",
    horizAdvX: 383,
    d: "M55 0v447h314v-131h-154v-316h-160zM268 729l101 -73l-154 -136l-74 55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10101",
    unicode: "\u0454",
    horizAdvX: 476,
    d: "M430 149v-134q-71 -30 -144 -30q-116 0 -180 60q-69 64 -69 179q0 106 66 172q67 65 177 65q83 0 150 -36v-132q-23 23 -52 35q-32 14 -71 14q-40 0 -70 -15q-29 -15 -42 -49h172v-104h-172q9 -34 38 -51q28 -17 77 -17q71 0 120 43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10102",
    unicode: "\u0455",
    horizAdvX: 444,
    d: "M27 37l57 111q30 -22 64 -33q31 -11 62 -11q28 0 41 12q8 8 8 21t-8 20q-8 8 -42 16l-42 10q-53 12 -78 39q-29 31 -29 77q0 65 42 109q52 54 160 54q74 0 143 -29l-54 -102q-48 22 -84 22q-22 0 -37 -9q-14 -8 -14 -22q0 -17 19 -25q8 -3 25 -6.5t28 -6.5l29 -8 q43 -12 66 -35q34 -32 34 -89q0 -68 -45 -111q-56 -56 -165 -56q-95 0 -180 52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10103",
    unicode: "\u0456",
    horizAdvX: 269,
    d: "M55 447h160v-447h-160v447zM45 633q0 37 26.5 63.5t63.5 26.5t63.5 -26.5t26.5 -63.5t-26.5 -63.5t-63.5 -26.5t-63.5 26.5t-26.5 63.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10104",
    unicode: "\u0457",
    horizAdvX: 350,
    d: "M96 447h158v-447h-158v447zM264 722q27 0 46 -16q29 -25 29 -65t-29 -65q-19 -16 -46 -16t-46 16q-29 25 -29 65t29 65q19 16 46 16zM86 722q27 0 46 -16q29 -25 29 -65t-29 -65q-19 -16 -46 -16t-46 16q-29 25 -29 65t29 65q19 16 46 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10105",
    unicode: "\u0458",
    horizAdvX: 269,
    d: "M55 447h160v-676h-160v676zM45 633q0 37 26.5 63.5t63.5 26.5t63.5 -26.5t26.5 -63.5t-26.5 -63.5t-63.5 -26.5t-63.5 26.5t-26.5 63.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10106",
    unicode: "\u0459",
    horizAdvX: 815,
    d: "M516 298h113q78 0 120 -40q41 -39 41 -107t-39 -107q-44 -44 -122 -44h-268v316h-114v-128q0 -102 -47 -151q-41 -43 -122 -43q-36 0 -68 6v116q40 -6 62 17q21 22 21 72v242h423v-149zM516 104h61q28 0 42 14q11 11 11 32q0 22 -12 32q-15 12 -43 12h-59v-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10107",
    unicode: "\u045A",
    horizAdvX: 818,
    d: "M520 298h112q79 0 121 -40q40 -39 40 -107q0 -69 -38 -107q-44 -44 -123 -44h-272v194h-145v-194h-160v447h160v-149h145v149h160v-149zM520 104h60q29 0 42 14q11 11 11 32q0 22 -12 32q-15 12 -43 12h-58v-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10108",
    unicode: "\u045B",
    horizAdvX: 585,
    d: "M55 0v486h-82v108h82v135h160v-135h164v-108h-164v-135q22 28 50 44q38 22 92 22q84 0 132 -48q27 -27 34.5 -55.5t7.5 -69.5v-244h-160v186q0 65 -20 87q-17 19 -51 19q-37 0 -58 -19q-27 -25 -27 -73v-200h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10109",
    unicode: "\u045C",
    horizAdvX: 569,
    d: "M55 0v447h160v-183l135 183h201l-185 -210l202 -237h-207l-146 198v-198h-160zM338 729l101 -73l-154 -136l-74 55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10110",
    unicode: "\u045E",
    horizAdvX: 604,
    d: "M66 -229l150 290l-216 386h186l119 -229l116 229h183l-359 -676h-179zM387 676l107 -38q-16 -60 -68 -92q-44 -28 -116 -28t-116 28q-52 32 -68 92l107 38q8 -27 23 -42q19 -20 54 -20t54 20q15 15 23 42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10193",
    unicode: "\u045F",
    horizAdvX: 566,
    d: "M55 0v447h160v-321h136v321h160v-447h-158v-140h-140v140h-158z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10146",
    unicode: "\u0462",
    horizAdvX: 693,
    d: "M143 0v495h-133v115h133v114h174v-114h191v-115h-191v-88h84q136 0 199 -62q53 -53 53 -141q0 -89 -51 -140q-64 -64 -211 -64h-248zM317 134h67q55 0 75 20q18 18 18 50t-19 49q-21 20 -74 20h-67v-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10194",
    unicode: "\u0463",
    horizAdvX: 583,
    d: "M281 359v-57h114q80 0 122 -41q41 -39 41 -108t-39 -108q-45 -45 -124 -45h-274v359h-111v94h111v214h160v-214h168v-94h-168zM281 105h61q28 0 43 15q11 11 11 32q0 20 -12 32q-14 13 -44 13h-59v-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10147",
    unicode: "\u0472",
    horizAdvX: 816,
    d: "M238 405h338q-18 49 -55 79q-46 38 -114 38q-63 0 -110 -36q-44 -32 -59 -81zM584 279h-354q15 -53 53 -88q52 -46 124 -46q66 0 118 42q45 36 59 92zM776 333q0 -148 -105 -249q-104 -99 -263 -99t-263 99q-105 101 -105 249q0 69 26.5 135t78.5 115q104 99 263 99 t263 -99q52 -49 78.5 -115t26.5 -135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10195",
    unicode: "\u0473",
    horizAdvX: 619,
    d: "M213 266h192q-9 28 -30 47q-25 22 -66 22q-45 0 -69 -24q-20 -18 -27 -45zM408 196h-197q8 -33 34 -54q27 -22 65 -22q39 0 66 24q25 25 32 52zM582 227q0 -98 -70 -167q-77 -75 -203 -75q-124 0 -202 75q-70 69 -70 167t70 166q78 75 202 75q126 0 203 -75 q70 -68 70 -166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10148",
    unicode: "\u0474",
    horizAdvX: 699,
    d: "M0 667h189l160 -406l162 406h188l-284 -667h-135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10196",
    unicode: "\u0475",
    horizAdvX: 573,
    d: "M0 447h179l107 -229l109 229h178l-233 -447h-109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10050",
    unicode: "\u0490",
    horizAdvX: 490,
    d: "M70 0v667h253v133h147v-280h-227v-520h-173z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10098",
    unicode: "\u0491",
    horizAdvX: 434,
    d: "M55 447h211v140h143v-271h-194v-316h-160v447z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0492",
    unicode: "\u0492",
    horizAdvX: 540,
    d: "M500 667v-147h-217v-132h164v-132h-164v-256h-173v256h-100v132h100v279h390z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0493",
    unicode: "\u0493",
    horizAdvX: 435,
    d: "M88 0v149h-78v99h78v199h323v-131h-163v-68h101v-99h-101v-149h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0494",
    unicode: "\u0494",
    horizAdvX: 634,
    d: "M476 667v-147h-233v-132q65 23 127 23q85 0 138 -30q93 -52 93 -178q0 -119 -81 -172q-57 -37 -156 -37q-21 0 -57 6v132q21 -6 44 -6q30 0 48 14q22 17 22 58q0 42 -33 59q-19 10 -55 10q-44 0 -90 -23v-244h-173v667h406z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0495",
    unicode: "\u0495",
    horizAdvX: 502,
    d: "M55 0v447h323v-131h-163v-80h16q134 0 193 -57q54 -52 54 -148q0 -109 -57 -169q-61 -67 -187 -70v116q38 2 61 25q27 27 27 87q0 59 -26 82q-22 19 -71 19h-10v-121h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0496",
    unicode: "\u0496",
    horizAdvX: 974,
    d: "M399 0v293l-180 -293h-218l243 340l-223 327h200l178 -290v290h172v-290l178 290h200l-223 -327l149 -194h89v-296h-156v150h-53l-184 293v-293h-172z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0497",
    unicode: "\u0497",
    horizAdvX: 811,
    d: "M310 0v194l-127 -194h-194l174 233l-149 214h182l114 -187v187h158v-187l120 187h182l-155 -214l89 -107h93v-256h-140v130h-52l-137 194v-194h-158z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0498",
    unicode: "\u0498",
    horizAdvX: 597,
    d: "M131 484l-67 127q39 27 92 47q68 25 141 25q117 0 179 -60q50 -47 50 -126q0 -55 -29 -97q-22 -32 -62 -56q44 -14 74 -42q48 -43 48 -114q0 -84 -57 -139q-54 -52 -137 -63v-152h-156v157q-100 10 -192 91l88 126q32 -35 70 -56q41 -22 90 -22q46 0 73 17q31 20 31 55 q0 33 -30 52q-24 16 -82 16h-65v134h43q76 0 104 28q17 17 17 43q0 28 -26 47q-24 17 -64 17q-42 0 -78 -18q-26 -13 -55 -37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0499",
    unicode: "\u0499",
    horizAdvX: 464,
    d: "M87 310l-53 104q35 19 74 31q59 18 114 18q110 0 160 -50q32 -32 32 -79q0 -42 -22 -68q-16 -19 -45 -35q39 -7 62 -31q27 -27 27 -71q0 -58 -41 -97q-40 -39 -104 -43v-129h-140v129q-73 11 -133 52l59 111q27 -21 56 -34q33 -14 70 -14q34 0 49 9q20 11 20 29t-18 27 q-17 7 -52 7h-55v104h45q31 0 50 7q21 7 21 27q0 18 -19 26q-16 8 -46 8t-61 -12q-28 -10 -50 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni049A",
    unicode: "\u049A",
    horizAdvX: 690,
    d: "M243 667v-275l212 275h214l-265 -316l177 -205h94v-296h-156v150h-44l-232 289v-289h-173v667h173z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni049B",
    unicode: "\u049B",
    horizAdvX: 578,
    d: "M55 0v447h160v-183l135 183h201l-181 -207l102 -114h92v-256h-140v130h-55l-154 198v-198h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni049C",
    unicode: "\u049C",
    horizAdvX: 806,
    d: "M70 667h173v-265h50v141h111v-141l187 265h202l-240 -316l252 -351h-210l-191 299v-140h-111v140h-50v-299h-173v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni049D",
    unicode: "\u049D",
    horizAdvX: 651,
    d: "M55 0v447h160v-173h36v97h97v-107l112 183h178l-154 -215l157 -232h-178l-115 198v-121h-97v107h-36v-184h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A0",
    unicode: "\u04A0",
    horizAdvX: 795,
    d: "M344 667v-275l212 275h214l-265 -316l289 -351h-224l-226 289v-289h-173v520h-161v147h334z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A1",
    unicode: "\u04A1",
    horizAdvX: 640,
    d: "M126 0v321h-121v126h281v-183l136 183h200l-185 -210l202 -237h-206l-147 198v-198h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A2",
    unicode: "\u04A2",
    horizAdvX: 766,
    d: "M243 667v-249h250v249h174v-521h84v-296h-156v150h-102v270h-250v-270h-173v667h173z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A3",
    unicode: "\u04A3",
    horizAdvX: 608,
    d: "M55 0v447h160v-151h149v151h160v-321h74v-256h-140v130h-94v170h-149v-170h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A4",
    unicode: "\u04A4",
    horizAdvX: 873,
    d: "M243 667v-249h250v249h356v-147h-183v-520h-173v270h-250v-270h-173v667h173z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A5",
    unicode: "\u04A5",
    horizAdvX: 677,
    d: "M55 0v447h160v-151h149v151h299v-131h-139v-316h-160v170h-149v-170h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AA",
    unicode: "\u04AA",
    horizAdvX: 590,
    d: "M550 220v-205q-30 -15 -69 -21v-160h-156v155q-115 10 -192 87q-93 91 -93 246q0 151 102 255t252 104q73 0 156 -34v-207q-59 73 -150 73q-71 0 -120 -44q-59 -53 -59 -140q0 -37 15 -73.5t40 -59.5q50 -46 124 -46q86 0 150 70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AB",
    unicode: "\u04AB",
    horizAdvX: 429,
    d: "M393 144v-134q-26 -14 -57 -18v-132h-140v139q-58 10 -99 51q-60 60 -60 162q0 111 72 181q71 68 180 68q54 0 104 -25v-134q-41 29 -83 29q-47 0 -78 -31t-31 -77q0 -44 28 -75q32 -34 82 -34q47 0 82 30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AE",
    unicode: "\u04AE",
    horizAdvX: 640,
    d: "M229 0v320l-241 347h207l126 -182l121 182h210l-249 -347v-320h-174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AF",
    unicode: "\u04AF",
    horizAdvX: 517,
    d: "M0 447h164l99 -244l91 244h163l-178 -404v-272h-160v270z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B0",
    unicode: "\u04B0",
    horizAdvX: 640,
    d: "M229 0v165h-180v128h180v27l-241 347h207l126 -182l121 182h210l-249 -347v-27h180v-128h-180v-165h-174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B1",
    unicode: "\u04B1",
    horizAdvX: 517,
    d: "M0 447h164l99 -244l91 244h163l-178 -396v-30h135v-99h-135v-151h-160v151h-135v99h135v30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B2",
    unicode: "\u04B2",
    horizAdvX: 715,
    d: "M0 0l261 356l-214 311h214l99 -173l103 173h213l-217 -311l149 -210h97v-296h-156v150h-48l-142 217l-150 -217h-209z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B3",
    unicode: "\u04B3",
    horizAdvX: 651,
    d: "M0 0l223 243l-181 204h208l77 -92l79 92h207l-185 -204l109 -117h100v-256h-140v130h-57l-114 133l-115 -133h-211z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B6",
    unicode: "\u04B6",
    horizAdvX: 689,
    d: "M518 0h-102v262q-66 -10 -139 -10q-129 0 -182 50t-53 158v207h174v-181q0 -49 20 -69q21 -21 82 -21q53 0 98 7v264h174v-521h84v-296h-156v150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B7",
    unicode: "\u04B7",
    horizAdvX: 568,
    d: "M418 0h-94v146q-47 -11 -96 -11q-101 0 -145 44q-41 41 -41 127v141h154v-130q0 -37 17 -51q14 -12 52 -12q35 0 59 7v186h160v-321h74v-256h-140v130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B8",
    unicode: "\u04B8",
    horizAdvX: 710,
    d: "M466 0v266q-30 -8 -62 -8v-132h-112v128q-140 -5 -205 67q-20 22 -30.5 50.5t-12.5 49t-2 51.5v194h174v-165q0 -59 22 -81q19 -20 54 -22v145h112v-145q33 -2 62 6v263h174v-667h-174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B9",
    unicode: "\u04B9",
    horizAdvX: 592,
    d: "M377 0v159q-24 -6 -41 -8v-84h-92v73h-5q-111 0 -156 44q-41 40 -41 110v153h150v-136q0 -34 15 -49q11 -11 34 -11h3v120h92v-120q22 0 41 8v188h160v-447h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04BA",
    unicode: "\u04BA",
    horizAdvX: 680,
    d: "M244 667v-264q64 13 143 13q144 0 202 -56q23 -22 34.5 -53.5t13 -49.5t1.5 -48v-209h-174v168q0 55 -20 77q-25 27 -99 27q-44 0 -101 -9v-263h-174v667h174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04BB",
    unicode: "\u04BB",
    horizAdvX: 585,
    d: "M55 0v729h160v-338q22 28 50 44q38 22 92 22q84 0 132 -48q27 -27 34.5 -55.5t7.5 -69.5v-284h-160v226q0 65 -20 87q-17 19 -51 19q-37 0 -58 -19q-27 -25 -27 -73v-240h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C0",
    unicode: "\u04C0",
    horizAdvX: 313,
    d: "M70 667h173v-667h-173v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C1",
    unicode: "\u04C1",
    horizAdvX: 970,
    d: "M399 0v293l-180 -293h-218l243 340l-223 327h200l178 -290v290h172v-290l178 290h200l-223 -327l243 -340h-218l-180 293v-293h-172zM551 895l116 -44q-24 -66 -82 -97q-47 -26 -128 -26q-78 0 -126 26q-58 31 -82 97l116 44q10 -31 32 -47t61 -16q38 0 61 16 q22 16 32 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C2",
    unicode: "\u04C2",
    horizAdvX: 818,
    d: "M330 0v194l-133 -194h-196l182 233l-155 214h182l120 -187v187h158v-187l120 187h182l-155 -214l182 -233h-196l-133 194v-194h-158zM499 676l107 -38q-16 -60 -68 -92q-44 -28 -116 -28t-116 28q-52 32 -68 92l107 38q8 -27 23 -42q19 -20 54 -20t54 20q15 15 23 42z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C3",
    unicode: "\u04C3",
    horizAdvX: 644,
    d: "M243 667v-275l194 275h202l-207 -264q42 -3 85 -20.5t70 -44.5q48 -49 48 -125q0 -102 -58 -158q-74 -72 -235 -54v133q16 -6 36 -6q34 0 54 20q19 19 19 53q0 37 -28 56q-25 17 -75 17q-53 0 -105 -22v-252h-173v667h173z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C4",
    unicode: "\u04C4",
    horizAdvX: 514,
    d: "M55 0v447h160v-190l119 190h175l-161 -222q53 -9 89 -45q53 -53 53 -148q0 -109 -57 -170q-61 -67 -187 -70v116q38 2 61 25q27 27 27 89q0 53 -28 80q-25 24 -80 24h-11v-126h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C7",
    unicode: "\u04C7",
    horizAdvX: 737,
    d: "M243 667v-248h250v248h174v-735q0 -87 -43 -126q-19 -17 -46.5 -25.5t-45.5 -9.5t-49 -1q-50 0 -83 10v114q14 -6 34 -6q32 0 46 14q13 13 13 47v320h-250v-269h-173v667h173z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C8",
    unicode: "\u04C8",
    horizAdvX: 579,
    d: "M55 0v447h160v-151h149v151h160v-518q0 -85 -43 -124q-38 -35 -121 -35q-48 0 -88 8v113q14 -6 30 -6q35 0 49 15q13 14 13 55v215h-149v-170h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D0",
    unicode: "\u04D0",
    horizAdvX: 710,
    d: "M518 0l-41 112h-242l-45 -112h-183l256 667h189l251 -667h-185zM283 244h148l-75 216zM447 895l116 -44q-24 -66 -82 -97q-47 -26 -128 -26q-78 0 -126 26q-58 31 -82 97l116 44q10 -31 32 -47t61 -16q38 0 61 16q22 16 32 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D1",
    unicode: "\u04D1",
    horizAdvX: 616,
    d: "M401 404v43h160v-447h-160v49q-46 -64 -139 -64q-94 0 -161 71q-64 68 -64 164q0 110 69 179q63 63 161 63q82 0 134 -58zM303 326q-40 0 -70 -29q-32 -31 -32 -73q0 -44 31 -73q32 -30 72 -30q41 0 72 31q30 30 30 72q0 43 -31 73q-31 29 -72 29zM387 676l107 -38 q-16 -60 -68 -92q-44 -28 -116 -28t-116 28q-52 32 -68 92l107 38q8 -27 23 -42q19 -20 54 -20t54 20q15 15 23 42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D2",
    unicode: "\u04D2",
    horizAdvX: 710,
    d: "M518 0l-41 112h-242l-45 -112h-183l256 667h189l251 -667h-185zM283 244h148l-75 216zM468 723q-36 0 -61 27q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62q0 -33 -26 -61q-26 -26 -61 -26zM241 723q-36 0 -61 27q-25 28 -25 60t26 61q26 26 60 26 q35 0 60 -25q27 -27 27 -62q0 -33 -26 -61q-26 -26 -61 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D3",
    unicode: "\u04D3",
    horizAdvX: 616,
    d: "M401 404v43h160v-447h-160v49q-46 -64 -139 -64q-94 0 -161 71q-64 68 -64 164q0 110 69 179q63 63 161 63q82 0 134 -58zM303 326q-40 0 -70 -29q-32 -31 -32 -73q0 -44 31 -73q32 -30 72 -30q41 0 72 31q30 30 30 72q0 43 -31 73q-31 29 -72 29zM423 523q-36 0 -61 27 q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62q0 -33 -26 -61q-26 -26 -61 -26zM196 523q-36 0 -61 27q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62q0 -33 -26 -61q-26 -26 -61 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D4",
    unicode: "\u04D4",
    horizAdvX: 924,
    d: "M515 0l-43 117h-241l-42 -117h-182l257 667h408l53 -147h-219l41 -111h219l55 -147h-220l44 -115h218l54 -147h-402zM279 249h146l-71 197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D5",
    unicode: "\u04D5",
    horizAdvX: 858,
    d: "M821 198h-335q0 -47 30 -77q25 -25 72 -25q32 0 50 13q14 9 23 29h153q-22 -70 -81 -113q-56 -40 -147 -40q-71 0 -119 26q-41 22 -61 61q-32 -41 -80 -63q-50 -22 -104 -22q-95 0 -147 52q-38 38 -38 92q0 58 39 97q51 51 148 51q62 0 114 -23v11q0 34 -21 55 q-26 26 -86 26q-59 0 -124 -25v119q74 21 133 21q56 0 93 -17q47 -21 73 -62q28 37 68 57q44 22 104 22q114 0 178 -64q65 -65 65 -188v-13zM490 289h184q-6 29 -27 48q-28 25 -67 25q-34 0 -59 -22q-22 -21 -31 -51zM264 190q-38 0 -57 -14q-16 -12 -16 -34q0 -21 19 -34 q20 -15 53 -15q28 0 52 12q27 14 27 37t-24 36q-22 12 -54 12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D6",
    unicode: "\u04D6",
    horizAdvX: 489,
    d: "M449 667v-147h-206v-111h195v-147h-195v-115h206v-147h-379v667h379zM338 895l116 -44q-24 -66 -82 -97q-47 -26 -128 -26q-78 0 -126 26q-58 31 -82 97l116 44q10 -31 32 -47t61 -16q38 0 61 16q22 16 32 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D7",
    unicode: "\u04D7",
    horizAdvX: 566,
    d: "M529 211v-17h-333q0 -47 28 -75q22 -22 66 -22q30 0 52 12q19 11 28 30h153q-15 -54 -54 -92q-64 -62 -182 -62q-117 0 -185 68q-66 66 -66 169q0 108 67 173t183 65q107 0 172 -61q71 -68 71 -188zM201 286h181q-7 29 -26 48q-24 24 -66 24q-41 0 -65 -24 q-20 -22 -24 -48zM377 676l107 -38q-16 -60 -68 -92q-44 -28 -116 -28t-116 28q-52 32 -68 92l107 38q8 -27 23 -42q19 -20 54 -20t54 20q15 15 23 42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D8",
    unicode: "\u04D8",
    horizAdvX: 768,
    d: "M235 444l-179 35q39 94 125 149q85 54 198 54q158 0 253 -97q96 -98 96 -247q0 -158 -95 -255q-95 -98 -257 -98q-151 0 -237 88q-99 101 -99 281v18h513q-9 57 -49 97q-50 49 -131 49q-44 0 -84 -22q-35 -19 -54 -52zM548 260h-328q7 -51 42 -83q41 -39 115 -39 q70 0 116 36q43 34 55 86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10846",
    unicode: "\u04D9",
    horizAdvX: 566,
    d: "M36 231v27h333q-3 43 -33 68q-26 22 -68 22q-29 0 -53 -14q-19 -11 -31 -32l-136 28q27 61 85 95q57 35 140 35q124 0 194 -72q62 -64 62 -164q0 -109 -67 -174t-183 -65q-107 0 -172 61q-71 67 -71 185zM364 169h-181q3 -34 26 -57q25 -25 67 -25q41 0 64 25 q21 21 24 57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04DA",
    unicode: "\u04DA",
    horizAdvX: 768,
    d: "M235 444l-179 35q39 94 125 149q85 54 198 54q158 0 253 -97q96 -98 96 -247q0 -158 -95 -255q-95 -98 -257 -98q-151 0 -237 88q-99 101 -99 281v18h513q-9 57 -49 97q-50 49 -131 49q-44 0 -84 -22q-35 -19 -54 -52zM548 260h-328q7 -51 42 -83q41 -39 115 -39 q70 0 116 36q43 34 55 86zM493 723q-36 0 -61 27q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62q0 -33 -26 -61q-26 -26 -61 -26zM266 723q-36 0 -61 27q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62q0 -33 -26 -61q-26 -26 -61 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04DB",
    unicode: "\u04DB",
    horizAdvX: 566,
    d: "M36 231v27h333q-3 43 -33 68q-26 22 -68 22q-29 0 -53 -14q-19 -11 -31 -32l-136 28q27 61 85 95q57 35 140 35q124 0 194 -72q62 -64 62 -164q0 -109 -67 -174t-183 -65q-107 0 -172 61q-71 67 -71 185zM364 169h-181q3 -34 26 -57q25 -25 67 -25q41 0 64 25 q21 21 24 57zM400 523q-36 0 -61 27q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62q0 -33 -26 -61q-26 -26 -61 -26zM173 523q-36 0 -61 27q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62q0 -33 -26 -61q-26 -26 -61 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04DC",
    unicode: "\u04DC",
    horizAdvX: 970,
    d: "M399 0v293l-180 -293h-218l243 340l-223 327h200l178 -290v290h172v-290l178 290h200l-223 -327l243 -340h-218l-180 293v-293h-172zM598 723q-36 0 -61 27q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62q0 -33 -26 -61q-26 -26 -61 -26zM371 723 q-36 0 -61 27q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62q0 -33 -26 -61q-26 -26 -61 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04DD",
    unicode: "\u04DD",
    horizAdvX: 818,
    d: "M330 0v194l-133 -194h-196l182 233l-155 214h182l120 -187v187h158v-187l120 187h182l-155 -214l182 -233h-196l-133 194v-194h-158zM524 523q-36 0 -61 27q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62q0 -33 -26 -61q-26 -26 -61 -26zM297 523 q-36 0 -61 27q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62q0 -33 -26 -61q-26 -26 -61 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04DE",
    unicode: "\u04DE",
    horizAdvX: 597,
    d: "M131 483l-67 127q39 27 92 47q68 25 141 25q117 0 179 -60q50 -47 50 -126q0 -55 -29 -96q-24 -35 -62 -53v-3q44 -14 74 -42q48 -46 48 -112q0 -102 -83 -159q-66 -46 -188 -46q-91 0 -161 29q-60 25 -110 70l88 126q30 -34 70 -56q43 -22 90 -22q46 0 73 17 q31 19 31 55q0 31 -30 50q-24 16 -82 16h-65v134h43q76 0 104 28q17 17 17 42q0 28 -26 47q-24 17 -64 17q-42 0 -78 -18q-26 -13 -55 -37zM411 723q-36 0 -61 27q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62q0 -33 -26 -61q-26 -26 -61 -26zM184 723 q-36 0 -61 27q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62q0 -33 -26 -61q-26 -26 -61 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04DF",
    unicode: "\u04DF",
    horizAdvX: 464,
    d: "M87 309l-53 104q35 19 74 31q59 18 114 18q110 0 160 -50q32 -32 32 -79q0 -41 -22 -67q-18 -21 -45 -33v-2q37 -6 62 -31q27 -27 27 -69q0 -58 -41 -97q-50 -49 -172 -49q-62 0 -116 17q-46 14 -89 41l59 111q27 -21 56 -34q33 -14 70 -14q30 0 48 8q21 10 21 30 q0 17 -18 25q-15 7 -52 7h-55v104h45q31 0 50 7q21 7 21 26q0 18 -19 26q-16 8 -46 8t-61 -12q-28 -10 -50 -26zM347 523q-36 0 -61 27q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62q0 -33 -26 -61q-26 -26 -61 -26zM120 523q-36 0 -61 27q-25 28 -25 60 t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62q0 -33 -26 -61q-26 -26 -61 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E2",
    unicode: "\u04E2",
    horizAdvX: 741,
    d: "M70 667h174v-420l250 420h177v-667h-174v420l-250 -420h-177v667zM182 749v98h376v-98h-376z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E3",
    unicode: "\u04E3",
    horizAdvX: 586,
    d: "M55 447h160v-230l177 230h139v-447h-160v236l-175 -236h-141v447zM92 539v98h396v-98h-396z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E4",
    unicode: "\u04E4",
    horizAdvX: 741,
    d: "M70 667h174v-420l250 420h177v-667h-174v420l-250 -420h-177v667zM483 723q-36 0 -61 27q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62q0 -33 -26 -61q-26 -26 -61 -26zM256 723q-36 0 -61 27q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62 q0 -33 -26 -61q-26 -26 -61 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E5",
    unicode: "\u04E5",
    horizAdvX: 586,
    d: "M55 447h160v-230l177 230h139v-447h-160v236l-175 -236h-141v447zM407 523q-36 0 -61 27q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62q0 -33 -26 -61q-26 -26 -61 -26zM180 523q-36 0 -61 27q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62 q0 -33 -26 -61q-26 -26 -61 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E6",
    unicode: "\u04E6",
    horizAdvX: 816,
    d: "M776 333q0 -148 -105 -249q-104 -99 -263 -99t-263 99q-105 101 -105 249q0 69 26.5 135t78.5 115q104 99 263 99t263 -99q52 -49 78.5 -115t26.5 -135zM408 514q-82 0 -135 -53q-53 -52 -53 -131q0 -73 53 -124q55 -53 135 -53q82 0 134 52q54 54 54 128q0 76 -54 128 q-56 53 -134 53zM522 723q-36 0 -61 27q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62q0 -33 -26 -61q-26 -26 -61 -26zM295 723q-36 0 -61 27q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62q0 -33 -26 -61q-26 -26 -61 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E7",
    unicode: "\u04E7",
    horizAdvX: 611,
    d: "M306 326q-41 0 -72 -29t-31 -73q0 -40 31 -71q30 -30 72 -30q41 0 71 30q31 29 31 71t-31 73q-31 29 -71 29zM574 224q0 -97 -69 -165q-75 -74 -200 -74q-124 0 -199 74q-69 68 -69 165t69 164q76 74 199 74q122 0 200 -74q69 -67 69 -164zM422 523q-36 0 -61 27 q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62q0 -33 -26 -61q-26 -26 -61 -26zM195 523q-36 0 -61 27q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62q0 -33 -26 -61q-26 -26 -61 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E8",
    unicode: "\u04E8",
    horizAdvX: 816,
    d: "M238 405h338q-18 49 -55 79q-46 38 -114 38q-63 0 -110 -36q-44 -32 -59 -81zM584 279h-354q15 -53 53 -88q52 -46 124 -46q66 0 118 42q45 36 59 92zM776 333q0 -148 -105 -249q-104 -99 -263 -99t-263 99q-105 101 -105 249q0 69 26.5 135t78.5 115q104 99 263 99 t263 -99q52 -49 78.5 -115t26.5 -135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E9",
    unicode: "\u04E9",
    horizAdvX: 619,
    d: "M213 266h192q-9 28 -30 47q-25 22 -66 22q-45 0 -69 -24q-20 -18 -27 -45zM408 196h-197q8 -33 34 -54q27 -22 65 -22q39 0 66 24q25 25 32 52zM582 227q0 -98 -70 -167q-77 -75 -203 -75q-124 0 -202 75q-70 69 -70 167t70 166q78 75 202 75q126 0 203 -75 q70 -68 70 -166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04EA",
    unicode: "\u04EA",
    horizAdvX: 816,
    d: "M238 405h338q-18 49 -55 79q-46 38 -114 38q-63 0 -110 -36q-44 -32 -59 -81zM584 279h-354q15 -53 53 -88q52 -46 124 -46q66 0 118 42q45 36 59 92zM776 333q0 -148 -105 -249q-104 -99 -263 -99t-263 99q-105 101 -105 249q0 69 26.5 135t78.5 115q104 99 263 99 t263 -99q52 -49 78.5 -115t26.5 -135zM522 723q-36 0 -61 27q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62q0 -33 -26 -61q-26 -26 -61 -26zM295 723q-36 0 -61 27q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62q0 -33 -26 -61 q-26 -26 -61 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04EB",
    unicode: "\u04EB",
    horizAdvX: 619,
    d: "M213 266h192q-9 28 -30 47q-25 22 -66 22q-45 0 -69 -24q-20 -18 -27 -45zM408 196h-197q8 -33 34 -54q27 -22 65 -22q39 0 66 24q25 25 32 52zM582 227q0 -98 -70 -167q-77 -75 -203 -75q-124 0 -202 75q-70 69 -70 167t70 166q78 75 202 75q126 0 203 -75 q70 -68 70 -166zM422 523q-36 0 -61 27q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62q0 -33 -26 -61q-26 -26 -61 -26zM195 523q-36 0 -61 27q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62q0 -33 -26 -61q-26 -26 -61 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04EE",
    unicode: "\u04EE",
    horizAdvX: 623,
    d: "M0 667h194l127 -297l111 297h185l-300 -667h-183l93 187zM123 749v98h376v-98h-376z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04EF",
    unicode: "\u04EF",
    horizAdvX: 604,
    d: "M66 -229l150 290l-216 386h186l119 -229l116 229h183l-359 -676h-179zM106 539v98h396v-98h-396z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F0",
    unicode: "\u04F0",
    horizAdvX: 623,
    d: "M0 667h194l127 -297l111 297h185l-300 -667h-183l93 187zM424 723q-36 0 -61 27q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62q0 -33 -26 -61q-26 -26 -61 -26zM197 723q-36 0 -61 27q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62 q0 -33 -26 -61q-26 -26 -61 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F1",
    unicode: "\u04F1",
    horizAdvX: 604,
    d: "M66 -229l150 290l-216 386h186l119 -229l116 229h183l-359 -676h-179zM417 523q-36 0 -61 27q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62q0 -33 -26 -61q-26 -26 -61 -26zM190 523q-36 0 -61 27q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25 q27 -27 27 -62q0 -33 -26 -61q-26 -26 -61 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F2",
    unicode: "\u04F2",
    horizAdvX: 623,
    d: "M0 667h194l127 -297l111 297h185l-300 -667h-183l93 187zM280 929l83 -73l-137 -136l-54 55zM453 929l84 -73l-137 -136l-55 55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F3",
    unicode: "\u04F3",
    horizAdvX: 604,
    d: "M66 -229l150 290l-216 386h186l119 -229l116 229h183l-359 -676h-179zM269 729l83 -73l-137 -136l-54 55zM442 729l84 -73l-137 -136l-55 55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F4",
    unicode: "\u04F4",
    horizAdvX: 660,
    d: "M416 0v262q-66 -10 -139 -10q-129 0 -182 50t-53 158v207h174v-181q0 -49 20 -69q21 -21 82 -21q53 0 98 7v264h174v-667h-174zM423 723q-36 0 -61 27q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62q0 -33 -26 -61q-26 -26 -61 -26zM196 723q-36 0 -61 27 q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62q0 -33 -26 -61q-26 -26 -61 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F5",
    unicode: "\u04F5",
    horizAdvX: 538,
    d: "M323 0v146q-44 -11 -98 -11q-100 0 -143 44q-40 40 -40 127v141h154v-130q0 -37 17 -51q14 -12 54 -12q33 0 56 7v186h160v-447h-160zM383 523q-36 0 -61 27q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62q0 -33 -26 -61q-26 -26 -61 -26zM156 523 q-36 0 -61 27q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62q0 -33 -26 -61q-26 -26 -61 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F8",
    unicode: "\u04F8",
    horizAdvX: 879,
    d: "M635 0v667h174v-667h-174zM70 0v667h174v-260h84q136 0 199 -62q53 -52 53 -141t-50 -140q-63 -64 -212 -64h-248zM244 134h67q55 0 75 20q18 18 18 50t-19 49q-21 20 -74 20h-67v-139zM552 723q-36 0 -61 27q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62 q0 -33 -26 -61q-26 -26 -61 -26zM325 723q-36 0 -61 27q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62q0 -33 -26 -61q-26 -26 -61 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F9",
    unicode: "\u04F9",
    horizAdvX: 742,
    d: "M527 0v447h160v-447h-160zM215 298h109q78 0 120 -40q40 -39 40 -107q0 -69 -38 -107q-44 -44 -122 -44h-269v447h160v-149zM215 104h60q29 0 43 14q11 11 11 32q0 22 -12 32q-15 12 -44 12h-58v-90zM486 523q-36 0 -61 27q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25 q27 -27 27 -62q0 -33 -26 -61q-26 -26 -61 -26zM259 523q-36 0 -61 27q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62q0 -33 -26 -61q-26 -26 -61 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2010",
    unicode: "\u2010",
    horizAdvX: 353,
    d: "M50 202v133h253v-133h-253z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2011",
    unicode: "\u2011",
    horizAdvX: 353,
    d: "M50 202v133h253v-133h-253z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "figuredash",
    unicode: "\u2012",
    horizAdvX: 574,
    d: "M70 275v132h434v-132h-434z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 574,
    d: "M70 199v132h434v-132h-434z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 907,
    d: "M70 199v132h767v-132h-767z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii00208",
    unicode: "\u2015",
    horizAdvX: 907,
    d: "M70 199v132h767v-132h-767z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 345,
    d: "M312 667l-115 -294h-150l162 294h103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 448,
    d: "M33 373l115 294h151l-163 -294h-103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 459,
    d: "M33 -149l126 316h151l-174 -316h-103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 572,
    d: "M539 667l-115 -294h-151l163 294h103zM312 667l-115 -294h-150l162 294h103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 675,
    d: "M33 373l115 294h151l-163 -294h-103zM260 373l115 294h150l-162 -294h-103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 683,
    d: "M260 -149l123 316h150l-170 -316h-103zM33 -149l123 316h150l-170 -316h-103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 600,
    d: "M226 531v198h147v-198h157v-127h-157v-592h-147v592h-156v127h156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 600,
    d: "M227 531v198h147v-198h155v-127h-155v-216h155v-127h-155v-249h-147v249h-156v127h156v216h-156v127h156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 1000,
    d: "M362 340q0 58 40 98q42 42 98 42q55 0 96 -41q42 -42 42 -99q0 -58 -45 -102q-40 -38 -93 -38t-94 38q-44 40 -44 102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 909,
    d: "M151 189q42 0 73 -31t31 -73t-31 -73t-73 -31t-74 32q-29 29 -29 72t30 73q31 31 73 31zM454 189q42 0 73 -31t31 -73t-31 -73t-73 -31t-74 32q-29 29 -29 72t30 73q31 31 73 31zM757 189q42 0 73 -31t31 -73t-31 -73t-73 -31t-74 32q-29 29 -29 72t30 73q31 31 73 31z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 1324,
    d: "M214 347q-88 0 -139 53q-42 45 -42 108q0 69 41 113q47 53 140 53q91 0 142 -53q42 -44 42 -110t-43 -111q-51 -53 -141 -53zM211 0l386 667h87l-387 -667h-86zM216 586q-34 0 -55 -23q-20 -22 -20 -52q0 -34 26 -57q20 -18 49 -18q30 0 53 21q22 22 22 54q0 33 -24 56 q-20 19 -51 19zM680 231q-34 0 -55 -23q-20 -22 -20 -52q0 -34 26 -57q20 -18 49 -18q30 0 53 21q22 22 22 54q0 34 -24 56q-20 19 -51 19zM678 -8q-88 0 -139 53q-42 45 -42 108q0 69 41 113q47 53 140 53q91 0 142 -53q42 -44 42 -110t-43 -111q-51 -53 -141 -53z M1109 231q-34 0 -55 -23q-20 -22 -20 -52q0 -34 26 -57q20 -18 49 -18q30 0 53 21q22 22 22 54q0 34 -24 56q-20 19 -51 19zM1107 -8q-88 0 -139 53q-42 45 -42 108q0 69 41 113q47 53 140 53q91 0 142 -53q42 -44 42 -110t-43 -111q-51 -53 -141 -53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 311,
    d: "M268 384l-111 -156l114 -154l-91 -64l-152 218l152 217z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 311,
    d: "M38 74l114 154l-111 156l88 61l152 -217l-152 -218z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 273,
    d: "M-100 0l386 667h87l-387 -667h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    horizAdvX: 600,
    d: "M544 190v-167q-75 -38 -172 -38q-131 0 -211 62q-78 60 -103 168h-78l36 90h30q-2 23 0 50h-66l36 90h43q26 107 112 171q88 65 221 65q104 0 182 -44l-58 -146q-60 38 -131 38q-59 0 -98 -22q-40 -21 -54 -62h268l-36 -90h-250q-3 -22 1 -50h229l-36 -90h-171 q16 -37 56 -58q38 -20 95 -20q94 0 155 53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B4",
    unicode: "\u20B4",
    horizAdvX: 600,
    d: "M148 498l-67 127q107 57 240 57q100 0 148 -35q54 -41 54 -107q0 -48 -29 -80h68v-105h-151l-66 -62h217v-104h-292q-13 -13 -13 -31q0 -21 18 -31q19 -11 62 -11q80 0 150 37l69 -118q-116 -56 -262 -56q-105 0 -158 33q-62 40 -62 109q0 37 24 68h-58v104h129l66 62 h-195v105h278q16 16 16 36q0 21 -16 34q-19 13 -52 13q-59 0 -118 -45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20B6",
    horizAdvX: 600,
    d: "M86 667h276q110 0 171 -57q60 -55 60 -153q0 -102 -59 -156q-61 -56 -166 -56h-109v-56h186v-104h-186v-85h-173v85h-82v104h82v56h-82v120h82v302zM259 527v-162h58q50 0 73 21q22 20 22 61q0 36 -20 56q-24 24 -74 24h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20CF",
    horizAdvX: 600,
    d: "M86 667h276q110 0 171 -57q60 -55 60 -153q0 -102 -59 -156q-61 -56 -166 -56h-109v-56h186v-104h-186v-85h-173v85h-82v104h82v56h-82v120h82v302zM259 527v-162h58q50 0 73 21q22 20 22 61q0 36 -20 56q-24 24 -74 24h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20CE",
    horizAdvX: 600,
    d: "M86 667h276q110 0 171 -57q60 -55 60 -153q0 -102 -59 -156q-61 -56 -166 -56h-109v-56h186v-104h-186v-85h-173v85h-82v104h82v56h-82v120h82v302zM259 527v-162h58q50 0 73 21q22 20 22 61q0 36 -20 56q-24 24 -74 24h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20CD",
    horizAdvX: 600,
    d: "M86 667h276q110 0 171 -57q60 -55 60 -153q0 -102 -59 -156q-61 -56 -166 -56h-109v-56h186v-104h-186v-85h-173v85h-82v104h82v56h-82v120h82v302zM259 527v-162h58q50 0 73 21q22 20 22 61q0 36 -20 56q-24 24 -74 24h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20CC",
    horizAdvX: 600,
    d: "M86 667h276q110 0 171 -57q60 -55 60 -153q0 -102 -59 -156q-61 -56 -166 -56h-109v-56h186v-104h-186v-85h-173v85h-82v104h82v56h-82v120h82v302zM259 527v-162h58q50 0 73 21q22 20 22 61q0 36 -20 56q-24 24 -74 24h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20CB",
    horizAdvX: 600,
    d: "M86 667h276q110 0 171 -57q60 -55 60 -153q0 -102 -59 -156q-61 -56 -166 -56h-109v-56h186v-104h-186v-85h-173v85h-82v104h82v56h-82v120h82v302zM259 527v-162h58q50 0 73 21q22 20 22 61q0 36 -20 56q-24 24 -74 24h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20CA",
    horizAdvX: 600,
    d: "M86 667h276q110 0 171 -57q60 -55 60 -153q0 -102 -59 -156q-61 -56 -166 -56h-109v-56h186v-104h-186v-85h-173v85h-82v104h82v56h-82v120h82v302zM259 527v-162h58q50 0 73 21q22 20 22 61q0 36 -20 56q-24 24 -74 24h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C9",
    horizAdvX: 600,
    d: "M86 667h276q110 0 171 -57q60 -55 60 -153q0 -102 -59 -156q-61 -56 -166 -56h-109v-56h186v-104h-186v-85h-173v85h-82v104h82v56h-82v120h82v302zM259 527v-162h58q50 0 73 21q22 20 22 61q0 36 -20 56q-24 24 -74 24h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C8",
    horizAdvX: 600,
    d: "M86 667h276q110 0 171 -57q60 -55 60 -153q0 -102 -59 -156q-61 -56 -166 -56h-109v-56h186v-104h-186v-85h-173v85h-82v104h82v56h-82v120h82v302zM259 527v-162h58q50 0 73 21q22 20 22 61q0 36 -20 56q-24 24 -74 24h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C7",
    horizAdvX: 600,
    d: "M86 667h276q110 0 171 -57q60 -55 60 -153q0 -102 -59 -156q-61 -56 -166 -56h-109v-56h186v-104h-186v-85h-173v85h-82v104h82v56h-82v120h82v302zM259 527v-162h58q50 0 73 21q22 20 22 61q0 36 -20 56q-24 24 -74 24h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C6",
    horizAdvX: 600,
    d: "M86 667h276q110 0 171 -57q60 -55 60 -153q0 -102 -59 -156q-61 -56 -166 -56h-109v-56h186v-104h-186v-85h-173v85h-82v104h82v56h-82v120h82v302zM259 527v-162h58q50 0 73 21q22 20 22 61q0 36 -20 56q-24 24 -74 24h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C5",
    horizAdvX: 600,
    d: "M86 667h276q110 0 171 -57q60 -55 60 -153q0 -102 -59 -156q-61 -56 -166 -56h-109v-56h186v-104h-186v-85h-173v85h-82v104h82v56h-82v120h82v302zM259 527v-162h58q50 0 73 21q22 20 22 61q0 36 -20 56q-24 24 -74 24h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C4",
    horizAdvX: 600,
    d: "M86 667h276q110 0 171 -57q60 -55 60 -153q0 -102 -59 -156q-61 -56 -166 -56h-109v-56h186v-104h-186v-85h-173v85h-82v104h82v56h-82v120h82v302zM259 527v-162h58q50 0 73 21q22 20 22 61q0 36 -20 56q-24 24 -74 24h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C3",
    horizAdvX: 600,
    d: "M86 667h276q110 0 171 -57q60 -55 60 -153q0 -102 -59 -156q-61 -56 -166 -56h-109v-56h186v-104h-186v-85h-173v85h-82v104h82v56h-82v120h82v302zM259 527v-162h58q50 0 73 21q22 20 22 61q0 36 -20 56q-24 24 -74 24h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C2",
    horizAdvX: 600,
    d: "M86 667h276q110 0 171 -57q60 -55 60 -153q0 -102 -59 -156q-61 -56 -166 -56h-109v-56h186v-104h-186v-85h-173v85h-82v104h82v56h-82v120h82v302zM259 527v-162h58q50 0 73 21q22 20 22 61q0 36 -20 56q-24 24 -74 24h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C1",
    horizAdvX: 600,
    d: "M86 667h276q110 0 171 -57q60 -55 60 -153q0 -102 -59 -156q-61 -56 -166 -56h-109v-56h186v-104h-186v-85h-173v85h-82v104h82v56h-82v120h82v302zM259 527v-162h58q50 0 73 21q22 20 22 61q0 36 -20 56q-24 24 -74 24h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C0",
    horizAdvX: 600,
    d: "M86 667h276q110 0 171 -57q60 -55 60 -153q0 -102 -59 -156q-61 -56 -166 -56h-109v-56h186v-104h-186v-85h-173v85h-82v104h82v56h-82v120h82v302zM259 527v-162h58q50 0 73 21q22 20 22 61q0 36 -20 56q-24 24 -74 24h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20BF",
    horizAdvX: 600,
    d: "M86 667h276q110 0 171 -57q60 -55 60 -153q0 -102 -59 -156q-61 -56 -166 -56h-109v-56h186v-104h-186v-85h-173v85h-82v104h82v56h-82v120h82v302zM259 527v-162h58q50 0 73 21q22 20 22 61q0 36 -20 56q-24 24 -74 24h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20BE",
    horizAdvX: 600,
    d: "M86 667h276q110 0 171 -57q60 -55 60 -153q0 -102 -59 -156q-61 -56 -166 -56h-109v-56h186v-104h-186v-85h-173v85h-82v104h82v56h-82v120h82v302zM259 527v-162h58q50 0 73 21q22 20 22 61q0 36 -20 56q-24 24 -74 24h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20BD",
    horizAdvX: 600,
    d: "M86 667h276q110 0 171 -57q60 -55 60 -153q0 -102 -59 -156q-61 -56 -166 -56h-109v-56h186v-104h-186v-85h-173v85h-82v104h82v56h-82v120h82v302zM259 527v-162h58q50 0 73 21q22 20 22 61q0 36 -20 56q-24 24 -74 24h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20BC",
    horizAdvX: 600,
    d: "M86 667h276q110 0 171 -57q60 -55 60 -153q0 -102 -59 -156q-61 -56 -166 -56h-109v-56h186v-104h-186v-85h-173v85h-82v104h82v56h-82v120h82v302zM259 527v-162h58q50 0 73 21q22 20 22 61q0 36 -20 56q-24 24 -74 24h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20BB",
    horizAdvX: 600,
    d: "M86 667h276q110 0 171 -57q60 -55 60 -153q0 -102 -59 -156q-61 -56 -166 -56h-109v-56h186v-104h-186v-85h-173v85h-82v104h82v56h-82v120h82v302zM259 527v-162h58q50 0 73 21q22 20 22 61q0 36 -20 56q-24 24 -74 24h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20BA",
    horizAdvX: 600,
    d: "M86 667h276q110 0 171 -57q60 -55 60 -153q0 -102 -59 -156q-61 -56 -166 -56h-109v-56h186v-104h-186v-85h-173v85h-82v104h82v56h-82v120h82v302zM259 527v-162h58q50 0 73 21q22 20 22 61q0 36 -20 56q-24 24 -74 24h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20B9",
    horizAdvX: 600,
    d: "M86 667h276q110 0 171 -57q60 -55 60 -153q0 -102 -59 -156q-61 -56 -166 -56h-109v-56h186v-104h-186v-85h-173v85h-82v104h82v56h-82v120h82v302zM259 527v-162h58q50 0 73 21q22 20 22 61q0 36 -20 56q-24 24 -74 24h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20B7",
    horizAdvX: 600,
    d: "M86 667h276q110 0 171 -57q60 -55 60 -153q0 -102 -59 -156q-61 -56 -166 -56h-109v-56h186v-104h-186v-85h-173v85h-82v104h82v56h-82v120h82v302zM259 527v-162h58q50 0 73 21q22 20 22 61q0 36 -20 56q-24 24 -74 24h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B8",
    unicode: "\u20B8",
    horizAdvX: 600,
    d: "M529 380h-144v-380h-173v380h-141v137h458v-137zM529 560h-458v107h458v-107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii61352",
    unicode: "\u2116",
    horizAdvX: 1163,
    d: "M243 0h-173v667h173l319 -408v408h173v-667h-173l-319 408v-408zM966 351q-82 0 -132 48q-45 45 -45 109q0 67 45 110q49 49 132 49q81 0 129 -47q47 -45 47 -112q0 -64 -46 -110q-47 -47 -130 -47zM814 192v95h303v-95h-303zM965 576q-29 0 -47 -17q-20 -18 -20 -51 q0 -31 19 -50q18 -18 48 -18q31 0 49 18q19 19 19 50q0 32 -19 51q-17 17 -49 17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2117",
    unicode: "\u2117",
    horizAdvX: 771,
    d: "M272 529h148q74 0 111 -36q33 -33 33 -90q0 -58 -33 -91q-36 -36 -110 -36h-32v-126h-117v379zM389 441v-77h7q27 0 39 9q14 10 14 30q0 19 -15 29q-12 9 -38 9h-7zM751 333q0 -67 -27 -132.5t-75 -113.5q-49 -49 -116.5 -75.5t-134.5 -26.5q-66 0 -133 26.5t-117 75.5 q-48 48 -75 113.5t-27 132.5q0 68 27 133.5t75 113.5q50 49 117 75.5t133 26.5q67 0 134.5 -26.5t116.5 -75.5q48 -48 75 -113.5t27 -133.5zM398 619q-116 0 -198 -82q-84 -84 -84 -204t84 -204q82 -82 198 -82q117 0 199 82q84 84 84 204t-84 204q-82 82 -199 82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 777,
    d: "M264 578h-81v-291h-103v291h-80v89h264v-89zM386 287h-103l63 380h103l72 -195l77 195h103l56 -380h-103l-26 206l-85 -206h-46l-81 206z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "partialdiff",
    unicode: "\u2202",
    horizAdvX: 561,
    d: "M87 567l17 110q85 -6 167.5 -35t140.5 -84q63 -59 89 -136t26 -147q0 -137 -76 -218q-65 -69 -175 -69q-105 0 -172 64q-70 69 -70 169q0 96 67 161q58 57 145 57q71 0 123 -40q-34 80 -106 120q-73 41 -176 48zM281 110q40 0 68 27q34 34 34 82q0 52 -35 82 q-27 24 -71 24q-42 0 -70 -25q-35 -32 -35 -81q0 -47 32 -79q30 -30 77 -30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "product",
    unicode: "\u220F",
    horizAdvX: 733,
    d: "M40 630v120h653v-120h-82v-760h82v-120h-293v120h73v760h-212v-760h71v-120h-292v120h83v760h-83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "summation",
    unicode: "\u2211",
    horizAdvX: 667,
    d: "M21 750h599v-247h-117l-13 127h-315l250 -363l-250 -397h324l8 130h122v-250h-608v130l243 387l-243 353v130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    d: "M33 280v120h434v-120h-434z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2215",
    unicode: "\u2215",
    horizAdvX: 672,
    d: "M-30 -188l511 917h131l-512 -917h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2219",
    unicode: "\u2219",
    horizAdvX: 248,
    d: "M124 229q-50 0 -85 34q-39 37 -39 90t39 91q36 34 85 34t83 -33q41 -39 41 -92q0 -51 -36 -87q-37 -37 -88 -37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "radical",
    unicode: "\u221A",
    horizAdvX: 667,
    d: "M375 827h292v-117h-179l-165 -710h-172l-57 271h-94v116h202l18 -84q6 -37 9 -73q4 -32 4 -60v-13h11l1 19q2 39 16 132q12 75 26 139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "infinity",
    unicode: "\u221E",
    horizAdvX: 667,
    d: "M488 176q-52 0 -91 25q-34 21 -60 54q-31 -36 -68 -57q-37 -22 -89 -22q-72 0 -119 48q-44 44 -44 113q0 70 46 118q47 47 116 47q46 0 88 -24q35 -20 63 -54q34 40 74 59t82 19q69 0 116 -44q48 -44 48 -118q0 -72 -48 -120q-43 -44 -114 -44zM466 386q-21 0 -41 -17 q-18 -14 -28 -30q13 -18 28 -30q20 -16 41 -16q23 0 36 14q14 14 14 33q0 18 -13 31q-17 15 -37 15zM200 386q-20 0 -35 -13q-14 -14 -14 -35q0 -18 13 -31q13 -14 36 -14q21 0 41 16q15 12 28 30q-10 16 -28 30q-20 17 -41 17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "integral",
    unicode: "\u222B",
    d: "M317 563v-538q0 -95 -4 -127q-6 -65 -43 -102q-46 -46 -134 -46q-44 0 -90 10l24 116q27 -10 56 -10q26 0 40 13q17 16 17 58v538q0 115 10 155q10 44 35 71q45 49 134 49q40 0 92 -10l-24 -116q-30 10 -56 10q-25 0 -39 -13q-18 -16 -18 -58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "approxequal",
    unicode: "\u2248",
    d: "M264 367l-32 12q-57 22 -82 22t-43 -17q-16 -16 -29 -44l-71 47l7 15q30 65 52 86q40 38 93 38q28 0 81 -19l42 -15q44 -16 66 -16q28 0 45 16q14 13 27 36l73 -43l-6 -13q-22 -50 -50 -78q-42 -43 -95 -43q-32 0 -78 16zM264 164l-32 12q-57 22 -82 22t-43 -17 q-16 -16 -29 -44l-71 47l7 15q30 65 52 86q40 38 93 38q28 0 81 -19l42 -15q44 -16 66 -16q28 0 45 16q14 13 27 36l73 -43l-6 -13q-22 -50 -50 -78q-42 -43 -95 -43q-32 0 -78 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\u2260",
    d: "M34 471h228l55 108h102l-54 -108h102v-116h-155l-34 -67h189v-117h-241l-49 -95h-102l47 95h-88v117h141l34 67h-175v116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lessequal",
    unicode: "\u2264",
    d: "M33 462l434 207v-121l-297 -141l297 -141v-121l-434 208v109zM33 117h434v-117h-434v117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greaterequal",
    unicode: "\u2265",
    d: "M467 353l-434 -208v121l297 141l-297 141v121l434 -207v-109zM467 0h-434v117h434v-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotmath",
    unicode: "\u22C5",
    horizAdvX: 248,
    d: "M124 229q-50 0 -85 34q-39 37 -39 90t39 91q36 34 85 34t83 -33q41 -39 41 -92q0 -51 -36 -87q-37 -37 -88 -37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lozenge",
    unicode: "\u25CA",
    horizAdvX: 819,
    d: "M74 334l259 359l260 -359l-260 -360zM441 334l-108 148l-107 -148l107 -148z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "openbullet",
    unicode: "\u25E6",
    d: "M252 363q-66 0 -111 45t-45 108q0 62 45 106q46 45 108 45q64 0 110 -44q45 -43 45 -107q0 -63 -45 -108t-107 -45zM178 515q0 -30 20.5 -50t51.5 -20t51.5 20t20.5 50t-20.5 50t-51.5 20t-51.5 -20t-20.5 -50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF400",
    unicode: "\uF400",
    horizAdvX: 2,
    d: "M-224 729l101 -73l-154 -136l-74 55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF401",
    unicode: "\uF401",
    horizAdvX: 2,
    d: "M-264 929l101 -73l-154 -136l-74 55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF406",
    unicode: "\uF406",
    d: "M321 877h103q-1 -66 -44 -109q-45 -45 -130 -45t-130 45q-43 43 -44 109h103q3 -26 20 -41q20 -18 51 -18t51 18q17 15 20 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF407",
    unicode: "\uF407",
    d: "M282 -46l112 -44l-116 -146l-92 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF408",
    unicode: "\uF408",
    d: "M121 720l-68 77l196 147l198 -147l-71 -77l-127 98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF409",
    unicode: "\uF409",
    d: "M150 -248l52 198l150 -16l-102 -194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF40A",
    unicode: "\uF40A",
    d: "M148 470l54 210l150 -26l-104 -202z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF40B",
    unicode: "\uF40B",
    d: "M250 723q-36 0 -64 26q-27 27 -27 63q0 40 27 67q26 26 64 26t64 -26q27 -27 27 -65q0 -39 -27 -65t-64 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF40C",
    unicode: "\uF40C",
    d: "M387 826q0 -40 -26 -66q-37 -37 -111 -37t-111 37q-26 26 -26 66q0 41 26 67q37 37 111 37t111 -37q26 -26 26 -67zM250 867q-28 0 -43 -15q-10 -10 -10 -25t10 -25q15 -15 43 -15t43 15q10 10 10 25t-10 25q-15 15 -43 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF40D",
    unicode: "\uF40D",
    d: "M351 867l77 -46q-18 -45 -44 -69q-29 -29 -72 -29q-26 0 -58 15l-30 15q-24 12 -36 12q-28 0 -38 -42l-78 46q15 44 40 68q30 28 70 28q27 0 60 -14l29 -13q33 -15 43 -15q24 0 37 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF40E",
    unicode: "\uF40E",
    d: "M361 -89l-22 -86q-31 -18 -66 -18q-47 0 -73 28q-21 23 -21 52q0 32 20 61q23 33 56 52h74q-27 -18 -39 -30q-19 -19 -19 -39q0 -16 11 -27t29 -11q25 0 50 18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF4C6",
    unicode: "\uF4C6",
    horizAdvX: 660,
    d: "M416 667h174v-735q0 -87 -43 -126q-40 -36 -129 -36q-62 0 -95 10v114q14 -6 34 -6q32 0 46 14q13 13 13 47v313q-66 -10 -139 -10q-129 0 -182 50t-53 158v207h174v-181q0 -49 20 -69q21 -21 82 -21q53 0 98 7v264z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF4C7",
    unicode: "\uF4C7",
    horizAdvX: 538,
    d: "M323 447h160v-518q0 -85 -42 -124q-38 -35 -124 -35q-46 0 -86 8v113q12 -6 31 -6q34 0 48 15q13 14 13 55v191q-44 -11 -96 -11q-101 0 -145 44q-40 40 -40 127v141h154v-130q0 -37 17 -51q14 -12 52 -12q36 0 58 7v186z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF4CC",
    unicode: "\uF4CC",
    horizAdvX: 623,
    d: "M0 667h194l127 -297l111 297h185l-300 -667h-183l93 187zM364 929l101 -73l-154 -136l-74 55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF4CD",
    unicode: "\uF4CD",
    horizAdvX: 604,
    d: "M66 -229l150 290l-216 386h186l119 -229l116 229h183l-359 -676h-179zM357 729l101 -73l-154 -136l-74 55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar.fitted",
    unicode: "\uF5F5",
    horizAdvX: 520,
    d: "M225 775h100v-110q73 -4 151 -51l-66 -128q-56 43 -112 43q-41 0 -60 -18q-15 -13 -15 -33q0 -19 14 -33q17 -15 46 -25l52 -18q78 -26 116 -63q50 -49 50 -122q0 -92 -56 -151q-45 -46 -120 -65v-113h-100v108q-57 1 -113 24q-53 22 -97 57l72 134q36 -35 69 -51 q48 -23 91 -23q42 0 65 23q18 18 18 42q0 23 -20 38q-14 10 -45 20l-59 20q-77 26 -110 62q-43 44 -43 116q0 86 50 141q47 52 122 66v110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro.fitted",
    unicode: "\uF5F6",
    horizAdvX: 646,
    d: "M583 190v-167q-75 -38 -172 -38q-131 0 -211 62q-78 60 -103 168h-78l36 90h30q-2 23 0 50h-66l36 90h43q26 107 112 171q88 65 221 65q104 0 182 -44l-58 -146q-60 38 -131 38q-60 0 -98 -22q-40 -21 -54 -62h268l-36 -90h-250q-3 -22 1 -50h229l-36 -90h-171 q16 -37 56 -58q38 -20 95 -20q94 0 155 53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent.fitted",
    unicode: "\uF5F7",
    horizAdvX: 400,
    d: "M222 660h94v-91q27 -2 52 -15v-144q-34 34 -80 34q-45 0 -75 -30q-33 -33 -33 -80q0 -48 33 -79q31 -28 75 -28q46 0 80 34v-144q-27 -13 -52 -14v-93h-94v87q-85 12 -143 70q-67 69 -67 168q0 104 71 173q54 54 139 67v85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling.fitted",
    unicode: "\uF5F8",
    horizAdvX: 624,
    d: "M162 252h-125v96h72q-24 56 -24 106q0 93 66 158q69 67 196 67q119 0 180 -62q60 -60 60 -164q0 -18 -1 -25h-174q1 8 1 24q0 46 -24 70q-23 21 -55 21q-36 0 -59 -25q-24 -27 -24 -69q0 -44 25 -101h153v-96h-125q4 -28 4 -50q0 -26 -8 -55l47 -14q67 -20 94 -20 q21 0 32.5 12.5t11.5 31.5h108q-2 -85 -56 -135q-39 -36 -102 -36q-44 0 -106 20l-38 12q-48 15 -89 15q-47 0 -61 -33h-115q13 70 54 112q35 37 88 45q6 18 6 42q0 27 -12 53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen.fitted",
    unicode: "\uF5F9",
    horizAdvX: 635,
    d: "M225 329h-163v105h100l-141 233h197l100 -192l96 192h200l-147 -233h105v-105h-171l-6 -9v-53h177v-104h-177v-163h-164v163h-169v104h169v53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin.fitted",
    unicode: "\uF5FA",
    horizAdvX: 618,
    d: "M214 113l43 238h-76l16 96h78l21 111q17 86 58 128q53 54 146 54q58 0 107 -25l-26 -139q-27 22 -62 22q-29 0 -46 -18q-14 -17 -24 -68l-12 -65h97l-18 -96h-97l-46 -257q-28 -155 -87 -216q-65 -66 -190 -66q-47 0 -86 9l26 146q25 -9 57 -9q47 0 71 22q31 27 50 133z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B4.fitted",
    unicode: "\uF5FB",
    horizAdvX: 570,
    d: "M131 498l-67 127q107 57 240 57q100 0 148 -35q54 -41 54 -107q0 -48 -29 -80h68v-105h-151l-66 -62h217v-104h-292q-13 -13 -13 -31q0 -21 18 -31q19 -11 62 -11q80 0 150 37l69 -118q-116 -56 -262 -56q-105 0 -158 33q-62 40 -62 109q0 37 24 68h-58v104h129l66 62 h-195v105h278q16 16 16 36q0 21 -16 34q-19 13 -52 13q-59 0 -118 -45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6.fitted",
    unicode: "\uF5FC",
    horizAdvX: 629,
    d: "M106 667h276q110 0 171 -57q60 -55 60 -153q0 -102 -59 -156q-61 -56 -166 -56h-109v-56h186v-104h-186v-85h-173v85h-82v104h82v56h-82v120h82v302zM279 527v-162h58q50 0 73 21q22 20 22 61q0 36 -20 56q-24 24 -74 24h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B8.fitted",
    unicode: "\uF5FD",
    horizAdvX: 496,
    d: "M477 380h-144v-380h-173v380h-141v137h458v-137zM477 560h-458v107h458v-107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign.fitted",
    unicode: "\uF5FF",
    horizAdvX: 636,
    d: "M487 299h101l-17 -117h-102l-29 -182h-134l30 182h-85l-29 -182h-132l30 182h-102l18 117h101l14 83h-101l18 116h101l27 169h132l-28 -169h85l27 169h133l-27 -169h100l-18 -116h-100zM354 299l13 83h-85l-13 -83h85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF639",
    unicode: "\uF639",
    horizAdvX: 624,
    d: "M312 527q-30 0 -53 -21q-26 -22 -42 -73.5t-16 -100.5q0 -45 15.5 -97.5t42.5 -76.5q23 -21 53 -21t53 21q26 23 42 74.5t16 98.5t-16.5 100t-41.5 75q-23 21 -53 21zM595 333q0 -175 -99 -272q-77 -76 -184 -76t-184 76q-99 97 -99 272q0 176 99 273q77 76 184 76 t184 -76q99 -97 99 -273z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF63A",
    unicode: "\uF63A",
    horizAdvX: 595,
    d: "M561 147v-147h-535l169 177q91 95 137 169q36 56 36 104q0 42 -20 64q-18 20 -49 20q-37 0 -58 -27q-22 -28 -24 -82h-179q1 112 74 185q72 72 189 72q119 0 188 -69q65 -65 65 -164q0 -106 -99 -198l-112 -104h218z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF63B",
    unicode: "\uF63B",
    horizAdvX: 583,
    d: "M22 228h177q2 -42 27 -67q24 -26 68 -26q41 0 68 29q20 23 20 55q0 37 -26 59q-23 19 -64 19q-17 0 -29 -4v117q44 -6 71 17q22 19 22 47q0 30 -18 48t-49 18t-48 -17q-23 -21 -23 -59h-161q5 93 65 153q62 65 176 65q106 0 166 -59q54 -54 54 -129q0 -46 -20 -82 q-19 -35 -51 -51q49 -18 79 -61q28 -41 28 -98q0 -87 -59 -146q-71 -71 -199 -71q-117 0 -191 69q-73 67 -83 174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF63C",
    unicode: "\uF63C",
    horizAdvX: 602,
    d: "M495 667v-408h81v-133h-81v-126h-160v126h-323v111l257 430h226zM178 259h157v272z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF63D",
    unicode: "\uF63D",
    horizAdvX: 553,
    d: "M476 667v-147h-231l-12 -74q31 5 54 5q112 0 176 -66q61 -61 61 -158q0 -101 -64 -167q-73 -75 -208 -75q-130 0 -225 60l26 162q38 -35 80 -54q49 -23 100 -23q56 0 87 33q26 28 26 68q0 44 -32 72q-37 33 -120 33q-67 0 -123 -28l58 359h347z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF63E",
    unicode: "\uF63E",
    horizAdvX: 608,
    d: "M271 667h197l-190 -227q47 21 93 21q87 0 151 -64q63 -63 63 -159q0 -105 -69 -174q-79 -79 -213 -79q-140 0 -219 81q-61 63 -61 156q0 118 99 249zM300 122q46 0 77 31t31 76q0 40 -31 70q-32 31 -77 31q-43 0 -75 -29q-33 -30 -33 -69q0 -45 29 -76q33 -34 79 -34z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF63F",
    unicode: "\uF63F",
    horizAdvX: 614,
    d: "M34 0l304 520h-278v147h547l-382 -667h-191z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF640",
    unicode: "\uF640",
    horizAdvX: 567,
    d: "M401 351q50 -15 86 -51q51 -50 51 -118q0 -72 -54 -126q-71 -71 -202 -71q-129 0 -199 70q-55 55 -55 127q0 32 14 65.5t35 54.5q33 33 84 49q-36 14 -60 38q-45 45 -45 106q0 74 55 126q66 61 178 61q110 0 172 -64q49 -49 49 -122q0 -63 -41 -104q-27 -27 -68 -41z M285 566q-34 0 -55 -23q-20 -22 -20 -51q0 -25 21 -48q21 -22 53 -22q29 0 49 20q23 23 23 51q0 32 -23 53q-22 20 -48 20zM283 281q-31 0 -56 -23q-24 -24 -24 -55q0 -33 23 -56q24 -24 57 -24t56 23q24 24 24 57t-24 55q-24 23 -56 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF641",
    unicode: "\uF641",
    horizAdvX: 612,
    d: "M339 0h-196l189 225q-39 -21 -89 -21q-91 0 -153 61q-67 66 -67 161q0 102 67 172q82 84 219 84q135 0 214 -79q66 -68 66 -165q0 -114 -101 -245zM311 545q-45 0 -77 -32q-33 -33 -33 -76q0 -42 32 -72t78 -30q44 0 75 28q35 31 35 76q0 42 -32 74q-34 32 -78 32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6BA",
    unicode: "\uF6BA",
    horizAdvX: 353,
    d: "M50 274v133h253v-133h-253z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6BB",
    unicode: "\uF6BB",
    horizAdvX: 574,
    d: "M70 275v132h434v-132h-434z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6BC",
    unicode: "\uF6BC",
    horizAdvX: 907,
    d: "M70 275v132h767v-132h-767z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6C3",
    unicode: "\uF6C3",
    d: "M150 -238l52 188l150 -16l-102 -184z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6C9",
    unicode: "\uF6C9",
    d: "M303 929l101 -73l-154 -136l-74 55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6CA",
    unicode: "\uF6CA",
    d: "M249 720l-196 147l68 77l128 -98l127 98l71 -77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6CB",
    unicode: "\uF6CB",
    d: "M363 723q-36 0 -61 27q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62q0 -33 -26 -61q-26 -26 -61 -26zM136 723q-36 0 -61 27q-25 28 -25 60t26 61q26 26 60 26q35 0 60 -25q27 -27 27 -62q0 -33 -26 -61q-26 -26 -61 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6CE",
    unicode: "\uF6CE",
    d: "M250 720l-154 136l102 73l126 -154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6CF",
    unicode: "\uF6CF",
    d: "M219 929l83 -73l-137 -136l-54 55zM392 929l84 -73l-137 -136l-55 55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6D0",
    unicode: "\uF6D0",
    d: "M62 749v98h376v-98h-376z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6D1",
    unicode: "\uF6D1",
    d: "M343 895l116 -44q-24 -66 -82 -97q-47 -26 -128 -26q-78 0 -126 26q-58 31 -82 97l116 44q10 -31 32 -47t61 -16q38 0 61 16q22 16 32 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6D4",
    unicode: "\uF6D4",
    d: "M327 676l107 -38q-16 -60 -68 -92q-44 -28 -116 -28t-116 28q-52 32 -68 92l107 38q8 -27 23 -42q19 -20 54 -20t54 20q15 15 23 42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6DC",
    unicode: "\uF6DC",
    horizAdvX: 329,
    d: "M114 0v520h-95v147h268v-667h-173z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6DE",
    unicode: "\uF6DE",
    horizAdvX: 680,
    d: "M52 199v132h576v-132h-576z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nbspace",
    horizAdvX: 233
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphenminus",
    horizAdvX: 353,
    d: "M50 202v133h253v-133h-253z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi1",
    horizAdvX: 267,
    d: "M53 447h160v-447h-160v447z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "S",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "O",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "G",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "C",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "Q",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u04AE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u045E",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0459",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0442",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0434",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0414",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0409",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "7",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "4",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "1",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: ",",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "9",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "8",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "7",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "6",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "5",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "4",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "3",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "2",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "1",
    k: 162
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "0",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: ".",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "7",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "1",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "7",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "1",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "7",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "4",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "1",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "7",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "1",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "7",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "4",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "1",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ",",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ":",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "8",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "7",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "6",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "5",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "4",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "3",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "1",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ".",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "7",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "1",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "7",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "1",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "0",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    g2: "hyphenminus",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u2018",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "Q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "J",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "*",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u2019",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "Y",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "V",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "T",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "C",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u2122",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u201D",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "X",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u2122",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u201D",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "x",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "X",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "M",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "J",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u2122",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "hyphenminus",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\uF6BC",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\uF6BB",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\uF6BA",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2014",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2013",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2012",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2011",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2010",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "z",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "t",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "s",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "i",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "e",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "d",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "c",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "a",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "S",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "A",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ".",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "-",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ",",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2122",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "x",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "J",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\u2122",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\u201D",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "X",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "J",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "H",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u2122",
    k: -88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "x",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u2122",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "v",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "q",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "p",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "Q",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "J",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u2122",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u201D",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "v",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "Q",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "*",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\u2019",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "y",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "w",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "Y",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\u2122",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\u201D",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "N",
    u2: "\u2122",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u201D",
    k: -88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "x",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "X",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "M",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "J",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "y",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "w",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "t",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "s",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "o",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "g",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "e",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "d",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "c",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "a",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "Z",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "Y",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "T",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "A",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ".",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ",",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "hyphenminus",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u2122",
    k: -87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "x",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "v",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "q",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "X",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "M",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "J",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u201D",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u2019",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "Y",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u2122",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "x",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "J",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\u2122",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\u201D",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "X",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "J",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "x",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "v",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "q",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "p",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "m",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "k",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "j",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "J",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u2122",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2122",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "x",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "v",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "q",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "p",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "m",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "k",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "f",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "b",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "M",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "J",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u2122",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "x",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "v",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "p",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "m",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "J",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "y",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "w",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "u",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "o",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "g",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "e",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "d",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "c",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "a",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "S",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "O",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "G",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "C",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "x",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "v",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "q",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "p",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "Q",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u2039",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u2026",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "x",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "v",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "q",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "p",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "m",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "h",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "f",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "b",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "Q",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "M",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "J",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ".",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "v",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "q",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "Q",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "M",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\u201D",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\u2018",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "x",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "J",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "f",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "x",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "v",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "h",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "f",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "b",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "Q",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "J",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "\u201D",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "\u2019",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "Q",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "Q",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "Y",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "T",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\u201C",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\u2018",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "x",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "w",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "Y",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "T",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "A",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "X",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "Y",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "f",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "J",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "v",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "f",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "X",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "Q",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "J",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "u",
    u2: "X",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "u",
    u2: "J",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "g",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "e",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "d",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "Y",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "A",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ".",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ",",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "x",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "X",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "J",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "X",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "J",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "o",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "e",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "d",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "c",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "a",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "Y",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "V",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "T",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "O",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "G",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "C",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "Q",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\u2018",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "f",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "X",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "J",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: ".",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0401",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0401",
    u2: "\u0414",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    g2: "afii10037.var.accented",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    g2: "afii10032.var.accented",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    g2: "afii10017.var.accented",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04F2",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04F0",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04EE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04EA",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04E8",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04E6",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04D8",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04D2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04D0",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04AE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04AA",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0423",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0422",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0421",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u041E",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0410",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u040E",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0404",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0402",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    g2: "afii10049.var.accented",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04F4",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04DC",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04C1",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04B8",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04B6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0496",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0472",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u042F",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u042A",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0427",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0416",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u040B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    g2: "afii10071.var.accented",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    g2: "afii10097.var.accented",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    g2: "afii10049.var.accented",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    g2: "afii10047.var.accented",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u2026",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04F9",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04F5",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04E5",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04E3",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04DD",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04C8",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04C7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04C4",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04C2",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04B9",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04B7",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04B3",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04B2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04AB",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04AA",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04A3",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04A2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u049D",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u049B",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0497",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0493",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0473",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0472",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0458",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0457",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0456",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0455",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0454",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0451",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u044F",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u044A",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0447",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0445",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0444",
    k: 157
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0442",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0441",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u043C",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0439",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0436",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0434",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0431",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u042F",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u042D",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u042A",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0425",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0424",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0421",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u041D",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u041C",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0414",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u040B",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0404",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0402",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: ":",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: ".",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u041B",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u2122",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u201C",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u2018",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04B2",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u042A",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0425",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u040B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0409",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0402",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0406",
    u2: "\u2122",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0407",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0407",
    u2: "\u0407",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    g2: "afii10037.var.accented",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    g2: "afii10032.var.accented",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    g2: "afii10017.var.accented",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04F2",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04F0",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04EE",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04EA",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04E8",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04E6",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04D8",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04D2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04D0",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04AE",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04AA",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0423",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0422",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0421",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u041E",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0410",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u040E",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0404",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    g2: "afii10049.var.accented",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    g2: "afii10047.var.accented",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04F4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04DC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04C1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04B8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04B6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04B2",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0496",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0472",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u042F",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u042D",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u042A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0427",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0425",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0424",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u041C",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0416",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u040B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0402",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    g2: "afii10037.var.accented",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    g2: "afii10017.var.accented",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04F2",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04F0",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04EE",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04D2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04D0",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04AE",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0423",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0422",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0410",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u040E",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    g2: "afii10049.var.accented",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    g2: "afii10047.var.accented",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04F4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04DC",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04C1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04B8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04B6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04B2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0496",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u042F",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u042D",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u042A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0427",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0425",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0424",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u041C",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0416",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u040B",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0402",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u04F4",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u04B8",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u04B6",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u042A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u040B",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0402",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10071.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10096.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10085.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10070.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10065.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10047.var.accented",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10032.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10017.var.accented",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04F3",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04F1",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04EF",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04EA",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04E8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04E6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04DF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04DE",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04D9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04D8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04D7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04D3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04D2",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04D1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04D0",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04C8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04BB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04AF",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04AA",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04A3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0499",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0498",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0493",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0491",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u045F",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u045E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u045C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u045B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u045A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0457",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0456",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0453",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0452",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0451",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u044E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u044C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0449",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0448",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0443",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u043D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u043A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0437",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0435",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0433",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0432",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0430",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u042D",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0421",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u041E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0417",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0410",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0404",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10097.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10095.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10093.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10080.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10074.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u2122",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04F9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04F5",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04F4",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04EB",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04E9",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04E7",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04E5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04E3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04DC",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04C4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04C1",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04B9",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04B8",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04B7",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04B6",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04B3",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04B2",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04AB",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u049D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u049B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0496",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0473",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0472",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0454",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u044F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u044D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u044B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u044A",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0447",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0446",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0445",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0444",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0442",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0441",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u043F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u043E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0439",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0438",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0431",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0427",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0425",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0424",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0416",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0414",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0409",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: ";",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: ":",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    g2: "afii10071.var.accented",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    g2: "afii10097.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    g2: "afii10095.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    g2: "afii10049.var.accented",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u2026",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u2018",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04F5",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04EB",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04E9",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04E7",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04E5",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04E3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04DD",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04C4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04C2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04B9",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04B7",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04B3",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04B2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04AB",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04AA",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u049D",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u049B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0497",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0473",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0458",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0457",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0456",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0455",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0454",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0451",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u044F",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u044D",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u044A",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0447",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0445",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0442",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0441",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u043E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u043C",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0436",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0434",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0431",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u042F",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0425",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0421",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u041C",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0414",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040F",
    u2: "\u2122",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    g2: "afii10097.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    g2: "afii10080.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u2122",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u201C",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u2018",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04F4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04EB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04E9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04E7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04B9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04B8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04B7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04B6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04B2",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04AE",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04AB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04AA",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0473",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u045B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0454",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u044F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u044A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0447",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0444",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0442",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0441",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u043E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0431",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u042A",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0427",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0425",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0424",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0421",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0414",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u040B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0402",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "*",
    k: 138
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    g2: "afii10037.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    g2: "afii10017.var.accented",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u201D",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u2019",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04F2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04F0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04EE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04DE",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04D2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04D0",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04AE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0498",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0423",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0422",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0417",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0410",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u040E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    g2: "afii10049.var.accented",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    g2: "afii10047.var.accented",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04F4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04B8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04B6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04B2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u042F",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u042D",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u042A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0427",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0425",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u041C",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u040B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0404",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0402",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u2122",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u04B2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u04AE",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0425",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u040B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0402",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    g2: "afii10071.var.accented",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    g2: "afii10097.var.accented",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    g2: "afii10049.var.accented",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u2026",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04F9",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04F5",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04E5",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04E3",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04DD",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04C8",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04C7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04C4",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04C2",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04B9",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04B7",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04B3",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04B2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04AB",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04AA",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04A3",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04A2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u049D",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u049B",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0497",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0493",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0473",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0472",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0458",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0457",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0456",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0455",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0454",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0451",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u044F",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u044A",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0447",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0445",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0444",
    k: 157
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0442",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0441",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u043C",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0439",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0436",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0434",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0431",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u042F",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u042A",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0425",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0424",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0421",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u041D",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u041C",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0414",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u040B",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0404",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0402",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: ":",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: ".",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    g2: "hyphenminus",
    k: -100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\uF6BC",
    k: -100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\uF6BB",
    k: -100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\uF6BA",
    k: -100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    g2: "afii10085.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u201D",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2019",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2014",
    k: -100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2013",
    k: -100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2012",
    k: -100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2011",
    k: -100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2010",
    k: -100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u04F3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u04F1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u04EF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u04AF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u045E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0443",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u041B",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "-",
    k: -100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2122",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0434",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0414",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0409",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0415",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0415",
    u2: "\u0414",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    g2: "afii10095.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    g2: "afii10093.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    g2: "afii10074.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04F9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04F5",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04F4",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04E5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04E3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04DC",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04C4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04C1",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04B9",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04B8",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04B7",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04B6",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04B3",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04B2",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u049D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u049B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0496",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0473",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0454",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u044D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u044B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u044A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0447",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0446",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0445",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0444",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0442",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u043F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0439",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0438",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0431",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0427",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0425",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0424",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0416",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0414",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0409",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u201D",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u2019",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u041B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0409",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u2122",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u2018",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04B2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04AE",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0425",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u040B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0402",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0418",
    u2: "\u2122",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0419",
    u2: "\u2122",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10071.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10096.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10085.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10070.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10065.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10047.var.accented",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10032.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10017.var.accented",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04F3",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04F1",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04EF",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04EA",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04E8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04E6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04DF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04DE",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04D9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04D8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04D7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04D3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04D2",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04D1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04D0",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04C8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04BB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04AF",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04AA",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04A3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0499",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0498",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0493",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0491",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u045F",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u045E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u045C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u045B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u045A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0457",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0456",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0453",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0452",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0451",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u044E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u044C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0449",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0448",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0443",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u043D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u043A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0437",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0435",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0433",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0432",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0430",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u042D",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0421",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u041E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0417",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0410",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0404",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10097.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10095.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10093.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10080.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10074.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u2122",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04F9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04F5",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04F4",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04EB",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04E9",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04E7",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04E5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04E3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04DC",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04C4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04C1",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04B9",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04B8",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04B7",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04B6",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04B3",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04B2",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04AB",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u049D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u049B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0496",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0473",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0472",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0454",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u044F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u044D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u044B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u044A",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0447",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0446",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0445",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0444",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0442",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0441",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u043F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u043E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0439",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0438",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0431",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0427",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0425",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0424",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0416",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0414",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0409",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    g2: "hyphenminus",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\uF6BC",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\uF6BB",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\uF6BA",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    g2: "afii10085.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u201D",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u2019",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u2014",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u2013",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u2012",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u2011",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u2010",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u04F3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u04F1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u04EF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u04AF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u045E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u0443",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "-",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u201C",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u2018",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u2122",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041D",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u201C",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u2018",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u04B2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u04AE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u0425",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u0416",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041F",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10071.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10080.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10070.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10065.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10047.var.accented",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10037.var.accented",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10017.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04F2",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04F0",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04EE",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04EB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04E9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04E7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04DE",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04D9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04D7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04D3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04D2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04D1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04D0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04AE",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0498",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0459",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0451",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u043E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u043B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0435",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0430",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u042D",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0423",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0422",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u041B",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0417",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0410",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u040E",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: ".",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: ",",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "hyphenminus",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10097.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10095.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u2122",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04B3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04B2",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04AF",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04AB",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0473",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0454",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u044F",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u044D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u044A",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0445",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0444",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0441",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0434",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u042A",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0425",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u041C",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0414",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u040B",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0409",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0402",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u2122",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u201C",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u2018",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u042A",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u040B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0409",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0402",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10096.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10093.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10085.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10080.var.accented",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10074.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10070.var.accented",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10065.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10037.var.accented",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10017.var.accented",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u201D",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u2019",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04F9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04F3",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04F2",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04F1",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04F0",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04EF",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04EE",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04DF",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04DE",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04D9",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04D7",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04D3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04D2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04D1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04D0",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04BB",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04AF",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04AE",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0499",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0498",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0491",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u045F",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u045E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u045C",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u045B",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u045A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0459",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0453",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0452",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0451",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044C",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0449",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0448",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0443",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0440",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043F",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0439",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0438",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0437",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0435",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0433",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0432",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0430",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0423",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0422",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0417",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0410",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u040E",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u040B",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0402",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: ".",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: ",",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10071.var.accented",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10097.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10095.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10047.var.accented",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u2122",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04F5",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04EB",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04E9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04E7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04E5",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04E3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04DD",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04C8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04C4",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04C2",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04B9",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04B7",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04B3",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04AB",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04A3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u049D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u049B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0497",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0493",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0473",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0458",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0457",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0456",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0455",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0454",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044F",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044A",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0447",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0446",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0445",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0444",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0442",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0441",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0436",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0434",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u042D",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u042A",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0414",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    g2: "afii10071.var.accented",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    g2: "afii10097.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    g2: "afii10095.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u2018",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04F5",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04EB",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04E9",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04E7",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04E5",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04E3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04DD",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04C4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04C2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04B9",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04B7",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04B3",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04B2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04AB",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04AA",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u049D",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u049B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0497",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0473",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0458",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0457",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0456",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0455",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0454",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0451",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u044F",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u044D",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u044A",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0447",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0445",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0442",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0441",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u043E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u043C",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0436",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0434",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0431",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0425",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0421",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u041C",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0414",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    g2: "afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    g2: "afii10047.var.accented",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    g2: "afii10017.var.accented",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u201D",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u2019",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04DF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04DE",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04D2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04D0",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0499",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0498",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0459",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u044D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u043B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0437",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u042D",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0417",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0410",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u201C",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u2018",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04DD",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04DC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04C2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04C1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04B3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04B2",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04AE",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04AB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0497",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0496",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0445",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0441",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0436",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0434",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0425",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0416",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    g2: "afii10071.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    g2: "afii10096.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    g2: "afii10095.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    g2: "afii10093.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    g2: "afii10085.var.accented",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    g2: "afii10074.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    g2: "afii10070.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    g2: "afii10065.var.accented",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    g2: "afii10047.var.accented",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    g2: "afii10032.var.accented",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04F9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04F3",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04F1",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04EF",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04EA",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04E8",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04E6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04DF",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04DE",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04D9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04D8",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04D7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04D3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04D1",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04C8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04BB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04AF",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04AA",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04A3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0499",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0498",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u045F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u045E",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u045C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u045B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u045A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0458",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0457",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0456",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0452",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0451",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u044E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u044D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u044C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u044B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0449",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0448",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0446",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0443",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0440",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u043F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u043D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u043A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0439",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0438",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0437",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0435",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0432",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0430",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u042D",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0421",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u041E",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u041B",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0417",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0404",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    g2: "afii10097.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    g2: "afii10080.var.accented",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u2122",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04F5",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04F4",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04EB",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04E9",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04E7",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04DC",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04C1",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04B9",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04B8",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04B7",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04B6",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04AB",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0496",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0493",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0491",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0473",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0472",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0454",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0453",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u044F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u044A",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0447",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0444",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0442",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0441",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u043E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0433",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0431",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0424",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0416",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0414",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0409",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    g2: "hyphenminus",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\uF6BC",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\uF6BB",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\uF6BA",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    g2: "afii10047.var.accented",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u2014",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u2013",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u2012",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u2011",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u2010",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u04DE",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0498",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u042D",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0417",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "-",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u2122",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u04B2",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0434",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0425",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0414",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0427",
    u2: "\u2122",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0428",
    u2: "\u2122",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    g2: "hyphenminus",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\uF6BC",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\uF6BB",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\uF6BA",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    g2: "afii10085.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u2014",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u2013",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u2012",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u2011",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u2010",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u04F3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u04F1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u04EF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u04AF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u045E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u0443",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "-",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u2122",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u04F4",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u04B8",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u04B6",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u0414",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    g2: "afii10049.var.accented",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u04F4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u04DC",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u04C1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u04B8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u04B6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u04B2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0496",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u042F",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u042A",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0427",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0425",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0424",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u041C",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0416",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0402",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042B",
    u2: "\u2122",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    g2: "afii10037.var.accented",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    g2: "afii10032.var.accented",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    g2: "afii10017.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u201D",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u2019",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04F2",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04F0",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04EE",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04EA",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04E8",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04E6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04D8",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04D2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04D0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04AE",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0423",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0422",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u041E",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0410",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u040E",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0404",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    g2: "afii10049.var.accented",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    g2: "afii10047.var.accented",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u2122",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04F4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04DC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04C1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04B8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04B6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04B2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04AA",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0496",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0472",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u042F",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u042D",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u042A",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0427",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0425",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0424",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0421",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u041C",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0416",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u040B",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0402",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    g2: "afii10037.var.accented",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    g2: "afii10017.var.accented",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u201D",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u2019",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u04F2",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u04F0",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u04EE",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u04D2",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u04D0",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u0423",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u0410",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u040E",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u201C",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u2018",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u04B2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u04AE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u0425",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u0416",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    g2: "afii10047.var.accented",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    g2: "afii10037.var.accented",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    g2: "afii10017.var.accented",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u201D",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u2019",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u04F2",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u04F0",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u04EE",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u04DE",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u04D2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u04D0",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0498",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u042D",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0423",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0417",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0410",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u040E",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u201C",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u2018",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u04B3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u04B2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u04AE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0445",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0425",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042F",
    u2: "\u2122",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u201C",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u2018",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u04DC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u04C1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u04B3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u04B2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0496",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u045E",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0445",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0425",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u041C",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0416",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04B2",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0434",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0425",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0414",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u2026",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04DC",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04C1",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04B2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04AB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04AA",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0496",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0472",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0459",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0454",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u044A",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0444",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0442",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0441",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0434",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0425",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0424",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0421",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u041C",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0416",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0414",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: ":",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    g2: "hyphenminus",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\uF6BC",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\uF6BB",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\uF6BA",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    g2: "afii10085.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    g2: "afii10037.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u201D",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u2019",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u2014",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u2013",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u2012",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u2011",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u2010",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u04F3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u04F2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u04F1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u04F0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u04EF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u04EE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u04AF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u04AE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u045E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0459",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0443",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u043B",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0423",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0422",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u041B",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u040E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u040B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0409",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0402",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "-",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u201C",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u2018",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0414",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0435",
    u2: "\u04DC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0435",
    u2: "\u04C1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0435",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0435",
    u2: "\u04B2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0435",
    u2: "\u0496",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0435",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0435",
    u2: "\u0425",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0435",
    u2: "\u0416",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u04DD",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u04C2",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u04B2",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u0497",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u045B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u0436",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u0434",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u0425",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u0414",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    g2: "afii10085.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04F3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04F1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04EF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04AF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u045E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0443",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0422",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u041B",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u040B",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0409",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0402",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04B3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04B2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0445",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0434",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0425",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0414",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0438",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0438",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0438",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0438",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0439",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0439",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0439",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0439",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    g2: "afii10071.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    g2: "afii10070.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    g2: "afii10065.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04D9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04D7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04D3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04D1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04BB",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04AB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0454",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0452",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0451",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0441",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0435",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0430",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0422",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u040B",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0402",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    g2: "afii10080.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04EB",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04E9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04E7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04DD",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04C2",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04B2",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0497",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0473",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u045B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0444",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u043E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0436",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0434",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0425",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0414",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    g2: "afii10085.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    g2: "afii10037.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u201D",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u2019",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u04F3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u04F2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u04F1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u04F0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u04EF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u04EE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u04AE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u045E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u0443",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u0423",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u040E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    g2: "hyphenminus",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\uF6BC",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\uF6BB",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\uF6BA",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u2014",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u2013",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u2012",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u2011",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u2010",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u0422",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u040B",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u0402",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "-",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u201C",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u2018",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u04DC",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u04C1",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u04B2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u0496",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u0425",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u0416",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    g2: "afii10037.var.accented",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u04F2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u04F0",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u04EE",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u04AE",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u0423",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u0422",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u041B",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u040E",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u040B",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u0409",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u0402",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u0414",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    g2: "afii10037.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u04F2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u04F0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u04EE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u04AE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u0423",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u040E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    g2: "afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    g2: "afii10037.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u201D",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u2019",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04F2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04F0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04EE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04DF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04AE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0499",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u044D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0437",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0423",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0422",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u040E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u040B",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0402",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04DC",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04C1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04B3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04B2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0496",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u045E",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0445",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0425",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u041C",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0416",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    g2: "hyphenminus",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\uF6BC",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\uF6BB",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\uF6BA",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u2014",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u2013",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u2012",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u2011",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u2010",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u0422",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u040B",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u0402",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "-",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    g2: "afii10085.var.accented",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    g2: "afii10037.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04F3",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04F2",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04F1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04F0",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04EF",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04EE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04AF",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04AE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0443",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0423",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0422",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u040E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u040B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0402",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04DC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04C1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04B3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04B2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0496",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u045E",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0445",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0425",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u041C",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0416",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: ".",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u04B3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u0445",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u0414",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    g2: "hyphenminus",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\uF6BC",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\uF6BB",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\uF6BA",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    g2: "afii10085.var.accented",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    g2: "afii10065.var.accented",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    g2: "afii10037.var.accented",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    g2: "afii10032.var.accented",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    g2: "afii10017.var.accented",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u2014",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u2013",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u2012",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u2011",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u2010",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04F3",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04F2",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04F1",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04F0",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04EF",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04EE",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04EA",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04E8",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04E6",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04D8",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04D3",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04D2",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04D1",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04D0",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04AF",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04AE",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u045E",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0443",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0430",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0423",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u041E",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u041B",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0410",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u040E",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0409",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0404",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: ".",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "-",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: ",",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04DC",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04C1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04B2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04AA",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0496",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0472",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u044A",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0442",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0425",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0424",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0421",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0416",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: ":",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    g2: "hyphenminus",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    g2: "afii10097.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u2026",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u2018",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u04DC",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u04C1",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u04B3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u04B2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u0496",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u0473",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u044F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u0445",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u0442",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u043C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u0434",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u0425",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u041C",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u0416",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u0414",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: ".",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    g2: "afii10085.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    g2: "afii10037.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u201D",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u2019",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04F3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04F2",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04F1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04F0",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04EF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04EE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04AF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04AE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0443",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0423",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0422",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u040E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u040B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0402",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04DC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04C1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04B3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04B2",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0496",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u045E",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0445",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0425",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u041C",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0416",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    g2: "afii10071.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    g2: "afii10095.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    g2: "afii10085.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    g2: "afii10070.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    g2: "afii10065.var.accented",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    g2: "afii10037.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    g2: "afii10017.var.accented",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04F3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04F2",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04F1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04F0",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04EF",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04EE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04DF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04D9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04D7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04D3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04D2",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04D1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04D0",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04BB",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04AF",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04AE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0499",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u045E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u045B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0459",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0454",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0452",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0451",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0444",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0443",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u043B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0437",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0435",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0430",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0423",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0422",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u041B",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0410",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u040E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u040B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0409",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0402",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    g2: "afii10080.var.accented",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    g2: "afii10074.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04F5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04EB",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04E9",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04E7",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04E5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04E3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04C4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04B9",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04B7",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04B3",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04AB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u049D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u049B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0473",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u045C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u044A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0447",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0445",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0442",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0441",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u043E",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u043A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0439",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0438",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0431",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u041C",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0414",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    g2: "hyphenminus",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\uF6BC",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\uF6BB",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\uF6BA",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    g2: "afii10037.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    g2: "afii10017.var.accented",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u2014",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u2013",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u2012",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u2011",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u2010",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u04F2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u04F0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u04EE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u04D2",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u04D0",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u04AE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0459",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u043B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0423",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0422",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u041B",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0410",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u040E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u040B",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0409",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0402",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "-",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u04DC",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u04C1",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u04B2",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0496",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0434",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0425",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0416",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0414",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    g2: "afii10037.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u04F2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u04F0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u04EE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u04AE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u0423",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u040E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    g2: "afii10037.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u04F2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u04F0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u04EE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u04AE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u0423",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u040E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    g2: "hyphenminus",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\uF6BC",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\uF6BB",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\uF6BA",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    g2: "afii10085.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    g2: "afii10037.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u2014",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u2013",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u2012",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u2011",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u2010",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u04F3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u04F2",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u04F1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u04F0",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u04EF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u04EE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u04AF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u04AE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u045E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0459",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0443",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u043B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0423",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0422",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u041B",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u040E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u040B",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0409",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0402",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "-",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u04DC",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u04C1",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0496",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0434",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0416",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0414",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    g2: "afii10080.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u2122",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u201C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u2018",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04EB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04E9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04E7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04DD",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04DC",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04C2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04C1",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04B9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04B7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04B3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04B2",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04AB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04AA",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0497",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0496",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0473",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0472",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u044A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0447",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0445",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0442",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0441",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u043E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0436",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0431",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0425",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0424",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0421",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u041C",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0416",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0414",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044B",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044B",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044B",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044B",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u201D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u2019",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0422",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u041B",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u040B",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0409",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0402",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    g2: "afii10097.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    g2: "afii10080.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u2122",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u201C",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u2018",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04EB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04E9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04E7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04DD",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04C2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04B3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04B2",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04AB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04AA",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0497",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0473",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0472",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u045B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u044F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u044A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0445",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0442",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0441",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u043E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0436",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0431",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0425",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0424",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0421",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u041C",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0414",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    g2: "afii10085.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    g2: "afii10037.var.accented",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    g2: "afii10017.var.accented",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u201D",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u2019",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04F3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04F2",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04F1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04F0",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04EF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04EE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04D2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04D0",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04AF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04AE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0443",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0423",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0422",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0410",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u040E",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u040B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0402",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04DC",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04C1",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04B3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04B2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0496",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u045E",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u044A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0445",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0425",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u041C",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0416",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    g2: "afii10085.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    g2: "afii10037.var.accented",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    g2: "afii10017.var.accented",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u201D",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u2019",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04F3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04F2",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04F1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04F0",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04EF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04EE",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04D2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04D0",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04AF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04AE",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0443",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0423",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0422",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u041B",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0410",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u040E",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u040B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0409",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0402",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04DC",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04C1",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04B3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04B2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0496",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u045E",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0445",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0425",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u041C",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0416",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    g2: "afii10037.var.accented",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u04F2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u04F0",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u04EE",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u04AE",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u0423",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u0422",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u040E",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u040B",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u0402",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0451",
    u2: "\u04DC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0451",
    u2: "\u04C1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0451",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0451",
    u2: "\u04B2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0451",
    u2: "\u0496",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0451",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0451",
    u2: "\u0425",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0451",
    u2: "\u0416",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    g2: "afii10065.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04D3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04D1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0430",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    g2: "hyphenminus",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    g2: "afii10080.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u2026",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04EB",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04E9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04E7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04DC",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04C1",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04B2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04AB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04AA",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0496",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0473",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0472",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0459",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0454",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u044A",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0444",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0442",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0441",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u043E",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u043C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0434",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0425",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0424",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0421",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u041C",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0416",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0414",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: ":",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u041B",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u0409",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u04B3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u04B2",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u0445",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u0425",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u0414",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0457",
    u2: "\u0457",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    g2: "afii10017.var.accented",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04D2",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04D0",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0410",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    g2: "afii10080.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u2122",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u201C",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u2018",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04EB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04E9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04E7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04DD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04C2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04B3",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04B2",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04AB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04AA",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0497",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0473",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0472",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u044A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0445",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0442",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0441",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u043E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0436",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0431",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0425",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0424",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0421",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u041C",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0414",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    g2: "afii10085.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    g2: "afii10017.var.accented",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u201D",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u2019",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04F3",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04F1",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04EF",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04D2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04D0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04BB",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04AF",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u045E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u045B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0452",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0443",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0410",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    g2: "afii10080.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u2122",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u201C",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u2018",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04EB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04E9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04E7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04DD",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04DC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04C2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04C1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04B2",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04AB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04AA",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0497",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0496",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0473",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0472",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u044A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0442",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0441",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u043E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0436",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0431",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0425",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0424",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0421",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u041C",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0416",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0414",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    g2: "afii10071.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    g2: "afii10070.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    g2: "afii10065.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04D9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04D7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04D3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04D1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04BB",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0454",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0452",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0451",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0435",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0430",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0422",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u040B",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0402",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    g2: "afii10080.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04EB",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04E9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04E7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04DD",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04C2",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04B2",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04AB",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0497",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0473",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u045B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0444",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0441",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u043E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0436",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0434",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0431",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0425",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0414",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    g2: "hyphenminus",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    g2: "afii10097.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u2026",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u2018",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u04DC",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u04C1",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u04B3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u04B2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0496",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0473",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u044F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0445",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0442",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u043C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0434",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0425",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u041C",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0416",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0414",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: ":",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: ".",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045F",
    u2: "\u04DC",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045F",
    u2: "\u04C1",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045F",
    u2: "\u0496",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045F",
    u2: "\u0416",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    g2: "afii10047.var.accented",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u201D",
    k: -88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u2019",
    k: -88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u04DE",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u0498",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u042D",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u0417",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u201C",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u2018",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u04B2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u0425",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    g2: "afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    g2: "afii10037.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u201D",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u2019",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u04F2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u04F0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u04EE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u04DF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u04AE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u0499",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u044D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u0437",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u0423",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u0422",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u040E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u040B",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u0402",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u04DC",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u04C1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u04B2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u0496",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u0425",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u0416",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10096.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10093.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10085.var.accented",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10080.var.accented",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10074.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10070.var.accented",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10037.var.accented",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10032.var.accented",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u201D",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u2019",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04F3",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04F2",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04F1",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04F0",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04EF",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04EE",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04EA",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04E8",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04E6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04DF",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04D9",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04D8",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04D7",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04AF",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04AE",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0499",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u045F",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u045E",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u045C",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u045A",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0459",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0453",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u044B",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0449",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0448",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0446",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0443",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0440",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u043F",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u043D",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u043B",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0437",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0435",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0432",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0423",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u041E",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u041B",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u040E",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0409",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: ",",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10071.var.accented",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10097.var.accented",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10095.var.accented",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10049.var.accented",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u2122",
    k: -100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u2026",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04F9",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04F5",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04EB",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04E9",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04E7",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04E5",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04E3",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04DD",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04C8",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04C7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04C4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04C2",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04B9",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04B7",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04B3",
    k: 146
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04B2",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04AB",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04AA",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04A3",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04A2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u049D",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u049B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0497",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0493",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0491",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0473",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0472",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0458",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0457",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0456",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0455",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0454",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0451",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u044F",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u044E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u044D",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u044C",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u044A",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0447",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0445",
    k: 146
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0444",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0442",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0441",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u043E",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u043C",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u043A",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0439",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0438",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0436",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0434",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0433",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0431",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u042F",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u042A",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0425",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0424",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0421",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u041D",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u041C",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0414",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u040B",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0404",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0402",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: ":",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: ".",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    g2: "afii10095.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    g2: "afii10065.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04DF",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04D3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04D1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0499",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u044D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0437",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0430",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    g2: "afii10097.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    g2: "afii10080.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u2026",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04EB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04E9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04E7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04DC",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04C8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04C1",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04B2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04AB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04AA",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04A3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0496",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0473",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0472",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0459",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0454",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u044F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u044A",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0444",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0442",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0441",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u043E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u043D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u043C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0434",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0425",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0424",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0421",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u041C",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0416",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0414",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: ":",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    g2: "afii10071.var.accented",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    g2: "afii10097.var.accented",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    g2: "afii10049.var.accented",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u2026",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04F9",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04F5",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04E5",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04E3",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04DD",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04C8",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04C7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04C4",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04C2",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04B9",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04B7",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04B3",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04B2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04AB",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04AA",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04A3",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04A2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u049D",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u049B",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0497",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0493",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0473",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0472",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0458",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0457",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0456",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0455",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0454",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0451",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u044F",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u044A",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0447",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0445",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0444",
    k: 157
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0442",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0441",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u043C",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0439",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0436",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0434",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0431",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u042F",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u042A",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0425",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0424",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0421",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u041D",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u041C",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0414",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u040B",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0404",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0402",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: ":",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: ".",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u2026",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04DC",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04C1",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04B2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04AB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04AA",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0496",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0472",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0459",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0454",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u044A",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0444",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0442",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0441",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0434",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0425",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0424",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0421",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u041C",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0416",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0414",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: ":",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    g2: "afii10095.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    g2: "afii10093.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    g2: "afii10074.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04F9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04F5",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04F4",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04E5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04E3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04DC",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04C4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04C1",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04B9",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04B8",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04B7",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04B6",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04B3",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04B2",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u049D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u049B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0496",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0473",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0454",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u044D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u044B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u044A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0447",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0446",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0445",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0444",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0442",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u043F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0439",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0438",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0431",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0427",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0425",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0424",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0416",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0414",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0409",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u04DD",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u04C2",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u04B2",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u0497",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u045B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u0436",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u0434",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u0425",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u0414",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u201D",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u2019",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u041B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u0409",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u2122",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u2018",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u04B2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u04AE",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u0425",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u040B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u0402",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    g2: "afii10085.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    g2: "afii10037.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04F3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04F2",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04F1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04F0",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04EF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04EE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04AF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04AE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u045E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0443",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0423",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0422",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u041B",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u040E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u040B",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0409",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0402",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04B3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04B2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0445",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0434",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0425",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0414",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10071.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10096.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10085.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10070.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10065.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10047.var.accented",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10032.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10017.var.accented",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04F3",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04F1",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04EF",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04EA",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04E8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04E6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04DF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04DE",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04D9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04D8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04D7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04D3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04D2",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04D1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04D0",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04C8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04BB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04AF",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04AA",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04A3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0499",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0498",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0493",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0491",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u045F",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u045E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u045C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u045B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u045A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0457",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0456",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0453",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0452",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0451",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u044E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u044C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0449",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0448",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0443",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u043D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u043A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0437",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0435",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0433",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0432",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0430",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u042D",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0421",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u041E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0417",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0410",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0404",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10097.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10095.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10093.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10080.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10074.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u2122",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04F9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04F5",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04F4",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04EB",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04E9",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04E7",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04E5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04E3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04DC",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04C4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04C1",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04B9",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04B8",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04B7",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04B6",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04B3",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04B2",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04AB",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u049D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u049B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0496",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0473",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0472",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0454",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u044F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u044D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u044B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u044A",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0447",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0446",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0445",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0444",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0442",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0441",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u043F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u043E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0439",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0438",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0431",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0427",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0425",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0424",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0416",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0414",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0409",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    g2: "afii10071.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    g2: "afii10070.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    g2: "afii10065.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    g2: "afii10037.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04F2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04F0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04EE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04D9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04D7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04D3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04D1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04BB",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04AE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04AB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0454",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0452",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0451",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0441",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0435",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0430",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0423",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0422",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u040E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u040B",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0402",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    g2: "afii10080.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04EB",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04E9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04E7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04DD",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04C2",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04B2",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0497",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0473",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u045B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0444",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u043E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0436",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0434",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0425",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0414",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10071.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10096.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10085.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10070.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10065.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10047.var.accented",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10032.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10017.var.accented",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04F3",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04F1",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04EF",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04EA",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04E8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04E6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04DF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04DE",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04D9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04D8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04D7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04D3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04D2",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04D1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04D0",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04C8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04BB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04AF",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04AA",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04A3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0499",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0498",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0493",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0491",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u045F",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u045E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u045C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u045B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u045A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0457",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0456",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0453",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0452",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0451",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u044E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u044C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0449",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0448",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0443",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u043D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u043A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0437",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0435",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0433",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0432",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0430",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u042D",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0421",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u041E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0417",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0410",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0404",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10097.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10095.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10093.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10080.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10074.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u2122",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04F9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04F5",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04F4",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04EB",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04E9",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04E7",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04E5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04E3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04DC",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04C4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04C1",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04B9",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04B8",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04B7",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04B6",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04B3",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04B2",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04AB",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u049D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u049B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0496",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0473",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0472",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0454",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u044F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u044D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u044B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u044A",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0447",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0446",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0445",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0444",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0442",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0441",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u043F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u043E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0439",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0438",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0431",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0427",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0425",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0424",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0416",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0414",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0409",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    g2: "afii10071.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    g2: "afii10070.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    g2: "afii10065.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    g2: "afii10037.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04F2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04F0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04EE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04D9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04D7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04D3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04D1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04BB",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04AE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04AB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0454",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0452",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0451",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0441",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0435",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0430",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0423",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0422",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u040E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u040B",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0402",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    g2: "afii10080.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04EB",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04E9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04E7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04DD",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04C2",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04B2",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0497",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0473",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u045B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0444",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u043E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0436",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0434",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0425",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0414",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A2",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    g2: "afii10037.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u04F2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u04F0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u04EE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u04AE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u0423",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u040E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u2122",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u201C",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u2018",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u042A",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u040B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u0409",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u0402",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "\u04B3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "\u0445",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "\u0414",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    g2: "hyphenminus",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\uF6BC",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\uF6BB",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\uF6BA",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    g2: "afii10096.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    g2: "afii10093.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    g2: "afii10074.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    g2: "afii10032.var.accented",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    g2: "afii10017.var.accented",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u2014",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u2013",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u2012",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u2011",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u2010",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04F9",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04EA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04E8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04E6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04D8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04D2",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04D0",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04C8",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04A3",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0493",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0491",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u045F",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u045C",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u045A",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0453",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u044E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u044C",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u044B",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0446",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u043F",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u043D",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u043A",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0439",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0438",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0433",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0432",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u041E",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0410",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0404",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: ";",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: ":",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "-",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    g2: "afii10071.var.accented",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    g2: "afii10097.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    g2: "afii10095.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u2018",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04F5",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04EB",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04E9",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04E7",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04E5",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04E3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04DD",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04C4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04C2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04B9",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04B7",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04B3",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04B2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04AB",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04AA",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u049D",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u049B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0497",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0473",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0458",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0457",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0456",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0455",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0454",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0451",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u044F",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u044D",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u044A",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0449",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0448",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0447",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0445",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0442",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0441",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u043E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u043C",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0436",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0434",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0431",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u042A",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0425",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0424",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0421",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u041C",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0414",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\uF6BC",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\uF6BB",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\uF6BA",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u2014",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u2013",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u2012",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u2011",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u2010",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "-",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    g2: "hyphenminus",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    g2: "afii10097.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u2026",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u2018",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u04DC",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u04C1",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u04B3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u04B2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0496",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0473",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0455",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u044F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0445",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0442",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u043C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0434",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0425",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u041C",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0416",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0414",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: ".",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    g2: "afii10071.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    g2: "afii10096.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    g2: "afii10095.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    g2: "afii10093.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    g2: "afii10085.var.accented",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    g2: "afii10074.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    g2: "afii10070.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    g2: "afii10065.var.accented",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    g2: "afii10047.var.accented",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    g2: "afii10032.var.accented",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04F9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04F3",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04F1",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04EF",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04EA",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04E8",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04E6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04DF",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04DE",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04D9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04D8",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04D7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04D3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04D1",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04C8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04BB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04AF",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04AA",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04A3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0499",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0498",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u045F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u045E",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u045C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u045B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u045A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0458",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0457",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0456",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0452",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0451",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u044E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u044D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u044C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u044B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0449",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0448",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0446",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0443",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0440",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u043F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u043D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u043A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0439",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0438",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0437",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0435",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0432",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0430",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u042D",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0421",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u041E",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u041B",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0417",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0404",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    g2: "afii10097.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    g2: "afii10080.var.accented",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u2122",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04F5",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04F4",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04EB",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04E9",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04E7",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04DC",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04C1",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04B9",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04B8",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04B7",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04B6",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04AB",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0496",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0493",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0491",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0473",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0472",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0454",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0453",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u044F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u044A",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0447",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0444",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0442",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0441",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u043E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0433",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0431",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0424",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0416",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0414",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0409",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    g2: "afii10071.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    g2: "afii10095.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    g2: "afii10085.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    g2: "afii10070.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    g2: "afii10065.var.accented",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    g2: "afii10037.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    g2: "afii10017.var.accented",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04F3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04F2",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04F1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04F0",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04EF",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04EE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04DF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04D9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04D7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04D3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04D2",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04D1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04D0",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04BB",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04AF",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04AE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0499",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u045E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u045B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0459",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0454",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0452",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0451",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0444",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0443",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u043B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0437",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0435",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0430",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0423",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0422",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u041B",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0410",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u040E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u040B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0409",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0402",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    g2: "afii10080.var.accented",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    g2: "afii10074.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04F5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04EB",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04E9",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04E7",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04E5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04E3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04C4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04B9",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04B7",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04B3",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04AB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u049D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u049B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0473",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u045C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u044A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0447",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0445",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0442",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0441",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u043E",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u043A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0439",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0438",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0431",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u041C",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0414",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B6",
    u2: "\u2122",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    g2: "afii10037.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u04F2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u04F0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u04EE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u04AE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u0423",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u040E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B8",
    u2: "\u2122",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    g2: "afii10037.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u04F2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u04F0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u04EE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u04AE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u0423",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u040E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u04F4",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u04B8",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u04B6",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u04AE",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u042A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u040B",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u0402",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BB",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BB",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BB",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BB",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    g2: "afii10095.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    g2: "afii10093.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    g2: "afii10074.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04F9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04F5",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04F4",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04E5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04E3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04DC",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04C4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04C1",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04B9",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04B8",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04B7",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04B6",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04B3",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04B2",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u049D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u049B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0496",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0473",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0454",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u044D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u044B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u044A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0447",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0446",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0445",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0444",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0442",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u043F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0439",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0438",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0431",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0427",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0425",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0424",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0416",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0414",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0409",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C2",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C2",
    u2: "\u04DD",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C2",
    u2: "\u04C2",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C2",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C2",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C2",
    u2: "\u04B2",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C2",
    u2: "\u0497",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C2",
    u2: "\u045B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C2",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C2",
    u2: "\u0436",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C2",
    u2: "\u0434",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C2",
    u2: "\u0425",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C2",
    u2: "\u0414",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10071.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10096.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10085.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10070.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10065.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10047.var.accented",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10032.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10017.var.accented",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04F3",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04F1",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04EF",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04EA",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04E8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04E6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04DF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04DE",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04D9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04D8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04D7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04D3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04D2",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04D1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04D0",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04C8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04BB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04AF",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04AA",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04A3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0499",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0498",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0493",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0491",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u045F",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u045E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u045C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u045B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u045A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0457",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0456",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0453",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0452",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0451",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u044E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u044C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0449",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0448",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0443",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u043D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u043A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0437",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0435",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0433",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0432",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0430",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u042D",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0421",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u041E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0417",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0410",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0404",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10097.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10095.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10093.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10080.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10074.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u2122",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04F9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04F5",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04F4",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04EB",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04E9",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04E7",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04E5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04E3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04DC",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04C4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04C1",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04B9",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04B8",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04B7",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04B6",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04B3",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04B2",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04AB",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u049D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u049B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0496",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0473",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0472",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0454",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u044F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u044D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u044B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u044A",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0447",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0446",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0445",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0444",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0442",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0441",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u043F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u043E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0439",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0438",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0431",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0427",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0425",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0424",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0416",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0414",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0409",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    g2: "afii10071.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    g2: "afii10070.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    g2: "afii10065.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    g2: "afii10037.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04F2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04F0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04EE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04D9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04D7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04D3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04D1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04BB",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04AE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04AB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0454",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0452",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0451",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0441",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0435",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0430",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0423",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0422",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u040E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u040B",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0402",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    g2: "afii10080.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04EB",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04E9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04E7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04DD",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04C2",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04B2",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0497",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0473",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u045B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0444",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u043E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0436",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0434",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0425",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0414",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C7",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    g2: "afii10037.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u04F2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u04F0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u04EE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u04AE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u0423",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u040E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    g2: "afii10097.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    g2: "afii10080.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u2122",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u201C",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u2018",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04F4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04EB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04E9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04E7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04B9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04B8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04B7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04B6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04B2",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04AE",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04AB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04AA",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0473",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u045B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0454",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u044F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u044A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0447",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0444",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0442",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0441",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u043E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0431",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u042A",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0427",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0425",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0424",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0421",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0414",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u040B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0402",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "*",
    k: 138
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D1",
    u2: "\u201C",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D1",
    u2: "\u2018",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D1",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D1",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D1",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D1",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    g2: "afii10097.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    g2: "afii10080.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u2122",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u201C",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u2018",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04F4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04EB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04E9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04E7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04B9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04B8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04B7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04B6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04B2",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04AE",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04AB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04AA",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0473",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u045B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0454",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u044F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u044A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0447",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0444",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0442",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0441",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u043E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0431",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u042A",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0427",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0425",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0424",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0421",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0414",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u040B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0402",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "*",
    k: 138
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D3",
    u2: "\u201C",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D3",
    u2: "\u2018",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D3",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D3",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D3",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D3",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D6",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D6",
    u2: "\u0414",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D7",
    u2: "\u04DC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D7",
    u2: "\u04C1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D7",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D7",
    u2: "\u04B2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D7",
    u2: "\u0496",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D7",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D7",
    u2: "\u0425",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D7",
    u2: "\u0416",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u201C",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u2018",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u04B2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u04AE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u0425",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u0416",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D9",
    u2: "\u04DC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D9",
    u2: "\u04C1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D9",
    u2: "\u04B3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D9",
    u2: "\u04B2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D9",
    u2: "\u0496",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D9",
    u2: "\u045E",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D9",
    u2: "\u0445",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D9",
    u2: "\u0425",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D9",
    u2: "\u041C",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D9",
    u2: "\u0416",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    g2: "afii10095.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    g2: "afii10093.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    g2: "afii10074.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04F9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04F5",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04F4",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04E5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04E3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04DC",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04C4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04C1",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04B9",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04B8",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04B7",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04B6",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04B3",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04B2",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u049D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u049B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0496",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0473",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0454",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u044D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u044B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u044A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0447",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0446",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0445",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0444",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0442",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u043F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0439",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0438",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0431",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0427",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0425",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0424",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0416",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0414",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0409",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DD",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DD",
    u2: "\u04DD",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DD",
    u2: "\u04C2",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DD",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DD",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DD",
    u2: "\u04B2",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DD",
    u2: "\u0497",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DD",
    u2: "\u045B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DD",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DD",
    u2: "\u0436",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DD",
    u2: "\u0434",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DD",
    u2: "\u0425",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DD",
    u2: "\u0414",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u201D",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u2019",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u041B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u0409",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u2122",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u2018",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u04B2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u04AE",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u0425",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u040B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u0402",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    g2: "afii10085.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    g2: "afii10037.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04F3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04F2",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04F1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04F0",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04EF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04EE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04AF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04AE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u045E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0443",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0423",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0422",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u041B",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u040E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u040B",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0409",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0402",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04B3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04B2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0445",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0434",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0425",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0414",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E2",
    u2: "\u2122",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E3",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E3",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E3",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E3",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E4",
    u2: "\u2122",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E5",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E5",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E5",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E5",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u201C",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u2018",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u04B2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u04AE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u0425",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u0416",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    g2: "afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    g2: "afii10037.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u201D",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u2019",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04F2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04F0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04EE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04DF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04AE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u0499",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u044D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u0437",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u0423",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u0422",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u040E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u040B",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u0402",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04DC",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04C1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04B3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04B2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u0496",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u045E",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u0445",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u0425",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u041C",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u0416",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u201C",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u2018",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u04B2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u04AE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u0425",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u0416",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    g2: "afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    g2: "afii10037.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u201D",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u2019",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04F2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04F0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04EE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04DF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04AE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u0499",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u044D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u0437",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u0423",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u0422",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u040E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u040B",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u0402",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04DC",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04C1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04B3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04B2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u0496",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u045E",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u0445",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u0425",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u041C",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u0416",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u201C",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u2018",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u04B2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u04AE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u0425",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u0416",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    g2: "afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    g2: "afii10037.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u201D",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u2019",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04F2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04F0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04EE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04DF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04AE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u0499",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u044D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u0437",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u0423",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u0422",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u040E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u040B",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u0402",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04DC",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04C1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04B3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04B2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u0496",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u045E",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u0445",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u0425",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u041C",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u0416",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    g2: "afii10071.var.accented",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    g2: "afii10097.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    g2: "afii10095.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u2018",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04F5",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04EB",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04E9",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04E7",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04E5",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04E3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04DD",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04C4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04C2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04B9",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04B7",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04B3",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04B2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04AB",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04AA",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u049D",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u049B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0497",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0473",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0458",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0457",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0456",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0455",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0454",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0451",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u044F",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u044D",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u044A",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0447",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0445",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0442",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0441",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u043E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u043C",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0436",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0434",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0431",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0425",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0421",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u041C",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0414",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    g2: "hyphenminus",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    g2: "afii10097.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u2026",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u2018",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u04DC",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u04C1",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u04B3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u04B2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u0496",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u0473",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u044F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u0445",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u0442",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u043C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u0434",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u0425",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u041C",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u0416",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u0414",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: ".",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    g2: "afii10071.var.accented",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    g2: "afii10097.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    g2: "afii10095.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u2018",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04F5",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04EB",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04E9",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04E7",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04E5",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04E3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04DD",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04C4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04C2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04B9",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04B7",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04B3",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04B2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04AB",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04AA",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u049D",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u049B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0497",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0473",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0458",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0457",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0456",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0455",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0454",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0451",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u044F",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u044D",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u044A",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0447",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0445",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0442",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0441",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u043E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u043C",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0436",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0434",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0431",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0425",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0421",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u041C",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0414",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    g2: "hyphenminus",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    g2: "afii10097.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u2026",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u2018",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u04DC",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u04C1",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u04B3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u04B2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u0496",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u0473",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u044F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u0445",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u0442",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u043C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u0434",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u0425",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u041C",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u0416",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u0414",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: ".",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    g2: "afii10071.var.accented",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    g2: "afii10097.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    g2: "afii10095.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u2018",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04F5",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04EB",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04E9",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04E7",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04E5",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04E3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04DD",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04C4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04C2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04B9",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04B7",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04B3",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04B2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04AB",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04AA",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u049D",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u049B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0497",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0473",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0458",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0457",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0456",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0455",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0454",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0451",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u044F",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u044D",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u044A",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0447",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0445",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0442",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0441",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u043E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u043C",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0436",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0434",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0431",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0425",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0421",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u041C",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0414",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    g2: "hyphenminus",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    g2: "afii10097.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u2026",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u2018",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u04DC",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u04C1",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u04B3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u04B2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u0496",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u0473",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u044F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u0445",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u0442",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u043C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u0434",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u0425",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u041C",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u0416",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u0414",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: ".",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F4",
    u2: "\u2122",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    g2: "afii10037.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u04F2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u04F0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u04EE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u04AE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u0423",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u040E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F8",
    u2: "\u2122",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u04AE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u045E",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u0459",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u0442",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u0434",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u0414",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u0409",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u04AE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u045E",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u0459",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u0442",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u0434",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u0414",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u0409",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u04AE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u045E",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u0459",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u0442",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u0434",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u0414",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u0409",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u04AE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u045E",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0459",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0442",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0434",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0414",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0409",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u04AE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u045E",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0459",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0442",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0434",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0414",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0409",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "J",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10071.var.accented",
    k: 187
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10096.var.accented",
    k: 146
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10093.var.accented",
    k: 146
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10085.var.accented",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10080.var.accented",
    k: 187
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10074.var.accented",
    k: 146
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10070.var.accented",
    k: 187
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10065.var.accented",
    k: 175
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10037.var.accented",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10032.var.accented",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10017.var.accented",
    k: 212
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04F9",
    k: 146
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04F3",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04F2",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04F1",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04F0",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04EF",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04EE",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04EB",
    k: 187
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04EA",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04E9",
    k: 187
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04E8",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04E7",
    k: 187
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04E6",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04DE",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04D9",
    k: 187
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04D8",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04D7",
    k: 187
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04D3",
    k: 175
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04D2",
    k: 212
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04D1",
    k: 175
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04D0",
    k: 212
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04C8",
    k: 146
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04AF",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04AE",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04A3",
    k: 146
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0498",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0493",
    k: 146
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0491",
    k: 146
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u045F",
    k: 146
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u045E",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u045C",
    k: 146
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u045A",
    k: 146
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0459",
    k: 167
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0457",
    k: 146
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0456",
    k: 146
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0453",
    k: 146
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0451",
    k: 187
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u044E",
    k: 146
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u044C",
    k: 146
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u044B",
    k: 146
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0449",
    k: 146
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0448",
    k: 146
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0446",
    k: 146
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0444",
    k: 187
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0443",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u043F",
    k: 146
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u043E",
    k: 187
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u043D",
    k: 146
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u043B",
    k: 167
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u043A",
    k: 146
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0439",
    k: 146
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0438",
    k: 146
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0435",
    k: 187
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0433",
    k: 146
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0432",
    k: 146
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0430",
    k: 175
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0423",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0422",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u041E",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u041B",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0417",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0410",
    k: 212
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u040E",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u040B",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0404",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0402",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "y",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "w",
    k: 127
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "s",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "r",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "o",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "g",
    k: 162
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "e",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "d",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "c",
    k: 175
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "a",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "Y",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "W",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "V",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "T",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "S",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "A",
    k: 212
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: ",",
    k: 275
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10047.var.accented",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04AB",
    k: 177
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04AA",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0473",
    k: 187
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0472",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0454",
    k: 208
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0441",
    k: 177
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u043C",
    k: 167
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0434",
    k: 198
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u042D",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0424",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0421",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u041C",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0414",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0409",
    k: 162
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "v",
    k: 132
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "q",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: ".",
    k: 163
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    g2: "afii10017.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u04D2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u04D0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0422",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0410",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u040B",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0402",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "a",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "W",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "V",
    k: -100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "T",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "J",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "Y",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "W",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "T",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "A",
    k: 187
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    g2: "afii10085.var.accented",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    g2: "afii10047.var.accented",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    g2: "afii10037.var.accented",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    g2: "afii10032.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    g2: "afii10017.var.accented",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04F3",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04F2",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04F1",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04F0",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04EF",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04EE",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04EA",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04E8",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04E6",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04DE",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04D8",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04D2",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04D0",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04AF",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04AE",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0498",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u045E",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0443",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u042D",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0423",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0422",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u041E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0417",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0410",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u040E",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "Y",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "W",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "V",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "T",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "S",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04F5",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04F4",
    k: 175
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04B9",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04B8",
    k: 175
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04B7",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04B6",
    k: 175
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04AA",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0472",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0447",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0444",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0442",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0427",
    k: 175
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0424",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0421",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u040B",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0404",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0402",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "Y",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    g2: "afii10097.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    g2: "afii10080.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u2122",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u201C",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u2018",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04F4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04EB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04E9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04E7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04B9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04B8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04B7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04B6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04B2",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04AE",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04AB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04AA",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0473",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u045B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0454",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u044F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u044A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0447",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0444",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0442",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0441",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u043E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0431",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u042A",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0427",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0425",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0424",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0421",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0414",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u040B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0402",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "*",
    k: 138
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10022.var.accented",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10022.var.accented",
    u2: "\u0414",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10026.var.accented",
    u2: "\u2122",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u201C",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u2018",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u04B2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u04AE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u0425",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u0416",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    g2: "afii10071.var.accented",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    g2: "afii10097.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    g2: "afii10095.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u2018",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04F5",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04EB",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04E9",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04E7",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04E5",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04E3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04DD",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04C4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04C2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04B9",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04B7",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04B3",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04B2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04AB",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04AA",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u049D",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u049B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0497",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0473",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0458",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0457",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0456",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0455",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0454",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0451",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u044F",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u044D",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u044A",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0447",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0445",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0442",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0441",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u043E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u043C",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0436",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0434",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0431",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0425",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0421",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u041C",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0414",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10045.var.accented",
    u2: "\u2122",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    g2: "afii10037.var.accented",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    g2: "afii10017.var.accented",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u201D",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u2019",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u04F2",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u04F0",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u04EE",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u04D2",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u04D0",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u0423",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u0410",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u040E",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u201C",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u2018",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u04B2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u04AE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u0425",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u0416",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    g2: "afii10047.var.accented",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    g2: "afii10037.var.accented",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    g2: "afii10017.var.accented",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u201D",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u2019",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u04F2",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u04F0",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u04EE",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u04DE",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u04D2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u04D0",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u0498",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u042D",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u0423",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u0417",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u0410",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u040E",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u201C",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u2018",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u04B3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u04B2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u04AE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u0445",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u0425",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10049.var.accented",
    u2: "\u2122",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10023.var.accented",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10023.var.accented",
    u2: "\u0414",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065.var.accented",
    u2: "\u201C",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065.var.accented",
    u2: "\u2018",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065.var.accented",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065.var.accented",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065.var.accented",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065.var.accented",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070.var.accented",
    u2: "\u04DC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070.var.accented",
    u2: "\u04C1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070.var.accented",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070.var.accented",
    u2: "\u04B2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070.var.accented",
    u2: "\u0496",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070.var.accented",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070.var.accented",
    u2: "\u0425",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070.var.accented",
    u2: "\u0416",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10074.var.accented",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10074.var.accented",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10074.var.accented",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10074.var.accented",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    g2: "afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    g2: "afii10037.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u201D",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u2019",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04F2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04F0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04EE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04DF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04AE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u0499",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u044D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u0437",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u0423",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u0422",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u040E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u040B",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u0402",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04DC",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04C1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04B3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04B2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u0496",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u045E",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u0445",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u0425",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u041C",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u0416",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    g2: "hyphenminus",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    g2: "afii10097.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u2026",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u2018",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u04DC",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u04C1",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u04B3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u04B2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u0496",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u0473",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u044F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u0445",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u0442",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u043C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u0434",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u0425",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u041C",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u0416",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u0414",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: ".",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    g2: "afii10085.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    g2: "afii10037.var.accented",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    g2: "afii10017.var.accented",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u201D",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u2019",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04F3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04F2",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04F1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04F0",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04EF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04EE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04D2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04D0",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04AF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04AE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u0443",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u0423",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u0422",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u0410",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u040E",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u040B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u0402",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04DC",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04C1",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04B3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04B2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u0496",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u045E",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u044A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u0445",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u0425",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u041C",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u0416",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    g2: "afii10085.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    g2: "afii10037.var.accented",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    g2: "afii10017.var.accented",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u201D",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u2019",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04F3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04F2",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04F1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04F0",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04EF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04EE",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04D2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04D0",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04AF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04AE",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0443",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0423",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0422",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u041B",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0410",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u040E",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u040B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0409",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0402",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04DC",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04C1",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04B3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04B2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0496",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u045E",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0445",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0425",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u041C",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0416",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    g2: "afii10037.var.accented",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u04F2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u04F0",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u04EE",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u04AE",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u0423",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u0422",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u040E",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u040B",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u0402",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u04DC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u04C1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u0496",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u0416",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10071.var.accented",
    u2: "\u04DC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10071.var.accented",
    u2: "\u04C1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10071.var.accented",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10071.var.accented",
    u2: "\u04B2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10071.var.accented",
    u2: "\u0496",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10071.var.accented",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10071.var.accented",
    u2: "\u0425",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10071.var.accented",
    u2: "\u0416",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u04AE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u045E",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u0459",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u0442",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u0434",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u0414",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u0409",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u04AE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u045E",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u0459",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u0442",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u0434",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u0414",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u0409",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u04AE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u045E",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u0459",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u0442",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u0434",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u0414",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u0409",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "A",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u04AE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u045E",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0459",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0442",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0434",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0414",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0409",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "C",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "G",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "O",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "S",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "T",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "Y",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "w",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "y",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "quoteright,quotedblright",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C",
    g2: "G",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C",
    g2: "T",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C",
    g2: "quoteright,quotedblright",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D",
    g2: "V",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D",
    g2: "Y",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D",
    g2: "quoteright,quotedblright",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D",
    g2: "A",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D",
    g2: "Z",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E",
    g2: "T",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "V",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "Y",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "quoteright,quotedblright",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "A",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "Z",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J",
    g2: "A",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J",
    g2: "z",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "C",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "G",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "O",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "S",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "T",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "V",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "w",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "y",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "U",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "a",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "c",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "d",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "e",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "g",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "o",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "s",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "t",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "u",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "C",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "G",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "O",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "S",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "T",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "V",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "Y",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "w",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "y",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "U",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "W",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "guilsinglright",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O",
    g2: "V",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O",
    g2: "Y",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O",
    g2: "quoteright,quotedblright",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O",
    g2: "A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O",
    g2: "Z",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "T",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "Y",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "quoteright,quotedblright",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "S",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "Y",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "quoteright,quotedblright",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "W",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "T",
    k: -45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "Y",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "w",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "y",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "quoteright,quotedblright",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "A",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "z",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "a",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "c",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "d",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "e",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "g",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "o",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "s",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "u",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "comma,period",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "l",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "h,n",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "O",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "w",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "y",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "z",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "a",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "c",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "d",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "e",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "g",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "o",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "s",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "t",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "u",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "comma,period",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "h,n",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "r",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "w",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "y",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "A",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "z",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "a",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "c",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "d",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "e",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "g",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "o",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "s",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "u",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "h,n",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "r",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "C",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "G",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "O",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "S",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "T",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "V",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "w",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "y",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "A",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "z",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "a",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "c",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "d",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "e",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "g",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "o",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "s",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "t",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "u",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "W",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "comma,period",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "h,n",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "r",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "colon,semicolon",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "C",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "G",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "O",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "S",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "w",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "y",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "a",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "c",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "d",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "e",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "o",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "s",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "t",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "u",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a",
    g2: "T",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a",
    g2: "Y",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a",
    g2: "quoteright,quotedblright",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b",
    g2: "T",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b",
    g2: "V",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b",
    g2: "Y",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b",
    g2: "w",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b",
    g2: "y",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b",
    g2: "A",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b",
    g2: "s",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b",
    g2: "W",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c",
    g2: "V",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c",
    g2: "Y",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c",
    g2: "t",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e",
    g2: "T",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e",
    g2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e",
    g2: "Y",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "C",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "G",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "O",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "w",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "y",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "quoteright,quotedblright",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "A",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "t",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "l",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "i",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g",
    g2: "V",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g",
    g2: "Y",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "C",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "G",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "O",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "T",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "Y",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "U",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "a",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "c",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "d",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "e",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "g",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "o",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "s",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "u",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "W",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "r",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "i",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "n",
    g2: "T",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "n",
    g2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "n",
    g2: "Y",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "n",
    g2: "quoteright,quotedblright",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o",
    g2: "T",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o",
    g2: "V",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o",
    g2: "Y",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o",
    g2: "quoteright,quotedblright",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "T",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "Y",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "y",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "c",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "g",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "o",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "t",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "comma,period",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s",
    g2: "T",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s",
    g2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s",
    g2: "Y",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s",
    g2: "quoteright,quotedblright",
    k: -88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s",
    g2: "A",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "G",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "O",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "V",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "Y",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "w",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "y",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "A",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "t",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u",
    g2: "V",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u",
    g2: "Y",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u",
    g2: "A",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "O",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "T",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "V",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "Y",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "a",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "c",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "d",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "g",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "o",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "comma,period",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "C",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "T",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "V",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "Y",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "quoteright,quotedblright",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "A",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "a",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "c",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "d",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "s",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "t",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "comma,period",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "T",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "Y",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "T",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "V",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "Y",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "a",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "c",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "W",
    k: -68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "afii10051,afii10060,afii10036",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period",
    g2: "quoteright,quotedblright",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    g2: "Y",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    g2: "A",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    g2: "afii10058,afii10029",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    g2: "afii10077,afii10106",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "quoteright,quotedblright",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "afii10051,afii10060,afii10036",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "afii10058,afii10029",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "afii10053,afii10032,afii10035,uni04AA,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "afii10070,afii10080,afii10083,afii10086,afii10071,afii10101,uni04AB,uni04D7,afii10846,uni04E7,uni04E9,uni04EB,afii10070.var.accented,afii10080.var.accented,afii10071.var.accented",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "afii10099,afii10108,uni04BB",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10019,afii10025,uni0498,uni04DE",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10019,afii10025,uni0498,uni04DE",
    g2: "afii10051,afii10060,afii10036",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10019,afii10025,uni0498,uni04DE",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10019,afii10025,uni0498,uni04DE",
    g2: "afii10025,afii10047,uni0498,uni04DE,afii10047.var.accented",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "comma,period",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "colon,semicolon",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10051,afii10060,afii10036",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10058,afii10029",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10077,afii10106",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10053,afii10032,afii10035,uni04AA,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10070,afii10080,afii10083,afii10086,afii10071,afii10101,uni04AB,uni04D7,afii10846,uni04E7,uni04E9,uni04EB,afii10070.var.accented,afii10080.var.accented,afii10071.var.accented",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10099,afii10108,uni04BB",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10025,afii10047,uni0498,uni04DE,afii10047.var.accented",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10067,afii10068,afii10074,afii10075,afii10076,afii10079,afii10081,afii10088,afii10090,afii10091,afii10093,afii10094,afii10096,afii10100,afii10103,afii10104,afii10107,afii10109,afii10193,afii10098,uni0493,uni04A3,uni04C8,uni04F9,afii10074.var.accented,afii10093.var.accented,afii10096.var.accented",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10082,afii10105",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10023,afii10022,uni04D6,afii10022.var.accented,afii10023.var.accented",
    g2: "afii10051,afii10060,afii10036",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10023,afii10022,uni04D6,afii10022.var.accented,afii10023.var.accented",
    g2: "afii10058,afii10029",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10058,afii10029",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10053,afii10032,afii10035,uni04AA,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10070,afii10080,afii10083,afii10086,afii10071,afii10101,uni04AB,uni04D7,afii10846,uni04E7,uni04E9,uni04EB,afii10070.var.accented,afii10080.var.accented,afii10071.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10067,afii10068,afii10074,afii10075,afii10076,afii10079,afii10081,afii10088,afii10090,afii10091,afii10093,afii10094,afii10096,afii10100,afii10103,afii10104,afii10107,afii10109,afii10193,afii10098,uni0493,uni04A3,uni04C8,uni04F9,afii10074.var.accented,afii10093.var.accented,afii10096.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10082,afii10105",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032,afii10047,afii10048,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented,afii10047.var.accented,afii10048.var.accented",
    g2: "quoteright,quotedblright",
    k: -88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032,afii10047,afii10048,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented,afii10047.var.accented,afii10048.var.accented",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032,afii10047,afii10048,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented,afii10047.var.accented,afii10048.var.accented",
    g2: "afii10025,afii10047,uni0498,uni04DE,afii10047.var.accented",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10053,afii10035,uni04AA",
    g2: "quoteright,quotedblright",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10053,afii10035,uni04AA",
    g2: "afii10051,afii10060,afii10036",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10053,afii10035,uni04AA",
    g2: "afii10058,afii10029",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10053,afii10035,uni04AA",
    g2: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "quoteright,quotedblright",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "comma,period",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10051,afii10060,afii10036",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10058,afii10029",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10077,afii10106",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10070,afii10080,afii10083,afii10086,afii10071,afii10101,uni04AB,uni04D7,afii10846,uni04E7,uni04E9,uni04EB,afii10070.var.accented,afii10080.var.accented,afii10071.var.accented",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10099,afii10108,uni04BB",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10025,afii10047,uni0498,uni04DE,afii10047.var.accented",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10067,afii10068,afii10074,afii10075,afii10076,afii10079,afii10081,afii10088,afii10090,afii10091,afii10093,afii10094,afii10096,afii10100,afii10103,afii10104,afii10107,afii10109,afii10193,afii10098,uni0493,uni04A3,uni04C8,uni04F9,afii10074.var.accented,afii10093.var.accented,afii10096.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10082,afii10105",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10058,afii10059,afii10044,afii10046",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10058,afii10059,afii10044,afii10046",
    g2: "afii10051,afii10060,afii10036",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10058,afii10059,afii10044,afii10046",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10058,afii10059,afii10044,afii10046",
    g2: "afii10058,afii10029",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10058,afii10059,afii10044,afii10046",
    g2: "afii10025,afii10047,uni0498,uni04DE,afii10047.var.accented",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    g2: "quoteright,quotedblright",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    g2: "afii10051,afii10060,afii10036",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10066,afii10080,afii10082,afii10086,afii10095,afii10096,afii10846,uni04E7,uni04E9,uni04EB,afii10080.var.accented,afii10095.var.accented,afii10096.var.accented",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10066,afii10080,afii10082,afii10086,afii10095,afii10096,afii10846,uni04E7,uni04E9,uni04EB,afii10080.var.accented,afii10095.var.accented,afii10096.var.accented",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10067,afii10073,uni0499,uni04DF",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10067,afii10073,uni0499,uni04DF",
    g2: "afii10058,afii10029",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10067,afii10073,uni0499,uni04DF",
    g2: "afii10077,afii10106",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "comma,period",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10051,afii10060,afii10036",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10058,afii10029",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10077,afii10106",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10053,afii10032,afii10035,uni04AA,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10070,afii10080,afii10083,afii10086,afii10071,afii10101,uni04AB,uni04D7,afii10846,uni04E7,uni04E9,uni04EB,afii10070.var.accented,afii10080.var.accented,afii10071.var.accented",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070,afii10071,uni04D7,afii10070.var.accented,afii10071.var.accented",
    g2: "quoteright,quotedblright",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070,afii10071,uni04D7,afii10070.var.accented,afii10071.var.accented",
    g2: "afii10051,afii10060,afii10036",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070,afii10071,uni04D7,afii10070.var.accented,afii10071.var.accented",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070,afii10071,uni04D7,afii10070.var.accented,afii10071.var.accented",
    g2: "afii10058,afii10029",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070,afii10071,uni04D7,afii10070.var.accented,afii10071.var.accented",
    g2: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10072,afii10076,afii10109,uni0497,uni049B,uni049D,uni04C2,uni04C4,uni04DD",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10072,afii10076,afii10109,uni0497,uni049B,uni049D,uni04C2,uni04C4,uni04DD",
    g2: "afii10051,afii10060,afii10036",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10072,afii10076,afii10109,uni0497,uni049B,uni049D,uni04C2,uni04C4,uni04DD",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10072,afii10076,afii10109,uni0497,uni049B,uni049D,uni04C2,uni04C4,uni04DD",
    g2: "afii10058,afii10029",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10072,afii10076,afii10109,uni0497,uni049B,uni049D,uni04C2,uni04C4,uni04DD",
    g2: "afii10070,afii10080,afii10083,afii10086,afii10071,afii10101,uni04AB,uni04D7,afii10846,uni04E7,uni04E9,uni04EB,afii10070.var.accented,afii10080.var.accented,afii10071.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10072,afii10076,afii10109,uni0497,uni049B,uni049D,uni04C2,uni04C4,uni04DD",
    g2: "afii10099,afii10108,uni04BB",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10074,afii10075,afii10079,afii10081,afii10089,afii10090,afii10093,afii10097,afii10193,uni04A3,uni04B7,uni04B9,uni04BB,uni04C8,uni04E3,uni04E5,uni04F5,uni04F9,afii10074.var.accented,afii10093.var.accented,afii10097.var.accented",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10083,afii10101,uni04AB",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10083,afii10101,uni04AB",
    g2: "afii10058,afii10029",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "quoteright,quotedblright",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "comma,period",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "afii10051,afii10060,afii10036",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "afii10058,afii10029",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "afii10077,afii10106",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "afii10070,afii10080,afii10083,afii10086,afii10071,afii10101,uni04AB,uni04D7,afii10846,uni04E7,uni04E9,uni04EB,afii10070.var.accented,afii10080.var.accented,afii10071.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "afii10099,afii10108,uni04BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "afii10082,afii10105",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10092,afii10094,afii10106,afii10107",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10092,afii10094,afii10106,afii10107",
    g2: "afii10051,afii10060,afii10036",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10092,afii10094,afii10106,afii10107",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10092,afii10094,afii10106,afii10107",
    g2: "afii10058,afii10029",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10092,afii10094,afii10106,afii10107",
    g2: "afii10053,afii10032,afii10035,uni04AA,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10092,afii10094,afii10106,afii10107",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10092,afii10094,afii10106,afii10107",
    g2: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10092,afii10094,afii10106,afii10107",
    g2: "afii10099,afii10108,uni04BB",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10092,afii10094,afii10106,afii10107",
    g2: "afii10067,afii10068,afii10074,afii10075,afii10076,afii10079,afii10081,afii10088,afii10090,afii10091,afii10093,afii10094,afii10096,afii10100,afii10103,afii10104,afii10107,afii10109,afii10193,afii10098,uni0493,uni04A3,uni04C8,uni04F9,afii10074.var.accented,afii10093.var.accented,afii10096.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10060,uni04BA",
    g2: "afii10051,afii10060,afii10036",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10060,uni04BA",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 37
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuturaCyrillicBold);
export default __webpack_public_path__ + "static/media/FuturaCyrillicBold.829b0c7bfc8670363d2cc10feea49116.svg";
export { ForwardRef as ReactComponent };